import { TInvoices } from '../../api/APITypes';

export const MOCK_INVOICES: TInvoices = [
  {
    id: 1,
    customer_id: 21,
    customer_name: 'Jack Cook',
    date: '2020-06-22',
    invoice_lines: [
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 80,
        total_line: 1184,
        total_margin: 63.2,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 83,
        total_line: 1986.19,
        total_margin: 102.09,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 77,
        total_line: 3812.27,
        total_margin: 290.29,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 9,
        total_line: 194.4,
        total_margin: 36.99,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 69,
        total_line: 657.5699999999999,
        total_margin: 63.480000000000004,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 29,
        total_line: 398.75,
        total_margin: 53.07,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 17,
        total_line: 298.85999999999996,
        total_margin: 49.47,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 137,
        total_line: 6064.990000000001,
        total_margin: 228.79,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 87,
        total_line: 1445.07,
        total_margin: 180.08999999999997,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 77,
        total_line: 3687.53,
        total_margin: 612.15,
      },
    ],
    total_invoice: 19729.63,
    total_margin: 1679.62,
    region: 'Australia',
  },
  {
    id: 2,
    customer_id: 7,
    customer_name: 'Jean Cook',
    date: '2020-03-05',
    invoice_lines: [
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 83,
        total_line: 1217.61,
        total_margin: 183.43,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 54,
        total_line: 1292.22,
        total_margin: 66.42,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 60,
        total_line: 2282.4,
        total_margin: 410.4,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 38,
        total_line: 680.58,
        total_margin: 70.68,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 50,
        total_line: 1713.5000000000002,
        total_margin: 224.5,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 15,
        total_line: 324,
        total_margin: 61.650000000000006,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 85,
        total_line: 1547,
        total_margin: 43.35,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 29,
        total_line: 509.81999999999994,
        total_margin: 84.39,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 78,
        total_line: 1407.12,
        total_margin: 223.07999999999998,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 43,
        total_line: 1345.47,
        total_margin: 276.92,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 148,
        total_line: 476.56,
        total_margin: 38.480000000000004,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 140,
        total_line: 5371.799999999999,
        total_margin: 469,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 53,
        total_line: 1117.24,
        total_margin: 13.780000000000001,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 71,
        total_line: 584.33,
        total_margin: 29.11,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 47,
        total_line: 447.90999999999997,
        total_margin: 43.24,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 148,
        total_line: 7087.72,
        total_margin: 1176.6000000000001,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 99,
        total_line: 2940.2999999999997,
        total_margin: 82.17,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 9,
        total_line: 253.44,
        total_margin: 10.53,
      },
    ],
    total_invoice: 30599.02,
    total_margin: 3507.730000000001,
    region: 'Australia',
  },
  {
    id: 3,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-05-16',
    invoice_lines: [
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 77,
        total_line: 849.31,
        total_margin: 72.38,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 111,
        total_line: 3771.7799999999997,
        total_margin: 808.08,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 7,
        total_line: 60.76,
        total_margin: 5.04,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 21,
        total_line: 572.67,
        total_margin: 137.76,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 76,
        total_line: 2903.96,
        total_margin: 671.08,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 135,
        total_line: 552.15,
        total_margin: 102.6,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 31,
        total_line: 1062.99,
        total_margin: 194.68,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 145,
        total_line: 1381.85,
        total_margin: 133.4,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 53,
        total_line: 2016.12,
        total_margin: 362.52,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 18,
        total_line: 601.5600000000001,
        total_margin: 72.35999999999999,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 111,
        total_line: 3296.7,
        total_margin: 92.13,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 47,
        total_line: 2278.09,
        total_margin: 433.81,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 19,
        total_line: 281.2,
        total_margin: 15.010000000000002,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 95,
        total_line: 1880.05,
        total_margin: 228.95000000000002,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 128,
        total_line: 3445.76,
        total_margin: 837.12,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 128,
        total_line: 4386.56,
        total_margin: 574.72,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 6,
        total_line: 99.66,
        total_margin: 12.419999999999998,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 32,
        total_line: 1399.36,
        total_margin: 320.32,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 11,
        total_line: 344.19,
        total_margin: 70.84,
      },
    ],
    total_invoice: 31184.719999999998,
    total_margin: 5145.22,
    region: 'Brazil',
  },
  {
    id: 4,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-10-31',
    invoice_lines: [
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 17,
        total_line: 209.27,
        total_margin: 43.52,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 116,
        total_line: 2111.2,
        total_margin: 59.160000000000004,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 16,
        total_line: 286.56,
        total_margin: 29.76,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 74,
        total_line: 1425.24,
        total_margin: 189.44,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 115,
        total_line: 1687.05,
        total_margin: 254.15,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 43,
        total_line: 713.8000000000001,
        total_margin: 17.2,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 94,
        total_line: 3591.7400000000002,
        total_margin: 830.02,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 132,
        total_line: 3148.2000000000003,
        total_margin: 757.6800000000001,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 115,
        total_line: 4146.900000000001,
        total_margin: 472.65000000000003,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 132,
        total_line: 6398.04,
        total_margin: 1218.3600000000001,
      },
    ],
    total_invoice: 23718.000000000004,
    total_margin: 3871.9400000000005,
    region: 'Australia',
  },
  {
    id: 5,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-07-12',
    invoice_lines: [
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 96,
        total_line: 4752.96,
        total_margin: 361.92,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 21,
        total_line: 565.32,
        total_margin: 137.34,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 15,
        total_line: 422.4,
        total_margin: 17.549999999999997,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 2,
        total_line: 68.54,
        total_margin: 8.98,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 29,
        total_line: 527.8,
        total_margin: 14.790000000000001,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 33,
        total_line: 1260.93,
        total_margin: 291.39,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 22,
        total_line: 599.9399999999999,
        total_margin: 144.32,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 61,
        total_line: 1012.6000000000001,
        total_margin: 24.400000000000002,
      },
    ],
    total_invoice: 9210.49,
    total_margin: 1000.6899999999999,
    region: 'Brazil',
  },
  {
    id: 6,
    customer_id: 12,
    customer_name: 'Trisha Wu',
    date: '2020-09-23',
    invoice_lines: [
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 12,
        total_line: 411.24,
        total_margin: 53.88,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 39,
        total_line: 751.1400000000001,
        total_margin: 99.84,
      },
    ],
    total_invoice: 1162.38,
    total_margin: 153.72,
    region: 'Europe',
  },
  {
    id: 7,
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    date: '2020-06-10',
    invoice_lines: [
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 16,
        total_line: 345.6,
        total_margin: 65.76,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 32,
        total_line: 1009.28,
        total_margin: 21.12,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 30,
        total_line: 1140.9,
        total_margin: 45.9,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 62,
        total_line: 1194.1200000000001,
        total_margin: 158.72,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 83,
        total_line: 915.4899999999999,
        total_margin: 78.02,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 16,
        total_line: 611.36,
        total_margin: 141.28,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 4,
        total_line: 95.4,
        total_margin: 22.96,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 97,
        total_line: 1765.3999999999999,
        total_margin: 49.47,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 5,
        total_line: 60.099999999999994,
        total_margin: 11.65,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 13,
        total_line: 123.88999999999999,
        total_margin: 11.96,
      },
    ],
    total_invoice: 7261.54,
    total_margin: 606.84,
    region: 'Europe',
  },
  {
    id: 8,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-09-18',
    invoice_lines: [
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 142,
        total_line: 6209.66,
        total_margin: 1421.42,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 25,
        total_line: 782.25,
        total_margin: 161,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 74,
        total_line: 1085.58,
        total_margin: 163.54,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 37,
        total_line: 614.2,
        total_margin: 14.8,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 147,
        total_line: 2675.4,
        total_margin: 74.97,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 9,
        total_line: 158.21999999999997,
        total_margin: 26.19,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 133,
        total_line: 2872.8,
        total_margin: 546.63,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 22,
        total_line: 1089.22,
        total_margin: 82.94,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 39,
        total_line: 1726.5300000000002,
        total_margin: 65.13,
      },
    ],
    total_invoice: 17213.86,
    total_margin: 2556.6200000000003,
    region: 'Brazil',
  },
  {
    id: 9,
    customer_id: 28,
    customer_name: 'Allan Cook',
    date: '2020-12-14',
    invoice_lines: [
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 114,
        total_line: 4985.219999999999,
        total_margin: 1141.1399999999999,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 65,
        total_line: 3112.85,
        total_margin: 516.75,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 135,
        total_line: 3634.2000000000003,
        total_margin: 882.9,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 91,
        total_line: 748.9300000000001,
        total_margin: 37.309999999999995,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 70,
        total_line: 1675.1,
        total_margin: 86.1,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 96,
        total_line: 1978.56,
        total_margin: 179.52,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 59,
        total_line: 666.7,
        total_margin: 162.25,
      },
    ],
    total_invoice: 16801.56,
    total_margin: 3005.97,
    region: 'Brazil',
  },
  {
    id: 10,
    customer_id: 7,
    customer_name: 'Jean Cook',
    date: '2020-07-29',
    invoice_lines: [
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 32,
        total_line: 1216.96,
        total_margin: 48.96,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 47,
        total_line: 780.2,
        total_margin: 18.8,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 24,
        total_line: 208.32,
        total_margin: 17.28,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 33,
        total_line: 453.75,
        total_margin: 60.39,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 92,
        total_line: 1659.6799999999998,
        total_margin: 263.12,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 20,
        total_line: 220.6,
        total_margin: 18.799999999999997,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 69,
        total_line: 657.5699999999999,
        total_margin: 63.480000000000004,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 20,
        total_line: 432,
        total_margin: 82.2,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 4,
        total_line: 82.44,
        total_margin: 7.48,
      },
    ],
    total_invoice: 5711.5199999999995,
    total_margin: 580.5100000000001,
    region: 'India',
  },
  {
    id: 11,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-05-05',
    invoice_lines: [
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 107,
        total_line: 3575.94,
        total_margin: 430.13999999999993,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 77,
        total_line: 1623.1599999999999,
        total_margin: 20.02,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 70,
        total_line: 225.4,
        total_margin: 18.2,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 130,
        total_line: 4455.1,
        total_margin: 583.7,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 146,
        total_line: 5006.34,
        total_margin: 916.88,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 84,
        total_line: 2261.28,
        total_margin: 549.36,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 14,
        total_line: 252.56,
        total_margin: 40.04,
      },
    ],
    total_invoice: 17399.780000000002,
    total_margin: 2558.34,
    region: 'Australia',
  },
  {
    id: 12,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-10-13',
    invoice_lines: [
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 31,
        total_line: 381.61,
        total_margin: 79.36,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 59,
        total_line: 2671.52,
        total_margin: 265.5,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 99,
        total_line: 1785.9599999999998,
        total_margin: 283.14,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 90,
        total_line: 1471.5000000000002,
        total_margin: 87.3,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 10,
        total_line: 442.70000000000005,
        total_margin: 16.7,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 137,
        total_line: 4655.259999999999,
        total_margin: 997.36,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 85,
        total_line: 3717.0499999999997,
        total_margin: 850.85,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 43,
        total_line: 636.4,
        total_margin: 33.97,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 27,
        total_line: 801.9,
        total_margin: 22.41,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 99,
        total_line: 3782.79,
        total_margin: 874.17,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 93,
        total_line: 1117.86,
        total_margin: 216.69,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 138,
        total_line: 1197.84,
        total_margin: 99.36,
      },
    ],
    total_invoice: 22662.39,
    total_margin: 3826.81,
    region: 'Europe',
  },
  {
    id: 13,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-05-30',
    invoice_lines: [
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 111,
        total_line: 4002.6600000000003,
        total_margin: 456.21000000000004,
      },
    ],
    total_invoice: 4002.6600000000003,
    total_margin: 456.21000000000004,
    region: 'Brazil',
  },
  {
    id: 14,
    customer_id: 39,
    customer_name: 'John Del Piero',
    date: '2020-12-12',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 2,
        total_line: 88.54,
        total_margin: 3.34,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 62,
        total_line: 2358.48,
        total_margin: 424.08,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 126,
        total_line: 4281.48,
        total_margin: 917.2800000000001,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 76,
        total_line: 2257.2,
        total_margin: 63.08,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 28,
        total_line: 316.40000000000003,
        total_margin: 77,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 46,
        total_line: 2229.62,
        total_margin: 424.58000000000004,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 42,
        total_line: 697.2,
        total_margin: 16.8,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 44,
        total_line: 1470.48,
        total_margin: 176.88,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 92,
        total_line: 1617.36,
        total_margin: 267.72,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 36,
        total_line: 432.71999999999997,
        total_margin: 83.88,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 123,
        total_line: 1820.4,
        total_margin: 97.17,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 81,
        total_line: 666.63,
        total_margin: 33.21,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 147,
        total_line: 2909.1299999999997,
        total_margin: 354.27000000000004,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 111,
        total_line: 2988.1200000000003,
        total_margin: 725.94,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 105,
        total_line: 1911,
        total_margin: 53.550000000000004,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 131,
        total_line: 2829.6000000000004,
        total_margin: 538.4100000000001,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 6,
        total_line: 88.02,
        total_margin: 13.26,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 99,
        total_line: 4741.11,
        total_margin: 787.0500000000001,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 67,
        total_line: 2416.02,
        total_margin: 275.37,
      },
    ],
    total_invoice: 36119.509999999995,
    total_margin: 5332.870000000001,
    region: 'Australia',
  },
  {
    id: 15,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-12-08',
    invoice_lines: [
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 67,
        total_line: 1886.72,
        total_margin: 78.39,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 25,
        total_line: 217,
        total_margin: 18,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 130,
        total_line: 3861,
        total_margin: 107.89999999999999,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 138,
        total_line: 2426.04,
        total_margin: 401.58000000000004,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 38,
        total_line: 1198.52,
        total_margin: 25.080000000000002,
      },
    ],
    total_invoice: 9589.28,
    total_margin: 630.95,
    region: 'Brazil',
  },
  {
    id: 16,
    customer_id: 7,
    customer_name: 'Jean Cook',
    date: '2020-05-14',
    invoice_lines: [
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 47,
        total_line: 564.9399999999999,
        total_margin: 109.51,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 98,
        total_line: 2019.78,
        total_margin: 183.26000000000002,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 67,
        total_line: 2296.09,
        total_margin: 300.83000000000004,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 121,
        total_line: 1663.75,
        total_margin: 221.43,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 44,
        total_line: 1184.48,
        total_margin: 287.76,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 90,
        total_line: 4362.3,
        total_margin: 830.7,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 64,
        total_line: 2897.92,
        total_margin: 288,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 133,
        total_line: 5081.93,
        total_margin: 1174.39,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 77,
        total_line: 947.87,
        total_margin: 197.12,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 92,
        total_line: 3154.68,
        total_margin: 577.76,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 75,
        total_line: 2346.75,
        total_margin: 483.00000000000006,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 35,
        total_line: 837.55,
        total_margin: 43.05,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 60,
        total_line: 981.0000000000001,
        total_margin: 58.199999999999996,
      },
    ],
    total_invoice: 28339.04,
    total_margin: 4755.01,
    region: 'India',
  },
  {
    id: 17,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-11-14',
    invoice_lines: [
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 103,
        total_line: 5099.53,
        total_margin: 388.31,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 6,
        total_line: 72.12,
        total_margin: 13.98,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 70,
        total_line: 286.3,
        total_margin: 53.2,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 143,
        total_line: 6330.610000000001,
        total_margin: 238.81,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 125,
        total_line: 2197.5,
        total_margin: 363.75,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 124,
        total_line: 1561.16,
        total_margin: 57.04,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 58,
        total_line: 2206.32,
        total_margin: 396.71999999999997,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 144,
        total_line: 4934.88,
        total_margin: 646.5600000000001,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 7,
        total_line: 134.82000000000002,
        total_margin: 17.92,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 75,
        total_line: 2571.75,
        total_margin: 471,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 25,
        total_line: 73.5,
        total_margin: 17,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 136,
        total_line: 3829.76,
        total_margin: 159.12,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 132,
        total_line: 4163.28,
        total_margin: 87.12,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 3,
        total_line: 33.089999999999996,
        total_margin: 2.82,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 76,
        total_line: 1641.6000000000001,
        total_margin: 312.36,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 129,
        total_line: 1773.75,
        total_margin: 236.07000000000002,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 77,
        total_line: 2072.84,
        total_margin: 503.58,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 10,
        total_line: 238.5,
        total_margin: 57.400000000000006,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 134,
        total_line: 3979.7999999999997,
        total_margin: 111.22,
      },
    ],
    total_invoice: 43201.11,
    total_margin: 4133.9800000000005,
    region: 'Europe',
  },
  {
    id: 18,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-02-06',
    invoice_lines: [
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 111,
        total_line: 913.5300000000001,
        total_margin: 45.51,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 67,
        total_line: 274.03,
        total_margin: 50.92,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 145,
        total_line: 2370.75,
        total_margin: 140.65,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 81,
        total_line: 915.3000000000001,
        total_margin: 222.75,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 56,
        total_line: 828.8000000000001,
        total_margin: 44.24,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 98,
        total_line: 866.3199999999999,
        total_margin: 158.76000000000002,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 21,
        total_line: 369.17999999999995,
        total_margin: 61.11,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 24,
        total_line: 474.96,
        total_margin: 57.84,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 97,
        total_line: 3721.89,
        total_margin: 324.95,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 141,
        total_line: 2906.0099999999998,
        total_margin: 263.67,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 83,
        total_line: 2465.1,
        total_margin: 68.89,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 148,
        total_line: 4667.92,
        total_margin: 97.68,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 52,
        total_line: 654.68,
        total_margin: 23.92,
      },
    ],
    total_invoice: 21428.47,
    total_margin: 1560.8900000000003,
    region: 'Brazil',
  },
  {
    id: 19,
    customer_id: 32,
    customer_name: 'John Muijs',
    date: '2020-01-03',
    invoice_lines: [
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 86,
        total_line: 3299.8199999999997,
        total_margin: 288.1,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 147,
        total_line: 2632.77,
        total_margin: 273.42,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 111,
        total_line: 4854.03,
        total_margin: 1111.11,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 16,
        total_line: 337.28,
        total_margin: 4.16,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 41,
        total_line: 739.64,
        total_margin: 117.25999999999999,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 66,
        total_line: 745.8000000000001,
        total_margin: 181.5,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 100,
        total_line: 1467,
        total_margin: 221,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 75,
        total_line: 1484.25,
        total_margin: 180.75,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 13,
        total_line: 280.8,
        total_margin: 53.43000000000001,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 133,
        total_line: 1267.49,
        total_margin: 122.36,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 104,
        total_line: 3956.16,
        total_margin: 711.36,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 129,
        total_line: 2267.8199999999997,
        total_margin: 375.39000000000004,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 130,
        total_line: 1600.3,
        total_margin: 332.8,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 5,
        total_line: 83.05,
        total_margin: 10.35,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 41,
        total_line: 167.69,
        total_margin: 31.16,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 30,
        total_line: 96.60000000000001,
        total_margin: 7.800000000000001,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 2,
        total_line: 96.94,
        total_margin: 18.46,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 82,
        total_line: 1955.7,
        total_margin: 470.68,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 84,
        total_line: 926.52,
        total_margin: 78.96,
      },
    ],
    total_invoice: 28259.659999999993,
    total_margin: 4590.05,
    region: 'Brazil',
  },
  {
    id: 20,
    customer_id: 30,
    customer_name: 'Jean Castex',
    date: '2020-05-09',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 116,
        total_line: 5135.320000000001,
        total_margin: 193.72,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 86,
        total_line: 3760.7799999999997,
        total_margin: 860.86,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 20,
        total_line: 190.6,
        total_margin: 18.400000000000002,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 49,
        total_line: 200.41,
        total_margin: 37.24,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 108,
        total_line: 2137.3199999999997,
        total_margin: 260.28000000000003,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 94,
        total_line: 1937.34,
        total_margin: 175.78,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 135,
        total_line: 1193.4,
        total_margin: 218.70000000000002,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 99,
        total_line: 2361.15,
        total_margin: 568.26,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 148,
        total_line: 435.12,
        total_margin: 100.64,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 27,
        total_line: 297.81,
        total_margin: 25.38,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 92,
        total_line: 2508.84,
        total_margin: 603.52,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 51,
        total_line: 754.8000000000001,
        total_margin: 40.29,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 76,
        total_line: 1114.92,
        total_margin: 167.96,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 98,
        total_line: 3360.42,
        total_margin: 615.44,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 21,
        total_line: 719.6700000000001,
        total_margin: 94.29,
      },
    ],
    total_invoice: 26107.899999999994,
    total_margin: 3980.7599999999998,
    region: 'India',
  },
  {
    id: 21,
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    date: '2020-08-15',
    invoice_lines: [
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 131,
        total_line: 6485.8099999999995,
        total_margin: 493.87,
      },
    ],
    total_invoice: 6485.8099999999995,
    total_margin: 493.87,
    region: 'India',
  },
  {
    id: 22,
    customer_id: 27,
    customer_name: 'Daniels Jackson',
    date: '2020-11-23',
    invoice_lines: [
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 55,
        total_line: 177.10000000000002,
        total_margin: 14.3,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 130,
        total_line: 4988.099999999999,
        total_margin: 435.5,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 26,
        total_line: 76.44,
        total_margin: 17.68,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 60,
        total_line: 1082.3999999999999,
        total_margin: 171.6,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 46,
        total_line: 1576.42,
        total_margin: 206.54000000000002,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 17,
        total_line: 463.59,
        total_margin: 111.52,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 124,
        total_line: 4716.96,
        total_margin: 848.16,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 32,
        total_line: 130.88,
        total_margin: 24.32,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 66,
        total_line: 1201.2,
        total_margin: 33.660000000000004,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 25,
        total_line: 901.5,
        total_margin: 102.75000000000001,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 90,
        total_line: 2534.4,
        total_margin: 105.3,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 111,
        total_line: 4221.33,
        total_margin: 169.83,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 45,
        total_line: 972.0000000000001,
        total_margin: 184.95000000000002,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 30,
        total_line: 1311.8999999999999,
        total_margin: 300.3,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 100,
        total_line: 2108,
        total_margin: 26,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 59,
        total_line: 709.18,
        total_margin: 137.47,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 92,
        total_line: 4072.84,
        total_margin: 153.64,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 60,
        total_line: 1782,
        total_margin: 49.8,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 132,
        total_line: 2158.2000000000003,
        total_margin: 128.04,
      },
    ],
    total_invoice: 35184.44,
    total_margin: 3221.36,
    region: 'India',
  },
  {
    id: 23,
    customer_id: 16,
    customer_name: 'Greg Muijs',
    date: '2020-06-08',
    invoice_lines: [
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 46,
        total_line: 1450.84,
        total_margin: 30.360000000000003,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 63,
        total_line: 556.92,
        total_margin: 102.06,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 93,
        total_line: 1665.63,
        total_margin: 172.98000000000002,
      },
    ],
    total_invoice: 3673.39,
    total_margin: 305.40000000000003,
    region: 'Europe',
  },
  {
    id: 24,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-10-08',
    invoice_lines: [
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 45,
        total_line: 1726.6499999999999,
        total_margin: 150.75,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 101,
        total_line: 3859.21,
        total_margin: 891.83,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 46,
        total_line: 2011.58,
        total_margin: 460.46,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 31,
        total_line: 969.99,
        total_margin: 199.64000000000001,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 78,
        total_line: 860.3399999999999,
        total_margin: 73.32,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 145,
        total_line: 6419.150000000001,
        total_margin: 242.14999999999998,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 26,
        total_line: 937.5600000000001,
        total_margin: 106.86000000000001,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 41,
        total_line: 120.53999999999999,
        total_margin: 27.880000000000003,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 102,
        total_line: 3408.84,
        total_margin: 410.03999999999996,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 122,
        total_line: 2571.7599999999998,
        total_margin: 31.720000000000002,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 74,
        total_line: 836.2,
        total_margin: 203.5,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 32,
        total_line: 1009.28,
        total_margin: 21.12,
      },
    ],
    total_invoice: 24731.100000000002,
    total_margin: 2819.27,
    region: 'USA',
  },
  {
    id: 25,
    customer_id: 38,
    customer_name: 'Mike Muijs',
    date: '2020-04-09',
    invoice_lines: [
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 41,
        total_line: 492.82,
        total_margin: 95.53,
      },
    ],
    total_invoice: 492.82,
    total_margin: 95.53,
    region: 'USA',
  },
  {
    id: 26,
    customer_id: 37,
    customer_name: 'John Wu',
    date: '2020-07-29',
    invoice_lines: [
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 25,
        total_line: 951,
        total_margin: 171,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 74,
        total_line: 3543.86,
        total_margin: 588.3000000000001,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 12,
        total_line: 38.64,
        total_margin: 3.12,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 57,
        total_line: 1936.86,
        total_margin: 414.96000000000004,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 142,
        total_line: 5425.82,
        total_margin: 1253.86,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 135,
        total_line: 1286.55,
        total_margin: 124.2,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 67,
        total_line: 1597.95,
        total_margin: 384.58000000000004,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 67,
        total_line: 2113.18,
        total_margin: 44.22,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 67,
        total_line: 2239.1400000000003,
        total_margin: 269.34,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 103,
        total_line: 847.69,
        total_margin: 42.23,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 79,
        total_line: 1312.19,
        total_margin: 163.53,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 149,
        total_line: 1834.19,
        total_margin: 381.44,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 87,
        total_line: 1879.2,
        total_margin: 357.57000000000005,
      },
    ],
    total_invoice: 25006.269999999997,
    total_margin: 4198.349999999999,
    region: 'USA',
  },
  {
    id: 27,
    customer_id: 18,
    customer_name: 'Jack Wu',
    date: '2020-11-08',
    invoice_lines: [
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 84,
        total_line: 2649.36,
        total_margin: 55.440000000000005,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 2,
        total_line: 76.08,
        total_margin: 13.68,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 140,
        total_line: 3350.2,
        total_margin: 172.2,
      },
    ],
    total_invoice: 6075.639999999999,
    total_margin: 241.32,
    region: 'Australia',
  },
  {
    id: 28,
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    date: '2020-09-24',
    invoice_lines: [
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 51,
        total_line: 1216.3500000000001,
        total_margin: 292.74,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 132,
        total_line: 4163.28,
        total_margin: 87.12,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 140,
        total_line: 6704.6,
        total_margin: 1113,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 128,
        total_line: 1219.84,
        total_margin: 117.76,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 75,
        total_line: 1484.25,
        total_margin: 180.75,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 10,
        total_line: 206.1,
        total_margin: 18.700000000000003,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 31,
        total_line: 544.9799999999999,
        total_margin: 90.21000000000001,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 113,
        total_line: 4317.7300000000005,
        total_margin: 997.79,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 142,
        total_line: 1952.5,
        total_margin: 259.86,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 69,
        total_line: 1145.4,
        total_margin: 27.6,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 132,
        total_line: 5976.96,
        total_margin: 594,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 92,
        total_line: 1771.92,
        total_margin: 235.52,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 76,
        total_line: 1124.8,
        total_margin: 60.040000000000006,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 15,
        total_line: 61.349999999999994,
        total_margin: 11.4,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 31,
        total_line: 1534.81,
        total_margin: 116.87,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 83,
        total_line: 244.01999999999998,
        total_margin: 56.440000000000005,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 50,
        total_line: 1803,
        total_margin: 205.50000000000003,
      },
    ],
    total_invoice: 35471.89,
    total_margin: 4465.3,
    region: 'Europe',
  },
  {
    id: 29,
    customer_id: 37,
    customer_name: 'John Wu',
    date: '2020-08-19',
    invoice_lines: [
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 4,
        total_line: 137.16,
        total_margin: 25.12,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 77,
        total_line: 1401.3999999999999,
        total_margin: 39.27,
      },
    ],
    total_invoice: 1538.56,
    total_margin: 64.39,
    region: 'USA',
  },
  {
    id: 30,
    customer_id: 38,
    customer_name: 'Mike Muijs',
    date: '2020-01-20',
    invoice_lines: [
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 46,
        total_line: 148.12,
        total_margin: 11.96,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 88,
        total_line: 1461.6799999999998,
        total_margin: 182.16,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 12,
        total_line: 135.60000000000002,
        total_margin: 33,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 39,
        total_line: 930.1500000000001,
        total_margin: 223.86,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 18,
        total_line: 324.71999999999997,
        total_margin: 51.48,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 13,
        total_line: 496.73,
        total_margin: 114.79,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 99,
        total_line: 3122.46,
        total_margin: 65.34,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 79,
        total_line: 752.87,
        total_margin: 72.68,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 44,
        total_line: 870.76,
        total_margin: 106.04,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 51,
        total_line: 642.09,
        total_margin: 23.46,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 8,
        total_line: 130.8,
        total_margin: 7.76,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 29,
        total_line: 611.3199999999999,
        total_margin: 7.54,
      },
    ],
    total_invoice: 9627.299999999997,
    total_margin: 900.0699999999999,
    region: 'USA',
  },
  {
    id: 31,
    customer_id: 37,
    customer_name: 'John Wu',
    date: '2020-09-18',
    invoice_lines: [
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 47,
        total_line: 1281.69,
        total_margin: 308.32,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 100,
        total_line: 1259,
        total_margin: 46,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 111,
        total_line: 3125.76,
        total_margin: 129.87,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 121,
        total_line: 1978.3500000000001,
        total_margin: 117.36999999999999,
      },
    ],
    total_invoice: 7644.800000000001,
    total_margin: 601.56,
    region: 'Europe',
  },
  {
    id: 32,
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    date: '2020-08-21',
    invoice_lines: [
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 120,
        total_line: 4077.5999999999995,
        total_margin: 873.6,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 39,
        total_line: 1483.17,
        total_margin: 59.67,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 53,
        total_line: 1048.87,
        total_margin: 127.73,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 63,
        total_line: 932.4000000000001,
        total_margin: 49.77,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 139,
        total_line: 2307.4,
        total_margin: 55.6,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 50,
        total_line: 147,
        total_margin: 34,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 87,
        total_line: 2342.04,
        total_margin: 568.98,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 94,
        total_line: 1036.82,
        total_margin: 88.36,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 95,
        total_line: 1577.95,
        total_margin: 196.64999999999998,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 148,
        total_line: 4035.96,
        total_margin: 970.88,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 63,
        total_line: 1213.38,
        total_margin: 161.28,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 45,
        total_line: 1543.05,
        total_margin: 282.6,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 46,
        total_line: 2277.46,
        total_margin: 173.42,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 78,
        total_line: 2460.12,
        total_margin: 51.480000000000004,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 105,
        total_line: 3994.2,
        total_margin: 718.1999999999999,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 63,
        total_line: 1298.43,
        total_margin: 117.81,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 90,
        total_line: 3084.3,
        total_margin: 404.1,
      },
    ],
    total_invoice: 34860.15,
    total_margin: 4934.130000000001,
    region: 'USA',
  },
  {
    id: 33,
    customer_id: 10,
    customer_name: 'Daniels van Dijk',
    date: '2020-07-17',
    invoice_lines: [
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 119,
        total_line: 4291.14,
        total_margin: 489.09000000000003,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 85,
        total_line: 1021.6999999999999,
        total_margin: 198.05,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 53,
        total_line: 1264.0500000000002,
        total_margin: 304.22,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 108,
        total_line: 1485,
        total_margin: 197.64000000000001,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 121,
        total_line: 3299.67,
        total_margin: 793.76,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 7,
        total_line: 20.58,
        total_margin: 4.760000000000001,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 116,
        total_line: 1926.76,
        total_margin: 240.11999999999998,
      },
    ],
    total_invoice: 13308.900000000001,
    total_margin: 2227.6400000000003,
    region: 'India',
  },
  {
    id: 34,
    customer_id: 30,
    customer_name: 'Jean Castex',
    date: '2020-09-26',
    invoice_lines: [
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 44,
        total_line: 651.2,
        total_margin: 34.760000000000005,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 94,
        total_line: 4653.94,
        total_margin: 354.38,
      },
    ],
    total_invoice: 5305.139999999999,
    total_margin: 389.14,
    region: 'USA',
  },
  {
    id: 35,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-07-26',
    invoice_lines: [
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 77,
        total_line: 1353.6599999999999,
        total_margin: 224.07000000000002,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 66,
        total_line: 812.46,
        total_margin: 168.96,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 134,
        total_line: 431.48,
        total_margin: 34.84,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 86,
        total_line: 1182.5,
        total_margin: 157.38,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 147,
        total_line: 5040.63,
        total_margin: 923.1600000000001,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 29,
        total_line: 276.37,
        total_margin: 26.68,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 75,
        total_line: 3320.2500000000005,
        total_margin: 125.25,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 110,
        total_line: 1243,
        total_margin: 302.5,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 44,
        total_line: 1184.48,
        total_margin: 287.76,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 78,
        total_line: 860.3399999999999,
        total_margin: 73.32,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 87,
        total_line: 2372.49,
        total_margin: 570.7199999999999,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 109,
        total_line: 4146.36,
        total_margin: 745.56,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 138,
        total_line: 4976.280000000001,
        total_margin: 567.1800000000001,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 78,
        total_line: 2966.34,
        total_margin: 119.34,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 132,
        total_line: 539.88,
        total_margin: 100.32000000000001,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 21,
        total_line: 701.82,
        total_margin: 84.41999999999999,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 47,
        total_line: 415.48,
        total_margin: 76.14,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 68,
        total_line: 997.56,
        total_margin: 150.28,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 118,
        total_line: 5343.04,
        total_margin: 531,
      },
    ],
    total_invoice: 38164.420000000006,
    total_margin: 5268.88,
    region: 'India',
  },
  {
    id: 36,
    customer_id: 28,
    customer_name: 'Allan Cook',
    date: '2020-01-15',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 127,
        total_line: 5622.29,
        total_margin: 212.09,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 137,
        total_line: 6640.389999999999,
        total_margin: 1264.51,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 105,
        total_line: 2826.6000000000004,
        total_margin: 686.7,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 50,
        total_line: 1080,
        total_margin: 205.50000000000003,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 43,
        total_line: 1643.03,
        total_margin: 379.69,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 39,
        total_line: 1337.31,
        total_margin: 244.92000000000002,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 40,
        total_line: 716.4,
        total_margin: 74.4,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 76,
        total_line: 2397.04,
        total_margin: 50.160000000000004,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 83,
        total_line: 1710.6299999999999,
        total_margin: 155.21,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 73,
        total_line: 1741.0500000000002,
        total_margin: 419.02000000000004,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 13,
        total_line: 311.09,
        total_margin: 15.99,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 90,
        total_line: 795.6,
        total_margin: 145.8,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 55,
        total_line: 606.65,
        total_margin: 51.699999999999996,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 74,
        total_line: 3663.74,
        total_margin: 278.98,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 13,
        total_line: 468.78000000000003,
        total_margin: 53.43000000000001,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 35,
        total_line: 637,
        total_margin: 17.85,
      },
    ],
    total_invoice: 32197.600000000006,
    total_margin: 4255.950000000001,
    region: 'Europe',
  },
  {
    id: 37,
    customer_id: 10,
    customer_name: 'Daniels van Dijk',
    date: '2020-12-13',
    invoice_lines: [
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 87,
        total_line: 1675.6200000000001,
        total_margin: 222.72,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 134,
        total_line: 5096.02,
        total_margin: 205.02,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 113,
        total_line: 3535.77,
        total_margin: 727.72,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 93,
        total_line: 1692.6,
        total_margin: 47.43,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 100,
        total_line: 1979,
        total_margin: 241,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 89,
        total_line: 4406.389999999999,
        total_margin: 335.53000000000003,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 62,
        total_line: 182.28,
        total_margin: 42.160000000000004,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 62,
        total_line: 2711.2599999999998,
        total_margin: 620.62,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 28,
        total_line: 266.84,
        total_margin: 25.76,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 131,
        total_line: 6273.59,
        total_margin: 1041.45,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 128,
        total_line: 2309.12,
        total_margin: 366.08,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 112,
        total_line: 4038.7200000000003,
        total_margin: 460.32000000000005,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 124,
        total_line: 2613.9199999999996,
        total_margin: 32.24,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 78,
        total_line: 2316.6,
        total_margin: 64.74,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 30,
        total_line: 412.5,
        total_margin: 54.900000000000006,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 110,
        total_line: 2623.5,
        total_margin: 631.4,
      },
    ],
    total_invoice: 42133.729999999996,
    total_margin: 5119.089999999999,
    region: 'USA',
  },
  {
    id: 38,
    customer_id: 11,
    customer_name: 'Jean Martins',
    date: '2020-07-02',
    invoice_lines: [
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 14,
        total_line: 269.64000000000004,
        total_margin: 35.84,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 108,
        total_line: 1191.24,
        total_margin: 101.52,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 12,
        total_line: 337.92,
        total_margin: 14.04,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 103,
        total_line: 1416.25,
        total_margin: 188.49,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 112,
        total_line: 5428.639999999999,
        total_margin: 1033.76,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 134,
        total_line: 2824.72,
        total_margin: 34.84,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 78,
        total_line: 982.02,
        total_margin: 35.88,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 148,
        total_line: 2650.68,
        total_margin: 275.28000000000003,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 18,
        total_line: 687.78,
        total_margin: 158.94,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 100,
        total_line: 3804,
        total_margin: 684,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 126,
        total_line: 1551.0600000000002,
        total_margin: 322.56,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 87,
        total_line: 3338.1899999999996,
        total_margin: 291.45,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 142,
        total_line: 6209.66,
        total_margin: 1421.42,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 47,
        total_line: 847.88,
        total_margin: 134.42,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 8,
        total_line: 130.8,
        total_margin: 7.76,
      },
    ],
    total_invoice: 31670.48,
    total_margin: 4740.200000000001,
    region: 'India',
  },
  {
    id: 39,
    customer_id: 20,
    customer_name: 'Magda Del Piero',
    date: '2020-02-28',
    invoice_lines: [
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 124,
        total_line: 1367.72,
        total_margin: 116.55999999999999,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 64,
        total_line: 1526.4,
        total_margin: 367.36,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 47,
        total_line: 564.9399999999999,
        total_margin: 109.51,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 98,
        total_line: 2672.46,
        total_margin: 642.88,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 123,
        total_line: 1820.4,
        total_margin: 97.17,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 27,
        total_line: 569.16,
        total_margin: 7.0200000000000005,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 131,
        total_line: 4491.99,
        total_margin: 822.6800000000001,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 139,
        total_line: 447.58000000000004,
        total_margin: 36.14,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 43,
        total_line: 1649.9099999999999,
        total_margin: 144.05,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 22,
        total_line: 394.02,
        total_margin: 40.92,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 31,
        total_line: 920.6999999999999,
        total_margin: 25.73,
      },
    ],
    total_invoice: 16425.28,
    total_margin: 2410.0200000000004,
    region: 'USA',
  },
  {
    id: 40,
    customer_id: 4,
    customer_name: 'Daniels Smith',
    date: '2020-12-11',
    invoice_lines: [
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 78,
        total_line: 1294.8000000000002,
        total_margin: 31.200000000000003,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 74,
        total_line: 1334.96,
        total_margin: 211.64,
      },
    ],
    total_invoice: 2629.76,
    total_margin: 242.83999999999997,
    region: 'USA',
  },
  {
    id: 41,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-05-12',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 8,
        total_line: 354.16,
        total_margin: 13.36,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 60,
        total_line: 738.6,
        total_margin: 153.6,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 58,
        total_line: 512.72,
        total_margin: 93.96000000000001,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 124,
        total_line: 5938.36,
        total_margin: 985.8000000000001,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 58,
        total_line: 1019.6399999999999,
        total_margin: 168.78,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 69,
        total_line: 2305.98,
        total_margin: 277.38,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 89,
        total_line: 2506.2400000000002,
        total_margin: 104.13,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 74,
        total_line: 302.65999999999997,
        total_margin: 56.24,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 10,
        total_line: 238.5,
        total_margin: 57.400000000000006,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 31,
        total_line: 1189.47,
        total_margin: 103.85000000000001,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 74,
        total_line: 1085.58,
        total_margin: 163.54,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 124,
        total_line: 2453.96,
        total_margin: 298.84000000000003,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 126,
        total_line: 6107.22,
        total_margin: 1162.98,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 11,
        total_line: 237.60000000000002,
        total_margin: 45.21,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 125,
        total_line: 2238.75,
        total_margin: 232.5,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 75,
        total_line: 827.25,
        total_margin: 70.5,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 26,
        total_line: 820.04,
        total_margin: 17.16,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 26,
        total_line: 431.86,
        total_margin: 53.81999999999999,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 101,
        total_line: 1214.02,
        total_margin: 235.33,
      },
    ],
    total_invoice: 30522.61,
    total_margin: 4294.380000000001,
    region: 'India',
  },
  {
    id: 42,
    customer_id: 8,
    customer_name: 'Tim Jackson',
    date: '2020-06-17',
    invoice_lines: [
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 27,
        total_line: 851.5799999999999,
        total_margin: 17.82,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 16,
        total_line: 236.8,
        total_margin: 12.64,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 98,
        total_line: 2116.8,
        total_margin: 402.78000000000003,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 93,
        total_line: 1791.18,
        total_margin: 238.08,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 106,
        total_line: 1457.5,
        total_margin: 193.98000000000002,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 34,
        total_line: 957.44,
        total_margin: 39.78,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 40,
        total_line: 721.5999999999999,
        total_margin: 114.39999999999999,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 30,
        total_line: 1454.1,
        total_margin: 276.90000000000003,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 70,
        total_line: 1230.6,
        total_margin: 203.70000000000002,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 86,
        total_line: 252.84,
        total_margin: 58.480000000000004,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 103,
        total_line: 2038.37,
        total_margin: 248.23000000000002,
      },
    ],
    total_invoice: 13108.810000000001,
    total_margin: 1806.7900000000002,
    region: 'India',
  },
  {
    id: 43,
    customer_id: 10,
    customer_name: 'Daniels van Dijk',
    date: '2020-09-25',
    invoice_lines: [
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 36,
        total_line: 858.6,
        total_margin: 206.64000000000001,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 6,
        total_line: 88.02,
        total_margin: 13.26,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 108,
        total_line: 5172.12,
        total_margin: 858.6,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 17,
        total_line: 277.95000000000005,
        total_margin: 16.49,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 110,
        total_line: 1933.7999999999997,
        total_margin: 320.1,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 109,
        total_line: 3410.61,
        total_margin: 701.96,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 91,
        total_line: 3041.2200000000003,
        total_margin: 365.81999999999994,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 129,
        total_line: 2310.39,
        total_margin: 239.94000000000003,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 32,
        total_line: 130.88,
        total_margin: 24.32,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 114,
        total_line: 1567.5,
        total_margin: 208.62,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 29,
        total_line: 93.38000000000001,
        total_margin: 7.54,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 141,
        total_line: 2566.2,
        total_margin: 71.91,
      },
    ],
    total_invoice: 21450.670000000002,
    total_margin: 3035.2,
    region: 'USA',
  },
  {
    id: 44,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-12-05',
    invoice_lines: [
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 82,
        total_line: 335.38,
        total_margin: 62.32,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 27,
        total_line: 1180.7099999999998,
        total_margin: 270.27,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 142,
        total_line: 5120.52,
        total_margin: 583.62,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 43,
        total_line: 755.9399999999999,
        total_margin: 125.13000000000001,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 82,
        total_line: 674.86,
        total_margin: 33.62,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 94,
        total_line: 1560.4,
        total_margin: 37.6,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 56,
        total_line: 915.6000000000001,
        total_margin: 54.32,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 74,
        total_line: 705.2199999999999,
        total_margin: 68.08,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 128,
        total_line: 6204.16,
        total_margin: 1181.44,
      },
    ],
    total_invoice: 17452.79,
    total_margin: 2416.3999999999996,
    region: 'Europe',
  },
  {
    id: 45,
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    date: '2020-05-10',
    invoice_lines: [
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 93,
        total_line: 299.46000000000004,
        total_margin: 24.18,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 117,
        total_line: 4470.57,
        total_margin: 1033.11,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 99,
        total_line: 4798.53,
        total_margin: 913.7700000000001,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 9,
        total_line: 267.3,
        total_margin: 7.47,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 96,
        total_line: 392.64,
        total_margin: 72.96000000000001,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 107,
        total_line: 2917.89,
        total_margin: 701.92,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 55,
        total_line: 1838.1000000000001,
        total_margin: 221.09999999999997,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 143,
        total_line: 4026.88,
        total_margin: 167.31,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 41,
        total_line: 463.3,
        total_margin: 112.75,
      },
    ],
    total_invoice: 19474.67,
    total_margin: 3254.5699999999997,
    region: 'Europe',
  },
  {
    id: 46,
    customer_id: 27,
    customer_name: 'Daniels Jackson',
    date: '2020-12-25',
    invoice_lines: [
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 121,
        total_line: 2885.8500000000004,
        total_margin: 694.5400000000001,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 142,
        total_line: 2993.3599999999997,
        total_margin: 36.92,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 148,
        total_line: 1778.96,
        total_margin: 344.84000000000003,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 37,
        total_line: 1793.3899999999999,
        total_margin: 341.51,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 29,
        total_line: 118.61,
        total_margin: 22.04,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 100,
        total_line: 3397.9999999999995,
        total_margin: 728,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 129,
        total_line: 4311.18,
        total_margin: 518.5799999999999,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 61,
        total_line: 2090.4700000000003,
        total_margin: 273.89,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 81,
        total_line: 2554.74,
        total_margin: 53.46,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 46,
        total_line: 507.38,
        total_margin: 43.239999999999995,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 23,
        total_line: 627.21,
        total_margin: 150.88,
      },
    ],
    total_invoice: 23059.149999999998,
    total_margin: 3207.9,
    region: 'Europe',
  },
  {
    id: 47,
    customer_id: 37,
    customer_name: 'John Wu',
    date: '2020-10-07',
    invoice_lines: [
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 14,
        total_line: 532.4200000000001,
        total_margin: 21.42,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 115,
        total_line: 3627.1,
        total_margin: 75.9,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 90,
        total_line: 4310.1,
        total_margin: 715.5,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 45,
        total_line: 890.55,
        total_margin: 108.45,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 145,
        total_line: 2792.7000000000003,
        total_margin: 371.2,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 83,
        total_line: 3674.4100000000003,
        total_margin: 138.60999999999999,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 140,
        total_line: 5048.400000000001,
        total_margin: 575.4000000000001,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 39,
        total_line: 1220.31,
        total_margin: 251.16000000000003,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 44,
        total_line: 2132.68,
        total_margin: 406.12,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 71,
        total_line: 208.74,
        total_margin: 48.28,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 130,
        total_line: 2366,
        total_margin: 66.3,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 34,
        total_line: 503.20000000000005,
        total_margin: 26.86,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 79,
        total_line: 949.5799999999999,
        total_margin: 184.07,
      },
    ],
    total_invoice: 28256.190000000002,
    total_margin: 2989.2700000000004,
    region: 'Australia',
  },
  {
    id: 48,
    customer_id: 4,
    customer_name: 'Daniels Smith',
    date: '2020-12-11',
    invoice_lines: [
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 6,
        total_line: 118.74,
        total_margin: 14.46,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 145,
        total_line: 4537.05,
        total_margin: 933.8000000000001,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 17,
        total_line: 69.53,
        total_margin: 12.92,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 131,
        total_line: 2175.91,
        total_margin: 271.16999999999996,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 43,
        total_line: 516.86,
        total_margin: 100.19,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 140,
        total_line: 450.8,
        total_margin: 36.4,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 101,
        total_line: 892.84,
        total_margin: 163.62,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 36,
        total_line: 1223.28,
        total_margin: 262.08,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 40,
        total_line: 550,
        total_margin: 73.2,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 26,
        total_line: 225.68,
        total_margin: 18.72,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 27,
        total_line: 1180.7099999999998,
        total_margin: 270.27,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 16,
        total_line: 576.96,
        total_margin: 65.76,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 100,
        total_line: 3804,
        total_margin: 684,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 107,
        total_line: 1930.28,
        total_margin: 306.02,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 9,
        total_line: 194.4,
        total_margin: 36.99,
      },
    ],
    total_invoice: 18447.04,
    total_margin: 3249.6,
    region: 'India',
  },
  {
    id: 49,
    customer_id: 32,
    customer_name: 'John Muijs',
    date: '2020-04-25',
    invoice_lines: [
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 74,
        total_line: 1209.9,
        total_margin: 71.78,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 121,
        total_line: 995.83,
        total_margin: 49.61,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 102,
        total_line: 1255.6200000000001,
        total_margin: 261.12,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 112,
        total_line: 1410.08,
        total_margin: 51.52,
      },
    ],
    total_invoice: 4871.43,
    total_margin: 434.03,
    region: 'India',
  },
  {
    id: 50,
    customer_id: 10,
    customer_name: 'Daniels van Dijk',
    date: '2020-02-19',
    invoice_lines: [
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 29,
        total_line: 481.40000000000003,
        total_margin: 11.600000000000001,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 138,
        total_line: 3291.3,
        total_margin: 792.12,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 111,
        total_line: 4221.33,
        total_margin: 169.83,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 11,
        total_line: 198.44,
        total_margin: 31.459999999999997,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 112,
        total_line: 4958.240000000001,
        total_margin: 187.04,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 8,
        total_line: 215.36,
        total_margin: 52.32,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 93,
        total_line: 2933.22,
        total_margin: 61.38,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 15,
        total_line: 509.69999999999993,
        total_margin: 109.2,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 105,
        total_line: 3509.1000000000004,
        total_margin: 422.09999999999997,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 37,
        total_line: 1413.77,
        total_margin: 326.71,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 73,
        total_line: 645.3199999999999,
        total_margin: 118.26,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 110,
        total_line: 449.9,
        total_margin: 83.6,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 15,
        total_line: 570.6,
        total_margin: 102.6,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 45,
        total_line: 1267.2,
        total_margin: 52.65,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 115,
        total_line: 1581.25,
        total_margin: 210.45000000000002,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 12,
        total_line: 287.15999999999997,
        total_margin: 14.76,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 132,
        total_line: 5064.839999999999,
        total_margin: 442.2,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 64,
        total_line: 1164.8,
        total_margin: 32.64,
      },
    ],
    total_invoice: 32762.930000000004,
    total_margin: 3220.92,
    region: 'Australia',
  },
  {
    id: 51,
    customer_id: 7,
    customer_name: 'Jean Cook',
    date: '2020-07-17',
    invoice_lines: [
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 85,
        total_line: 751.4,
        total_margin: 137.70000000000002,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 58,
        total_line: 639.74,
        total_margin: 54.519999999999996,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 88,
        total_line: 1855.04,
        total_margin: 22.880000000000003,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 109,
        total_line: 1809.4,
        total_margin: 43.6,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 62,
        total_line: 700.6,
        total_margin: 170.5,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 15,
        total_line: 540.9000000000001,
        total_margin: 61.650000000000006,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 8,
        total_line: 158.32,
        total_margin: 19.28,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 99,
        total_line: 3782.79,
        total_margin: 874.17,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 9,
        total_line: 283.86,
        total_margin: 5.94,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 133,
        total_line: 4560.57,
        total_margin: 835.24,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 72,
        total_line: 906.48,
        total_margin: 33.120000000000005,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 53,
        total_line: 880.3299999999999,
        total_margin: 109.71,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 133,
        total_line: 5103.21,
        total_margin: 445.55,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 93,
        total_line: 765.39,
        total_margin: 38.129999999999995,
      },
    ],
    total_invoice: 22738.03,
    total_margin: 2851.9900000000002,
    region: 'India',
  },
  {
    id: 52,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-10-10',
    invoice_lines: [
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 97,
        total_line: 1705.2599999999998,
        total_margin: 282.27000000000004,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 73,
        total_line: 1965.16,
        total_margin: 477.42,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 118,
        total_line: 1301.54,
        total_margin: 110.91999999999999,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 42,
        total_line: 686.7,
        total_margin: 40.74,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 6,
        total_line: 203.88,
        total_margin: 43.68,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 90,
        total_line: 4075.2000000000003,
        total_margin: 405,
      },
    ],
    total_invoice: 9937.74,
    total_margin: 1360.03,
    region: 'Europe',
  },
  {
    id: 53,
    customer_id: 18,
    customer_name: 'Jack Wu',
    date: '2020-11-28',
    invoice_lines: [
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 130,
        total_line: 1924,
        total_margin: 102.7,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 83,
        total_line: 4023.0099999999998,
        total_margin: 766.09,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 146,
        total_line: 2657.2,
        total_margin: 74.46000000000001,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 24,
        total_line: 822.48,
        total_margin: 107.76,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 42,
        total_line: 135.24,
        total_margin: 10.92,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 28,
        total_line: 554.12,
        total_margin: 67.48,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 63,
        total_line: 1774.08,
        total_margin: 73.71,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 112,
        total_line: 3326.4,
        total_margin: 92.96,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 12,
        total_line: 199.20000000000002,
        total_margin: 4.800000000000001,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 5,
        total_line: 119.25,
        total_margin: 28.700000000000003,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 61,
        total_line: 3020.1099999999997,
        total_margin: 229.97,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 30,
        total_line: 717.9,
        total_margin: 36.9,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 20,
        total_line: 905.6,
        total_margin: 90,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 121,
        total_line: 2182.8399999999997,
        total_margin: 346.06,
      },
    ],
    total_invoice: 22361.43,
    total_margin: 2032.5100000000004,
    region: 'USA',
  },
  {
    id: 54,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-08-18',
    invoice_lines: [
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 48,
        total_line: 1631.04,
        total_margin: 349.44,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 127,
        total_line: 4872.99,
        total_margin: 425.45,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 64,
        total_line: 188.16,
        total_margin: 43.52,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 5,
        total_line: 103.05,
        total_margin: 9.350000000000001,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 121,
        total_line: 1454.4199999999998,
        total_margin: 281.93,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 126,
        total_line: 2426.76,
        total_margin: 322.56,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 124,
        total_line: 3491.84,
        total_margin: 145.07999999999998,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 42,
        total_line: 1324.68,
        total_margin: 27.720000000000002,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 106,
        total_line: 3822.36,
        total_margin: 435.66,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 133,
        total_line: 6022.24,
        total_margin: 598.5,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 62,
        total_line: 683.86,
        total_margin: 58.279999999999994,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 38,
        total_line: 1303.02,
        total_margin: 238.64000000000001,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 45,
        total_line: 890.55,
        total_margin: 108.45,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 149,
        total_line: 1834.19,
        total_margin: 381.44,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 35,
        total_line: 626.85,
        total_margin: 65.10000000000001,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 23,
        total_line: 414.91999999999996,
        total_margin: 65.78,
      },
    ],
    total_invoice: 31090.929999999997,
    total_margin: 3556.9,
    region: 'Europe',
  },
  {
    id: 55,
    customer_id: 22,
    customer_name: 'Martin Cook',
    date: '2020-09-05',
    invoice_lines: [
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 120,
        total_line: 2149.2,
        total_margin: 223.20000000000002,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 100,
        total_line: 4951,
        total_margin: 377,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 47,
        total_line: 138.18,
        total_margin: 31.96,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 47,
        total_line: 1395.8999999999999,
        total_margin: 39.01,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 16,
        total_line: 548.32,
        total_margin: 71.84,
      },
    ],
    total_invoice: 9182.6,
    total_margin: 743.0100000000001,
    region: 'Australia',
  },
  {
    id: 56,
    customer_id: 22,
    customer_name: 'Martin Cook',
    date: '2020-01-04',
    invoice_lines: [
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 32,
        total_line: 616.32,
        total_margin: 81.92,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 56,
        total_line: 689.36,
        total_margin: 143.36,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 68,
        total_line: 750.04,
        total_margin: 63.919999999999995,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 137,
        total_line: 2027.6000000000001,
        total_margin: 108.23,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 96,
        total_line: 2297.2799999999997,
        total_margin: 118.08,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 59,
        total_line: 742.81,
        total_margin: 27.14,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 66,
        total_line: 2886.18,
        total_margin: 660.66,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 95,
        total_line: 2972.5499999999997,
        total_margin: 611.8000000000001,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 33,
        total_line: 484.11,
        total_margin: 72.92999999999999,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 116,
        total_line: 5743.16,
        total_margin: 437.32,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 105,
        total_line: 308.7,
        total_margin: 71.4,
      },
    ],
    total_invoice: 19518.11,
    total_margin: 2396.76,
    region: 'USA',
  },
  {
    id: 57,
    customer_id: 24,
    customer_name: 'Pablo Mohaman',
    date: '2020-03-25',
    invoice_lines: [
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 52,
        total_line: 1875.1200000000001,
        total_margin: 213.72000000000003,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 95,
        total_line: 1073.5,
        total_margin: 261.25,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 48,
        total_line: 2298.7200000000003,
        total_margin: 381.6,
      },
    ],
    total_invoice: 5247.34,
    total_margin: 856.57,
    region: 'Europe',
  },
  {
    id: 58,
    customer_id: 11,
    customer_name: 'Jean Martins',
    date: '2020-07-10',
    invoice_lines: [
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 1,
        total_line: 19.26,
        total_margin: 2.56,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 85,
        total_line: 1070.15,
        total_margin: 39.1,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 81,
        total_line: 2707.02,
        total_margin: 325.61999999999995,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 73,
        total_line: 1193.5500000000002,
        total_margin: 70.81,
      },
    ],
    total_invoice: 4989.9800000000005,
    total_margin: 438.09,
    region: 'India',
  },
  {
    id: 59,
    customer_id: 3,
    customer_name: 'John Wu',
    date: '2020-07-04',
    invoice_lines: [
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 73,
        total_line: 1538.84,
        total_margin: 18.98,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 74,
        total_line: 1992.0800000000002,
        total_margin: 483.96,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 103,
        total_line: 4504.19,
        total_margin: 1031.03,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 2,
        total_line: 96.94,
        total_margin: 18.46,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 45,
        total_line: 1543.05,
        total_margin: 282.6,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 110,
        total_line: 4203.1,
        total_margin: 971.3,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 74,
        total_line: 1598.4,
        total_margin: 304.14000000000004,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 147,
        total_line: 2632.77,
        total_margin: 273.42,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 92,
        total_line: 1659.6799999999998,
        total_margin: 263.12,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 39,
        total_line: 491.01,
        total_margin: 17.94,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 118,
        total_line: 1301.54,
        total_margin: 110.91999999999999,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 54,
        total_line: 1850.5800000000002,
        total_margin: 242.46,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 31,
        total_line: 597.0600000000001,
        total_margin: 79.36,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 149,
        total_line: 479.78000000000003,
        total_margin: 38.74,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 61,
        total_line: 838.75,
        total_margin: 111.63000000000001,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 22,
        total_line: 693.88,
        total_margin: 14.520000000000001,
      },
    ],
    total_invoice: 26021.65,
    total_margin: 4262.58,
    region: 'USA',
  },
  {
    id: 60,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-02-02',
    invoice_lines: [
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 124,
        total_line: 3381.48,
        total_margin: 813.4399999999999,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 77,
        total_line: 1401.3999999999999,
        total_margin: 39.27,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 76,
        total_line: 1045,
        total_margin: 139.08,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 107,
        total_line: 5124.2300000000005,
        total_margin: 850.65,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 43,
        total_line: 2084.21,
        total_margin: 396.89000000000004,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 18,
        total_line: 148.14000000000001,
        total_margin: 7.38,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 75,
        total_line: 1580.9999999999998,
        total_margin: 19.5,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 74,
        total_line: 1764.9,
        total_margin: 424.76,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 138,
        total_line: 2426.04,
        total_margin: 401.58000000000004,
      },
    ],
    total_invoice: 18956.4,
    total_margin: 3092.55,
    region: 'Europe',
  },
  {
    id: 61,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-07-03',
    invoice_lines: [
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 48,
        total_line: 1825.44,
        total_margin: 73.44,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 23,
        total_line: 829.3800000000001,
        total_margin: 94.53,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 92,
        total_line: 757.1600000000001,
        total_margin: 37.72,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 120,
        total_line: 5816.4,
        total_margin: 1107.6000000000001,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 12,
        total_line: 114.35999999999999,
        total_margin: 11.040000000000001,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 98,
        total_line: 1450.4,
        total_margin: 77.42,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 66,
        total_line: 1306.1399999999999,
        total_margin: 159.06,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 93,
        total_line: 1144.8300000000002,
        total_margin: 238.08,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 80,
        total_line: 2503.2,
        total_margin: 515.2,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 36,
        total_line: 115.92,
        total_margin: 9.36,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 129,
        total_line: 3632.64,
        total_margin: 150.92999999999998,
      },
    ],
    total_invoice: 19495.870000000003,
    total_margin: 2474.38,
    region: 'Europe',
  },
  {
    id: 62,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-05-13',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 118,
        total_line: 5223.860000000001,
        total_margin: 197.06,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 31,
        total_line: 920.6999999999999,
        total_margin: 25.73,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 75,
        total_line: 2346.75,
        total_margin: 483.00000000000006,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 121,
        total_line: 2394.5899999999997,
        total_margin: 291.61,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 59,
        total_line: 2243.77,
        total_margin: 90.27,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 123,
        total_line: 6089.73,
        total_margin: 463.71,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 66,
        total_line: 727.9799999999999,
        total_margin: 62.04,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 18,
        total_line: 379.43999999999994,
        total_margin: 4.68,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 88,
        total_line: 3015.76,
        total_margin: 395.12,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 3,
        total_line: 49.83,
        total_margin: 6.209999999999999,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 142,
        total_line: 2543.22,
        total_margin: 264.12,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 24,
        total_line: 392.40000000000003,
        total_margin: 23.28,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 107,
        total_line: 3013.12,
        total_margin: 125.19,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 17,
        total_line: 649.57,
        total_margin: 150.11,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 84,
        total_line: 2003.4,
        total_margin: 482.16,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 142,
        total_line: 3872.34,
        total_margin: 931.52,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 12,
        total_line: 411.48,
        total_margin: 75.36,
      },
    ],
    total_invoice: 36277.94000000001,
    total_margin: 4071.1700000000005,
    region: 'Europe',
  },
  {
    id: 63,
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    date: '2020-09-20',
    invoice_lines: [
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 27,
        total_line: 583.2,
        total_margin: 110.97000000000001,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 19,
        total_line: 340.29,
        total_margin: 35.34,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 37,
        total_line: 1008.99,
        total_margin: 242.72,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 1,
        total_line: 9.53,
        total_margin: 0.92,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 21,
        total_line: 720.09,
        total_margin: 131.88,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 65,
        total_line: 1079,
        total_margin: 26,
      },
    ],
    total_invoice: 3741.1,
    total_margin: 547.8299999999999,
    region: 'India',
  },
  {
    id: 64,
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    date: '2020-01-25',
    invoice_lines: [
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 135,
        total_line: 1998,
        total_margin: 106.65,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 12,
        total_line: 147.72,
        total_margin: 30.72,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 118,
        total_line: 971.1400000000001,
        total_margin: 48.379999999999995,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 19,
        total_line: 55.86,
        total_margin: 12.920000000000002,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 54,
        total_line: 882.9000000000001,
        total_margin: 52.379999999999995,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 125,
        total_line: 1105,
        total_margin: 202.5,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 122,
        total_line: 2144.7599999999998,
        total_margin: 355.02000000000004,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 59,
        total_line: 1274.4,
        total_margin: 242.49,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 91,
        total_line: 1145.69,
        total_margin: 41.86,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 70,
        total_line: 2207.7999999999997,
        total_margin: 46.2,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 141,
        total_line: 5084.46,
        total_margin: 579.51,
      },
    ],
    total_invoice: 17017.73,
    total_margin: 1718.6299999999999,
    region: 'Europe',
  },
  {
    id: 65,
    customer_id: 12,
    customer_name: 'Trisha Wu',
    date: '2020-11-25',
    invoice_lines: [
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 148,
        total_line: 3984.1600000000003,
        total_margin: 967.92,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 115,
        total_line: 3136.0499999999997,
        total_margin: 754.4,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 18,
        total_line: 690.66,
        total_margin: 60.300000000000004,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 77,
        total_line: 1139.6000000000001,
        total_margin: 60.830000000000005,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 36,
        total_line: 655.1999999999999,
        total_margin: 18.36,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 129,
        total_line: 6252.63,
        total_margin: 1190.67,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 57,
        total_line: 717.63,
        total_margin: 26.220000000000002,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 58,
        total_line: 1970.84,
        total_margin: 422.24,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 140,
        total_line: 450.8,
        total_margin: 36.4,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 113,
        total_line: 5411.57,
        total_margin: 898.35,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 45,
        total_line: 1967.85,
        total_margin: 450.45,
      },
    ],
    total_invoice: 26376.989999999998,
    total_margin: 4886.139999999999,
    region: 'USA',
  },
  {
    id: 66,
    customer_id: 5,
    customer_name: 'Tim Smith',
    date: '2020-02-07',
    invoice_lines: [
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 129,
        total_line: 1422.87,
        total_margin: 121.25999999999999,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 109,
        total_line: 1613.2,
        total_margin: 86.11,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 99,
        total_line: 1452.33,
        total_margin: 218.79,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 23,
        total_line: 74.06,
        total_margin: 5.98,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 130,
        total_line: 4100.2,
        total_margin: 85.8,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 102,
        total_line: 299.88,
        total_margin: 69.36,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 113,
        total_line: 3776.46,
        total_margin: 454.25999999999993,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 44,
        total_line: 847.44,
        total_margin: 112.64,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 48,
        total_line: 2298.7200000000003,
        total_margin: 381.6,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 146,
        total_line: 1649.8000000000002,
        total_margin: 401.5,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 102,
        total_line: 3465.9599999999996,
        total_margin: 742.5600000000001,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 2,
        total_line: 76.42,
        total_margin: 17.66,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 114,
        total_line: 4335.42,
        total_margin: 174.42000000000002,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 139,
        total_line: 2750.81,
        total_margin: 334.99,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 146,
        total_line: 2423.6000000000004,
        total_margin: 58.400000000000006,
      },
    ],
    total_invoice: 30587.17,
    total_margin: 3265.3300000000004,
    region: 'India',
  },
  {
    id: 67,
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    date: '2020-03-24',
    invoice_lines: [
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 38,
        total_line: 456.76,
        total_margin: 88.54,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 109,
        total_line: 4146.36,
        total_margin: 745.56,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 24,
        total_line: 920.8799999999999,
        total_margin: 80.4,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 103,
        total_line: 2456.55,
        total_margin: 591.22,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 90,
        total_line: 3935.7,
        total_margin: 900.9,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 6,
        total_line: 53.04,
        total_margin: 9.72,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 85,
        total_line: 1791.8,
        total_margin: 22.1,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 6,
        total_line: 129.60000000000002,
        total_margin: 24.660000000000004,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 26,
        total_line: 732.16,
        total_margin: 30.419999999999998,
      },
    ],
    total_invoice: 14622.85,
    total_margin: 2493.5199999999995,
    region: 'Europe',
  },
  {
    id: 68,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-10-26',
    invoice_lines: [
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 44,
        total_line: 497.20000000000005,
        total_margin: 121,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 140,
        total_line: 6122.2,
        total_margin: 1401.3999999999999,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 20,
        total_line: 385.20000000000005,
        total_margin: 51.2,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 31,
        total_line: 454.77,
        total_margin: 68.51,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 5,
        total_line: 191.05,
        total_margin: 44.15,
      },
    ],
    total_invoice: 7650.419999999999,
    total_margin: 1686.26,
    region: 'Brazil',
  },
  {
    id: 69,
    customer_id: 28,
    customer_name: 'Allan Cook',
    date: '2020-12-22',
    invoice_lines: [
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 3,
        total_line: 89.1,
        total_margin: 2.4899999999999998,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 19,
        total_line: 518.13,
        total_margin: 124.63999999999999,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 95,
        total_line: 1393.65,
        total_margin: 209.95,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 15,
        total_line: 514.0500000000001,
        total_margin: 67.35000000000001,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 77,
        total_line: 2573.34,
        total_margin: 309.53999999999996,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 62,
        total_line: 1110.42,
        total_margin: 115.32000000000001,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 17,
        total_line: 336.43,
        total_margin: 40.97,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 83,
        total_line: 2234.36,
        total_margin: 542.82,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 82,
        total_line: 3118.46,
        total_margin: 125.46000000000001,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 138,
        total_line: 5272.9800000000005,
        total_margin: 1218.54,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 53,
        total_line: 784.4000000000001,
        total_margin: 41.870000000000005,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 88,
        total_line: 763.8399999999999,
        total_margin: 63.36,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 52,
        total_line: 1123.2,
        total_margin: 213.72000000000003,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 59,
        total_line: 1243.7199999999998,
        total_margin: 15.34,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 24,
        total_line: 865.44,
        total_margin: 98.64000000000001,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 23,
        total_line: 1018.21,
        total_margin: 38.41,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 40,
        total_line: 492.40000000000003,
        total_margin: 102.4,
      },
    ],
    total_invoice: 23452.130000000005,
    total_margin: 3330.8199999999997,
    region: 'Europe',
  },
  {
    id: 70,
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    date: '2020-01-11',
    invoice_lines: [
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 131,
        total_line: 535.79,
        total_margin: 99.56,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 137,
        total_line: 2239.9500000000003,
        total_margin: 132.89,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 136,
        total_line: 2619.36,
        total_margin: 348.16,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 108,
        total_line: 954.72,
        total_margin: 174.96,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 46,
        total_line: 566.26,
        total_margin: 117.76,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 33,
        total_line: 1189.98,
        total_margin: 135.63000000000002,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 6,
        total_line: 88.80000000000001,
        total_margin: 4.74,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 43,
        total_line: 928.8000000000001,
        total_margin: 176.73000000000002,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 79,
        total_line: 3783.31,
        total_margin: 628.0500000000001,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 120,
        total_line: 1041.6,
        total_margin: 86.39999999999999,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 44,
        total_line: 906.8399999999999,
        total_margin: 82.28,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 62,
        total_line: 3069.62,
        total_margin: 233.74,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 112,
        total_line: 3153.92,
        total_margin: 131.04,
      },
    ],
    total_invoice: 21078.949999999997,
    total_margin: 2351.94,
    region: 'USA',
  },
  {
    id: 71,
    customer_id: 3,
    customer_name: 'John Wu',
    date: '2020-05-14',
    invoice_lines: [
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 111,
        total_line: 5380.17,
        total_margin: 1024.53,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 31,
        total_line: 1484.59,
        total_margin: 246.45000000000002,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 3,
        total_line: 115.10999999999999,
        total_margin: 10.05,
      },
    ],
    total_invoice: 6979.87,
    total_margin: 1281.03,
    region: 'India',
  },
  {
    id: 72,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-08-27',
    invoice_lines: [
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 89,
        total_line: 4406.389999999999,
        total_margin: 335.53000000000003,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 18,
        total_line: 52.92,
        total_margin: 12.24,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 35,
        total_line: 1189.3,
        total_margin: 254.8,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 113,
        total_line: 2056.6,
        total_margin: 57.63,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 106,
        total_line: 2528.1000000000004,
        total_margin: 608.44,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 75,
        total_line: 847.5,
        total_margin: 206.25,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 21,
        total_line: 310.8,
        total_margin: 16.59,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 131,
        total_line: 421.82000000000005,
        total_margin: 34.06,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 72,
        total_line: 2406.2400000000002,
        total_margin: 289.43999999999994,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 125,
        total_line: 4755,
        total_margin: 855,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 11,
        total_line: 237.60000000000002,
        total_margin: 45.21,
      },
    ],
    total_invoice: 19212.269999999997,
    total_margin: 2715.19,
    region: 'India',
  },
  {
    id: 73,
    customer_id: 12,
    customer_name: 'Trisha Wu',
    date: '2020-04-23',
    invoice_lines: [
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 100,
        total_line: 1202,
        total_margin: 233,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 70,
        total_line: 618.8,
        total_margin: 113.4,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 95,
        total_line: 1577.95,
        total_margin: 196.64999999999998,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 128,
        total_line: 1894.4,
        total_margin: 101.12,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 123,
        total_line: 4215.21,
        total_margin: 552.27,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 19,
        total_line: 841.1300000000001,
        total_margin: 31.729999999999997,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 143,
        total_line: 2513.9399999999996,
        total_margin: 416.13,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 127,
        total_line: 1210.31,
        total_margin: 116.84,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 115,
        total_line: 2751.95,
        total_margin: 141.45,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 112,
        total_line: 2005.92,
        total_margin: 208.32000000000002,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 38,
        total_line: 111.72,
        total_margin: 25.840000000000003,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 77,
        total_line: 2573.34,
        total_margin: 309.53999999999996,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 6,
        total_line: 161.52,
        total_margin: 39.24,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 54,
        total_line: 610.2,
        total_margin: 148.5,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 25,
        total_line: 681.75,
        total_margin: 164,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 26,
        total_line: 469.03999999999996,
        total_margin: 74.36,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 53,
        total_line: 2015.5900000000001,
        total_margin: 81.09,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 120,
        total_line: 1992.0000000000002,
        total_margin: 48,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 70,
        total_line: 2662.7999999999997,
        total_margin: 478.8,
      },
    ],
    total_invoice: 30109.570000000003,
    total_margin: 3480.2800000000007,
    region: 'Brazil',
  },
  {
    id: 74,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-08-08',
    invoice_lines: [
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 47,
        total_line: 780.67,
        total_margin: 97.28999999999999,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 69,
        total_line: 1651.17,
        total_margin: 84.87,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 108,
        total_line: 888.84,
        total_margin: 44.279999999999994,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 125,
        total_line: 5986.25,
        total_margin: 993.75,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 120,
        total_line: 2529.6,
        total_margin: 31.200000000000003,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 38,
        total_line: 1070.08,
        total_margin: 44.459999999999994,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 64,
        total_line: 947.2,
        total_margin: 50.56,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 74,
        total_line: 2827.54,
        total_margin: 653.42,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 96,
        total_line: 4249.92,
        total_margin: 160.32,
      },
    ],
    total_invoice: 20931.270000000004,
    total_margin: 2160.15,
    region: 'India',
  },
  {
    id: 75,
    customer_id: 26,
    customer_name: 'Magda Castex',
    date: '2020-05-01',
    invoice_lines: [
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 13,
        total_line: 280.8,
        total_margin: 53.43000000000001,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 48,
        total_line: 2099.04,
        total_margin: 480.48,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 9,
        total_line: 79.56,
        total_margin: 14.580000000000002,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 108,
        total_line: 2945.16,
        total_margin: 708.4799999999999,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 57,
        total_line: 2167.71,
        total_margin: 87.21000000000001,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 40,
        total_line: 1251.6,
        total_margin: 257.6,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 19,
        total_line: 334.02,
        total_margin: 55.290000000000006,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 20,
        total_line: 293.4,
        total_margin: 44.2,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 5,
        total_line: 119.25,
        total_margin: 28.700000000000003,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 89,
        total_line: 1761.31,
        total_margin: 214.49,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 59,
        total_line: 562.27,
        total_margin: 54.28,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 67,
        total_line: 1112.2,
        total_margin: 26.8,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 83,
        total_line: 1510.6,
        total_margin: 42.33,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 71,
        total_line: 1160.8500000000001,
        total_margin: 68.87,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 39,
        total_line: 159.51,
        total_margin: 29.64,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 25,
        total_line: 217,
        total_margin: 18,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 75,
        total_line: 1031.25,
        total_margin: 137.25,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 43,
        total_line: 541.37,
        total_margin: 19.78,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 7,
        total_line: 116.27,
        total_margin: 14.489999999999998,
      },
    ],
    total_invoice: 17743.17,
    total_margin: 2355.9,
    region: 'USA',
  },
  {
    id: 76,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-06-14',
    invoice_lines: [
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 14,
        total_line: 302.40000000000003,
        total_margin: 57.540000000000006,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 100,
        total_line: 294,
        total_margin: 68,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 40,
        total_line: 1090.8,
        total_margin: 262.4,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 52,
        total_line: 640.12,
        total_margin: 133.12,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 146,
        total_line: 2423.6000000000004,
        total_margin: 58.400000000000006,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 114,
        total_line: 1435.26,
        total_margin: 52.440000000000005,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 130,
        total_line: 6436.3,
        total_margin: 490.1,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 55,
        total_line: 1133.55,
        total_margin: 102.85000000000001,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 14,
        total_line: 633.9200000000001,
        total_margin: 63,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 48,
        total_line: 1351.68,
        total_margin: 56.16,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 48,
        total_line: 704.16,
        total_margin: 106.08,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 58,
        total_line: 2091.48,
        total_margin: 238.38000000000002,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 51,
        total_line: 1075.08,
        total_margin: 13.26,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 8,
        total_line: 271.84,
        total_margin: 58.24,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 94,
        total_line: 2941.2599999999998,
        total_margin: 605.36,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 88,
        total_line: 3376.56,
        total_margin: 294.8,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 14,
        total_line: 670.46,
        total_margin: 111.3,
      },
    ],
    total_invoice: 26872.469999999998,
    total_margin: 2771.4300000000003,
    region: 'USA',
  },
  {
    id: 77,
    customer_id: 32,
    customer_name: 'John Muijs',
    date: '2020-07-18',
    invoice_lines: [
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 90,
        total_line: 1733.4,
        total_margin: 230.4,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 14,
        total_line: 172.34,
        total_margin: 35.84,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 107,
        total_line: 3348.0299999999997,
        total_margin: 689.08,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 77,
        total_line: 1842.61,
        total_margin: 94.71,
      },
    ],
    total_invoice: 7096.379999999999,
    total_margin: 1050.03,
    region: 'Australia',
  },
  {
    id: 78,
    customer_id: 13,
    customer_name: 'Mike Jackson',
    date: '2020-11-04',
    invoice_lines: [
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 105,
        total_line: 2863.35,
        total_margin: 688.8,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 97,
        total_line: 3706.37,
        total_margin: 856.51,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 20,
        total_line: 538.4000000000001,
        total_margin: 130.8,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 21,
        total_line: 231.63,
        total_margin: 19.74,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 32,
        total_line: 1009.28,
        total_margin: 21.12,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 57,
        total_line: 167.57999999999998,
        total_margin: 38.760000000000005,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 21,
        total_line: 757.26,
        total_margin: 86.31,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 70,
        total_line: 1669.5,
        total_margin: 401.8,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 116,
        total_line: 1394.32,
        total_margin: 270.28000000000003,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 23,
        total_line: 259.90000000000003,
        total_margin: 63.25,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 79,
        total_line: 323.11,
        total_margin: 60.04,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 4,
        total_line: 12.88,
        total_margin: 1.04,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 80,
        total_line: 1914.4,
        total_margin: 98.4,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 83,
        total_line: 3629.5899999999997,
        total_margin: 830.8299999999999,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 34,
        total_line: 613.36,
        total_margin: 97.24,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 73,
        total_line: 1080.4,
        total_margin: 57.67,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 148,
        total_line: 5071.96,
        total_margin: 664.52,
      },
    ],
    total_invoice: 25243.289999999997,
    total_margin: 4387.11,
    region: 'Europe',
  },
  {
    id: 79,
    customer_id: 11,
    customer_name: 'Jean Martins',
    date: '2020-09-06',
    invoice_lines: [
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 48,
        total_line: 796.8000000000001,
        total_margin: 19.200000000000003,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 93,
        total_line: 1692.6,
        total_margin: 47.43,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 100,
        total_line: 2816,
        total_margin: 117,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 119,
        total_line: 1498.21,
        total_margin: 54.74,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 1,
        total_line: 17.58,
        total_margin: 2.91,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 66,
        total_line: 2509.98,
        total_margin: 100.98,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 20,
        total_line: 164.60000000000002,
        total_margin: 8.2,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 37,
        total_line: 1334.22,
        total_margin: 152.07000000000002,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 77,
        total_line: 733.81,
        total_margin: 70.84,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 122,
        total_line: 2185.02,
        total_margin: 226.92000000000002,
      },
    ],
    total_invoice: 13748.82,
    total_margin: 800.29,
    region: 'Brazil',
  },
  {
    id: 80,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-01-03',
    invoice_lines: [
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 103,
        total_line: 1296.77,
        total_margin: 47.38,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 7,
        total_line: 126.28,
        total_margin: 20.02,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 114,
        total_line: 5459.46,
        total_margin: 906.3000000000001,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 110,
        total_line: 2318.7999999999997,
        total_margin: 28.6,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 28,
        total_line: 876.12,
        total_margin: 180.32000000000002,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 64,
        total_line: 2897.92,
        total_margin: 288,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 19,
        total_line: 315.40000000000003,
        total_margin: 7.6000000000000005,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 5,
        total_line: 171.35000000000002,
        total_margin: 22.450000000000003,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 97,
        total_line: 4294.1900000000005,
        total_margin: 161.98999999999998,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 136,
        total_line: 5172.08,
        total_margin: 208.08,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 121,
        total_line: 3257.32,
        total_margin: 791.34,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 19,
        total_line: 315.59,
        total_margin: 39.33,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 98,
        total_line: 806.5400000000001,
        total_margin: 40.18,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 143,
        total_line: 2097.81,
        total_margin: 316.03,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 132,
        total_line: 4485.36,
        total_margin: 960.96,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 85,
        total_line: 737.8,
        total_margin: 61.199999999999996,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 29,
        total_line: 348.58,
        total_margin: 67.57000000000001,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 1,
        total_line: 18.2,
        total_margin: 0.51,
      },
    ],
    total_invoice: 34995.57000000001,
    total_margin: 4147.86,
    region: 'Brazil',
  },
  {
    id: 81,
    customer_id: 9,
    customer_name: 'Daniels Martins',
    date: '2020-12-21',
    invoice_lines: [
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 4,
        total_line: 35.36,
        total_margin: 6.48,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 137,
        total_line: 3735.99,
        total_margin: 898.7199999999999,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 89,
        total_line: 4406.389999999999,
        total_margin: 335.53000000000003,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 72,
        total_line: 2138.4,
        total_margin: 59.76,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 32,
        total_line: 633.28,
        total_margin: 77.12,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 61,
        total_line: 894.87,
        total_margin: 134.81,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 87,
        total_line: 3804.5099999999998,
        total_margin: 870.87,
      },
    ],
    total_invoice: 15648.800000000001,
    total_margin: 2383.29,
    region: 'USA',
  },
  {
    id: 82,
    customer_id: 4,
    customer_name: 'Daniels Smith',
    date: '2020-02-05',
    invoice_lines: [
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 73,
        total_line: 2501.71,
        total_margin: 327.77000000000004,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 108,
        total_line: 3669.8399999999997,
        total_margin: 786.24,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 42,
        total_line: 1604.82,
        total_margin: 370.86,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 49,
        total_line: 1379.84,
        total_margin: 57.33,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 136,
        total_line: 2866.8799999999997,
        total_margin: 35.36,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 32,
        total_line: 1009.28,
        total_margin: 21.12,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 14,
        total_line: 207.20000000000002,
        total_margin: 11.06,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 134,
        total_line: 1277.02,
        total_margin: 123.28,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 136,
        total_line: 2223.6000000000004,
        total_margin: 131.92,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 35,
        total_line: 440.65,
        total_margin: 16.1,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 21,
        total_line: 404.46000000000004,
        total_margin: 53.76,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 51,
        total_line: 913.41,
        total_margin: 94.86,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 17,
        total_line: 823.99,
        total_margin: 156.91,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 46,
        total_line: 399.28,
        total_margin: 33.12,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 104,
        total_line: 3475.6800000000003,
        total_margin: 418.0799999999999,
      },
    ],
    total_invoice: 23197.660000000003,
    total_margin: 2637.769999999999,
    region: 'Brazil',
  },
  {
    id: 83,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-08-12',
    invoice_lines: [
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 121,
        total_line: 2330.46,
        total_margin: 309.76,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 22,
        total_line: 386.76,
        total_margin: 64.02000000000001,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 78,
        total_line: 3861.7799999999997,
        total_margin: 294.06,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 59,
        total_line: 521.56,
        total_margin: 95.58000000000001,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 42,
        total_line: 831.18,
        total_margin: 101.22,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 101,
        total_line: 4895.47,
        total_margin: 932.23,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 28,
        total_line: 352.52,
        total_margin: 12.88,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 84,
        total_line: 2290.68,
        total_margin: 551.04,
      },
    ],
    total_invoice: 15470.41,
    total_margin: 2360.79,
    region: 'Europe',
  },
  {
    id: 84,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-04-16',
    invoice_lines: [
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 122,
        total_line: 5842.58,
        total_margin: 969.9,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 58,
        total_line: 1222.6399999999999,
        total_margin: 15.08,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 2,
        total_line: 17.68,
        total_margin: 3.24,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 145,
        total_line: 5515.8,
        total_margin: 991.8,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 38,
        total_line: 621.3000000000001,
        total_margin: 36.86,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 17,
        total_line: 350.37,
        total_margin: 31.790000000000003,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 95,
        total_line: 1880.05,
        total_margin: 228.95000000000002,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 49,
        total_line: 553.7,
        total_margin: 134.75,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 102,
        total_line: 2432.7000000000003,
        total_margin: 585.48,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 117,
        total_line: 4449.51,
        total_margin: 179.01,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 27,
        total_line: 902.34,
        total_margin: 108.53999999999999,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 13,
        total_line: 366.08,
        total_margin: 15.209999999999999,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 53,
        total_line: 155.82,
        total_margin: 36.04,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 51,
        total_line: 920.04,
        total_margin: 145.85999999999999,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 88,
        total_line: 1694.88,
        total_margin: 225.28,
      },
    ],
    total_invoice: 26925.490000000005,
    total_margin: 3707.79,
    region: 'Europe',
  },
  {
    id: 85,
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    date: '2020-01-22',
    invoice_lines: [
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 22,
        total_line: 209.66,
        total_margin: 20.240000000000002,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 111,
        total_line: 1397.49,
        total_margin: 51.06,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 142,
        total_line: 457.24,
        total_margin: 36.92,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 147,
        total_line: 1209.8100000000002,
        total_margin: 60.269999999999996,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 144,
        total_line: 1249.92,
        total_margin: 103.67999999999999,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 85,
        total_line: 1411.0000000000002,
        total_margin: 34,
      },
    ],
    total_invoice: 5935.120000000001,
    total_margin: 306.17,
    region: 'USA',
  },
  {
    id: 86,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-07-06',
    invoice_lines: [
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 65,
        total_line: 1142.6999999999998,
        total_margin: 189.15,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 89,
        total_line: 2974.38,
        total_margin: 357.78,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 65,
        total_line: 1079,
        total_margin: 26,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 20,
        total_line: 625.8,
        total_margin: 128.8,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 137,
        total_line: 2959.2000000000003,
        total_margin: 563.07,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 125,
        total_line: 4507.5,
        total_margin: 513.75,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 75,
        total_line: 1444.5000000000002,
        total_margin: 192,
      },
    ],
    total_invoice: 14733.08,
    total_margin: 1970.5500000000002,
    region: 'Brazil',
  },
  {
    id: 87,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-04-07',
    invoice_lines: [
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 83,
        total_line: 1228.4,
        total_margin: 65.57000000000001,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 44,
        total_line: 1947.88,
        total_margin: 73.47999999999999,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 66,
        total_line: 907.5,
        total_margin: 120.78,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 30,
        total_line: 1140.9,
        total_margin: 45.9,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 52,
        total_line: 1766.9599999999998,
        total_margin: 378.56,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 10,
        total_line: 166,
        total_margin: 4,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 133,
        total_line: 4795.9800000000005,
        total_margin: 546.63,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 50,
        total_line: 1713.5000000000002,
        total_margin: 224.5,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 148,
        total_line: 435.12,
        total_margin: 100.64,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 69,
        total_line: 1244.76,
        total_margin: 197.34,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 2,
        total_line: 36.4,
        total_margin: 1.02,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 4,
        total_line: 112.64,
        total_margin: 4.68,
      },
    ],
    total_invoice: 15496.04,
    total_margin: 1763.1000000000001,
    region: 'Brazil',
  },
  {
    id: 88,
    customer_id: 21,
    customer_name: 'Jack Cook',
    date: '2020-03-17',
    invoice_lines: [
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 102,
        total_line: 3880.08,
        total_margin: 697.68,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 39,
        total_line: 572.13,
        total_margin: 86.19,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 58,
        total_line: 2216.18,
        total_margin: 512.14,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 38,
        total_line: 335.92,
        total_margin: 61.56,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 3,
        total_line: 102.87,
        total_margin: 18.84,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 58,
        total_line: 639.74,
        total_margin: 54.519999999999996,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 67,
        total_line: 1803.64,
        total_margin: 438.18,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 140,
        total_line: 4158,
        total_margin: 116.19999999999999,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 146,
        total_line: 6991.9400000000005,
        total_margin: 1160.7,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 107,
        total_line: 1317.17,
        total_margin: 273.92,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 133,
        total_line: 1502.9,
        total_margin: 365.75,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 17,
        total_line: 350.37,
        total_margin: 31.790000000000003,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 85,
        total_line: 3762.9500000000003,
        total_margin: 141.95,
      },
    ],
    total_invoice: 27633.89,
    total_margin: 3959.4199999999996,
    region: 'India',
  },
  {
    id: 89,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-09-20',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 92,
        total_line: 4072.84,
        total_margin: 153.64,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 77,
        total_line: 1058.75,
        total_margin: 140.91,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 88,
        total_line: 3376.56,
        total_margin: 294.8,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 131,
        total_line: 1574.62,
        total_margin: 305.23,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 75,
        total_line: 714.75,
        total_margin: 69,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 116,
        total_line: 5743.16,
        total_margin: 437.32,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 32,
        total_line: 582.4,
        total_margin: 16.32,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 144,
        total_line: 5476.32,
        total_margin: 220.32,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 76,
        total_line: 838.28,
        total_margin: 71.44,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 30,
        total_line: 498.00000000000006,
        total_margin: 12,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 55,
        total_line: 1499.85,
        total_margin: 360.79999999999995,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 133,
        total_line: 4557.910000000001,
        total_margin: 597.1700000000001,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 136,
        total_line: 1202.24,
        total_margin: 220.32000000000002,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 147,
        total_line: 3505.9500000000003,
        total_margin: 843.7800000000001,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 115,
        total_line: 470.34999999999997,
        total_margin: 87.4,
      },
    ],
    total_invoice: 35171.979999999996,
    total_margin: 3830.4500000000003,
    region: 'Brazil',
  },
  {
    id: 90,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-03-22',
    invoice_lines: [
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 85,
        total_line: 2680.9,
        total_margin: 56.1,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 32,
        total_line: 1222.72,
        total_margin: 282.56,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 12,
        total_line: 524.76,
        total_margin: 120.12,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 135,
        total_line: 2373.2999999999997,
        total_margin: 392.85,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 121,
        total_line: 1663.75,
        total_margin: 221.43,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 21,
        total_line: 348.6,
        total_margin: 8.4,
      },
    ],
    total_invoice: 8814.03,
    total_margin: 1081.4600000000003,
    region: 'Brazil',
  },
  {
    id: 91,
    customer_id: 20,
    customer_name: 'Magda Del Piero',
    date: '2020-12-26',
    invoice_lines: [
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 120,
        total_line: 386.40000000000003,
        total_margin: 31.200000000000003,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 18,
        total_line: 796.86,
        total_margin: 30.06,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 75,
        total_line: 2571.75,
        total_margin: 471,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 23,
        total_line: 781.54,
        total_margin: 167.44,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 77,
        total_line: 3486.56,
        total_margin: 346.5,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 119,
        total_line: 1312.57,
        total_margin: 111.86,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 7,
        total_line: 61.879999999999995,
        total_margin: 11.34,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 132,
        total_line: 2542.32,
        total_margin: 337.92,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 141,
        total_line: 6165.929999999999,
        total_margin: 1411.41,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 85,
        total_line: 347.65,
        total_margin: 64.6,
      },
    ],
    total_invoice: 18453.46,
    total_margin: 2983.33,
    region: 'Europe',
  },
  {
    id: 92,
    customer_id: 39,
    customer_name: 'John Del Piero',
    date: '2020-08-25',
    invoice_lines: [
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 21,
        total_line: 565.32,
        total_margin: 137.34,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 81,
        total_line: 2534.49,
        total_margin: 521.64,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 101,
        total_line: 1676.6000000000001,
        total_margin: 40.400000000000006,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 44,
        total_line: 1924.12,
        total_margin: 440.44,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 56,
        total_line: 2681.84,
        total_margin: 445.2,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 59,
        total_line: 2263.83,
        total_margin: 197.65,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 89,
        total_line: 1455.15,
        total_margin: 86.33,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 48,
        total_line: 865.92,
        total_margin: 137.28,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 118,
        total_line: 2487.4399999999996,
        total_margin: 30.68,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 58,
        total_line: 850.86,
        total_margin: 128.18,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 47,
        total_line: 1570.74,
        total_margin: 188.93999999999997,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 18,
        total_line: 266.40000000000003,
        total_margin: 14.22,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 142,
        total_line: 4869.18,
        total_margin: 891.76,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 19,
        total_line: 376.01,
        total_margin: 45.790000000000006,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 16,
        total_line: 724.48,
        total_margin: 72,
      },
    ],
    total_invoice: 25112.38,
    total_margin: 3377.8499999999995,
    region: 'Australia',
  },
  {
    id: 93,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-04-02',
    invoice_lines: [
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 141,
        total_line: 6752.49,
        total_margin: 1120.95,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 14,
        total_line: 207.20000000000002,
        total_margin: 11.06,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 42,
        total_line: 1514.52,
        total_margin: 172.62,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 92,
        total_line: 1504.2,
        total_margin: 89.24,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 91,
        total_line: 1028.3,
        total_margin: 250.25,
      },
    ],
    total_invoice: 11006.71,
    total_margin: 1644.1200000000001,
    region: 'India',
  },
  {
    id: 94,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-10-29',
    invoice_lines: [
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 28,
        total_line: 266.84,
        total_margin: 25.76,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 80,
        total_line: 3498.3999999999996,
        total_margin: 800.8,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 92,
        total_line: 757.1600000000001,
        total_margin: 37.72,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 130,
        total_line: 6301.099999999999,
        total_margin: 1199.9,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 31,
        total_line: 99.82000000000001,
        total_margin: 8.06,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 11,
        total_line: 179.85000000000002,
        total_margin: 10.67,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 92,
        total_line: 2732.4,
        total_margin: 76.36,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 45,
        total_line: 1529.1,
        total_margin: 327.6,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 102,
        total_line: 1284.18,
        total_margin: 46.92,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 19,
        total_line: 315.59,
        total_margin: 39.33,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 121,
        total_line: 355.74,
        total_margin: 82.28,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 12,
        total_line: 594.12,
        total_margin: 45.24,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 23,
        total_line: 474.03,
        total_margin: 43.010000000000005,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 4,
        total_line: 70.32,
        total_margin: 11.64,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 15,
        total_line: 422.4,
        total_margin: 17.549999999999997,
      },
    ],
    total_invoice: 18881.05,
    total_margin: 2772.8400000000006,
    region: 'USA',
  },
  {
    id: 95,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-01-24',
    invoice_lines: [
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 3,
        total_line: 8.82,
        total_margin: 2.04,
      },
    ],
    total_invoice: 8.82,
    total_margin: 2.04,
    region: 'Europe',
  },
  {
    id: 96,
    customer_id: 34,
    customer_name: 'Mike Martins',
    date: '2020-01-16',
    invoice_lines: [
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 4,
        total_line: 35.36,
        total_margin: 6.48,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 57,
        total_line: 931.95,
        total_margin: 55.29,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 138,
        total_line: 5248.14,
        total_margin: 211.14000000000001,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 10,
        total_line: 238.5,
        total_margin: 57.400000000000006,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 64,
        total_line: 261.76,
        total_margin: 48.64,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 145,
        total_line: 6340.849999999999,
        total_margin: 1451.45,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 76,
        total_line: 1045,
        total_margin: 139.08,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 101,
        total_line: 3842.04,
        total_margin: 690.84,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 54,
        total_line: 949.3199999999999,
        total_margin: 157.14000000000001,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 126,
        total_line: 6107.22,
        total_margin: 1162.98,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 2,
        total_line: 36.08,
        total_margin: 5.72,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 3,
        total_line: 84.48,
        total_margin: 3.51,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 84,
        total_line: 2010.12,
        total_margin: 103.32,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 143,
        total_line: 2829.97,
        total_margin: 344.63,
      },
    ],
    total_invoice: 29960.790000000005,
    total_margin: 4437.62,
    region: 'Brazil',
  },
  {
    id: 97,
    customer_id: 5,
    customer_name: 'Tim Smith',
    date: '2020-12-16',
    invoice_lines: [
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 62,
        total_line: 852.5,
        total_margin: 113.46000000000001,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 99,
        total_line: 3798.6299999999997,
        total_margin: 331.65000000000003,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 84,
        total_line: 1232.28,
        total_margin: 185.64,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 17,
        total_line: 646.51,
        total_margin: 26.01,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 86,
        total_line: 3894.08,
        total_margin: 387,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 33,
        total_line: 591.03,
        total_margin: 61.38,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 20,
        total_line: 176.8,
        total_margin: 32.400000000000006,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 3,
        total_line: 61.83,
        total_margin: 5.61,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 25,
        total_line: 1093.25,
        total_margin: 250.25,
      },
    ],
    total_invoice: 12346.91,
    total_margin: 1393.4,
    region: 'Brazil',
  },
  {
    id: 98,
    customer_id: 8,
    customer_name: 'Tim Jackson',
    date: '2020-05-05',
    invoice_lines: [
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 87,
        total_line: 355.83,
        total_margin: 66.12,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 38,
        total_line: 111.72,
        total_margin: 25.840000000000003,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 16,
        total_line: 345.6,
        total_margin: 65.76,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 35,
        total_line: 1039.5,
        total_margin: 29.049999999999997,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 87,
        total_line: 2074.9500000000003,
        total_margin: 499.38,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 100,
        total_line: 1375,
        total_margin: 183,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 135,
        total_line: 434.70000000000005,
        total_margin: 35.1,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 110,
        total_line: 4183.3,
        total_margin: 168.3,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 77,
        total_line: 2954.49,
        total_margin: 257.95,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 113,
        total_line: 3839.74,
        total_margin: 822.64,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 84,
        total_line: 3209.64,
        total_margin: 741.72,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 15,
        total_line: 514.35,
        total_margin: 94.2,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 134,
        total_line: 2190.9,
        total_margin: 129.98,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 41,
        total_line: 355.88,
        total_margin: 29.52,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 56,
        total_line: 821.52,
        total_margin: 123.75999999999999,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 118,
        total_line: 3322.88,
        total_margin: 138.06,
      },
    ],
    total_invoice: 27130.000000000004,
    total_margin: 3410.3800000000006,
    region: 'India',
  },
  {
    id: 99,
    customer_id: 26,
    customer_name: 'Magda Castex',
    date: '2020-06-22',
    invoice_lines: [
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 85,
        total_line: 2659.65,
        total_margin: 547.4,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 16,
        total_line: 291.2,
        total_margin: 8.16,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 132,
        total_line: 4759.92,
        total_margin: 542.5200000000001,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 23,
        total_line: 1114.81,
        total_margin: 212.29000000000002,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 37,
        total_line: 1419.6899999999998,
        total_margin: 123.95,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 24,
        total_line: 392.40000000000003,
        total_margin: 23.28,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 137,
        total_line: 3857.92,
        total_margin: 160.29,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 61,
        total_line: 2762.08,
        total_margin: 274.5,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 2,
        total_line: 76.42,
        total_margin: 17.66,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 6,
        total_line: 115.56,
        total_margin: 15.36,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 104,
        total_line: 3566.16,
        total_margin: 653.12,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 3,
        total_line: 63.239999999999995,
        total_margin: 0.78,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 2,
        total_line: 63.08,
        total_margin: 1.32,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 109,
        total_line: 3735.4300000000003,
        total_margin: 489.41,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 92,
        total_line: 296.24,
        total_margin: 23.92,
      },
    ],
    total_invoice: 25173.800000000003,
    total_margin: 3093.96,
    region: 'Brazil',
  },
  {
    id: 100,
    customer_id: 30,
    customer_name: 'Jean Castex',
    date: '2020-06-24',
    invoice_lines: [
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 16,
        total_line: 265.6,
        total_margin: 6.4,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 12,
        total_line: 147.72,
        total_margin: 30.72,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 18,
        total_line: 649.08,
        total_margin: 73.98,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 78,
        total_line: 3410.9399999999996,
        total_margin: 780.78,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 45,
        total_line: 735.7500000000001,
        total_margin: 43.65,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 21,
        total_line: 61.74,
        total_margin: 14.280000000000001,
      },
    ],
    total_invoice: 5270.83,
    total_margin: 949.81,
    region: 'Europe',
  },
  {
    id: 101,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-03-12',
    invoice_lines: [
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 54,
        total_line: 1453.68,
        total_margin: 353.16,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 23,
        total_line: 496.8,
        total_margin: 94.53,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 59,
        total_line: 485.57000000000005,
        total_margin: 24.189999999999998,
      },
    ],
    total_invoice: 2436.05,
    total_margin: 471.88000000000005,
    region: 'India',
  },
  {
    id: 102,
    customer_id: 21,
    customer_name: 'Jack Cook',
    date: '2020-01-30',
    invoice_lines: [
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 57,
        total_line: 2167.71,
        total_margin: 87.21000000000001,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 131,
        total_line: 4451.379999999999,
        total_margin: 953.6800000000001,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 82,
        total_line: 1690.02,
        total_margin: 153.34,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 52,
        total_line: 914.1599999999999,
        total_margin: 151.32,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 111,
        total_line: 4241.31,
        total_margin: 980.13,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 87,
        total_line: 2983.23,
        total_margin: 546.36,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 148,
        total_line: 4167.68,
        total_margin: 173.16,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 2,
        total_line: 42.16,
        total_margin: 0.52,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 148,
        total_line: 5629.92,
        total_margin: 1012.3199999999999,
      },
    ],
    total_invoice: 26287.57,
    total_margin: 4058.04,
    region: 'Europe',
  },
  {
    id: 103,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-09-28',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 91,
        total_line: 4028.57,
        total_margin: 151.97,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 2,
        total_line: 22.6,
        total_margin: 5.5,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 82,
        total_line: 1492.3999999999999,
        total_margin: 41.82,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 83,
        total_line: 1749.6399999999999,
        total_margin: 21.580000000000002,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 64,
        total_line: 206.08,
        total_margin: 16.64,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 55,
        total_line: 913.55,
        total_margin: 113.85,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 119,
        total_line: 979.37,
        total_margin: 48.79,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 105,
        total_line: 1321.95,
        total_margin: 48.300000000000004,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 35,
        total_line: 954.4499999999999,
        total_margin: 229.6,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 79,
        total_line: 1291.65,
        total_margin: 76.63,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 99,
        total_line: 1785.9599999999998,
        total_margin: 283.14,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 1,
        total_line: 28.16,
        total_margin: 1.17,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 5,
        total_line: 20.45,
        total_margin: 3.8,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 15,
        total_line: 132.6,
        total_margin: 24.3,
      },
    ],
    total_invoice: 14927.43,
    total_margin: 1067.0900000000001,
    region: 'USA',
  },
  {
    id: 104,
    customer_id: 32,
    customer_name: 'John Muijs',
    date: '2020-08-19',
    invoice_lines: [
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 108,
        total_line: 4107.24,
        total_margin: 165.24,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 5,
        total_line: 191.85,
        total_margin: 16.75,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 23,
        total_line: 442.98,
        total_margin: 58.88,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 9,
        total_line: 431.01,
        total_margin: 71.55,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 121,
        total_line: 3786.0899999999997,
        total_margin: 779.24,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 15,
        total_line: 249.00000000000003,
        total_margin: 6,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 100,
        total_line: 1259,
        total_margin: 46,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 137,
        total_line: 2823.5699999999997,
        total_margin: 256.19,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 77,
        total_line: 247.94000000000003,
        total_margin: 20.02,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 60,
        total_line: 1892.3999999999999,
        total_margin: 39.6,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 115,
        total_line: 1299.5,
        total_margin: 316.25,
      },
    ],
    total_invoice: 16730.58,
    total_margin: 1775.72,
    region: 'Brazil',
  },
  {
    id: 105,
    customer_id: 7,
    customer_name: 'Jean Cook',
    date: '2020-08-16',
    invoice_lines: [
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 31,
        total_line: 454.77,
        total_margin: 68.51,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 107,
        total_line: 1286.1399999999999,
        total_margin: 249.31,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 21,
        total_line: 348.81,
        total_margin: 43.47,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 77,
        total_line: 3732.19,
        total_margin: 710.71,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 12,
        total_line: 218.39999999999998,
        total_margin: 6.12,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 32,
        total_line: 1097.28,
        total_margin: 200.96,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 100,
        total_line: 868,
        total_margin: 72,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 84,
        total_line: 1617.8400000000001,
        total_margin: 215.04,
      },
    ],
    total_invoice: 9623.43,
    total_margin: 1566.12,
    region: 'India',
  },
  {
    id: 106,
    customer_id: 21,
    customer_name: 'Jack Cook',
    date: '2020-01-03',
    invoice_lines: [
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 1,
        total_line: 21.08,
        total_margin: 0.26,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 134,
        total_line: 3773.44,
        total_margin: 156.78,
      },
    ],
    total_invoice: 3794.52,
    total_margin: 157.04,
    region: 'India',
  },
  {
    id: 107,
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    date: '2020-05-22',
    invoice_lines: [
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 96,
        total_line: 2703.36,
        total_margin: 112.32,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 18,
        total_line: 159.12,
        total_margin: 29.160000000000004,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 93,
        total_line: 2933.22,
        total_margin: 61.38,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 38,
        total_line: 621.3000000000001,
        total_margin: 36.86,
      },
    ],
    total_invoice: 6417,
    total_margin: 239.71999999999997,
    region: 'Australia',
  },
  {
    id: 108,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-12-09',
    invoice_lines: [
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 41,
        total_line: 1987.27,
        total_margin: 378.43,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 77,
        total_line: 1379.07,
        total_margin: 143.22,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 123,
        total_line: 4179.54,
        total_margin: 895.44,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 117,
        total_line: 2315.43,
        total_margin: 281.97,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 2,
        total_line: 76.74,
        total_margin: 6.7,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 91,
        total_line: 1093.82,
        total_margin: 212.03,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 50,
        total_line: 733.5,
        total_margin: 110.5,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 134,
        total_line: 1687.06,
        total_margin: 61.64,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 44,
        total_line: 381.91999999999996,
        total_margin: 31.68,
      },
    ],
    total_invoice: 13834.349999999999,
    total_margin: 2121.61,
    region: 'Europe',
  },
  {
    id: 109,
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    date: '2020-02-13',
    invoice_lines: [
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 66,
        total_line: 1425.6000000000001,
        total_margin: 271.26000000000005,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 45,
        total_line: 1543.05,
        total_margin: 282.6,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 146,
        total_line: 597.14,
        total_margin: 110.96000000000001,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 105,
        total_line: 2164.0499999999997,
        total_margin: 196.35000000000002,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 64,
        total_line: 880,
        total_margin: 117.12,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 2,
        total_line: 17.36,
        total_margin: 1.44,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 105,
        total_line: 1744.05,
        total_margin: 217.35,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 108,
        total_line: 1792.8000000000002,
        total_margin: 43.2,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 19,
        total_line: 281.2,
        total_margin: 15.010000000000002,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 127,
        total_line: 4829.81,
        total_margin: 194.31,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 93,
        total_line: 3353.5800000000004,
        total_margin: 382.23,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 138,
        total_line: 6688.86,
        total_margin: 1273.74,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 22,
        total_line: 599.9399999999999,
        total_margin: 144.32,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 1,
        total_line: 19.26,
        total_margin: 2.56,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 131,
        total_line: 4131.74,
        total_margin: 86.46000000000001,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 111,
        total_line: 3709.6200000000003,
        total_margin: 446.21999999999997,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 127,
        total_line: 6082.03,
        total_margin: 1009.65,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 142,
        total_line: 2561.68,
        total_margin: 406.12,
      },
    ],
    total_invoice: 42421.770000000004,
    total_margin: 5200.9,
    region: 'Europe',
  },
  {
    id: 110,
    customer_id: 20,
    customer_name: 'Magda Del Piero',
    date: '2020-05-09',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 117,
        total_line: 5179.59,
        total_margin: 195.39,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 26,
        total_line: 213.98000000000002,
        total_margin: 10.66,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 27,
        total_line: 646.11,
        total_margin: 33.21,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 55,
        total_line: 1188,
        total_margin: 226.05,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 14,
        total_line: 205.38,
        total_margin: 30.939999999999998,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 83,
        total_line: 937.9000000000001,
        total_margin: 228.25,
      },
    ],
    total_invoice: 8370.96,
    total_margin: 724.5,
    region: 'India',
  },
  {
    id: 111,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-07-06',
    invoice_lines: [
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 50,
        total_line: 204.5,
        total_margin: 38,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 148,
        total_line: 1410.4399999999998,
        total_margin: 136.16,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 97,
        total_line: 4701.59,
        total_margin: 895.3100000000001,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 104,
        total_line: 3088.7999999999997,
        total_margin: 86.32,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 64,
        total_line: 526.72,
        total_margin: 26.24,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 110,
        total_line: 2176.9,
        total_margin: 265.1,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 1,
        total_line: 38.04,
        total_margin: 6.84,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 82,
        total_line: 1340.7,
        total_margin: 79.53999999999999,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 52,
        total_line: 2302.04,
        total_margin: 86.84,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 41,
        total_line: 734.3100000000001,
        total_margin: 76.26,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 88,
        total_line: 1813.6799999999998,
        total_margin: 164.56,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 14,
        total_line: 381.78,
        total_margin: 91.83999999999999,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 72,
        total_line: 2738.16,
        total_margin: 110.16,
      },
    ],
    total_invoice: 21457.66,
    total_margin: 2063.1699999999996,
    region: 'USA',
  },
  {
    id: 112,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-02-01',
    invoice_lines: [
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 45,
        total_line: 553.95,
        total_margin: 115.2,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 109,
        total_line: 3410.61,
        total_margin: 701.96,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 147,
        total_line: 601.23,
        total_margin: 111.72,
      },
    ],
    total_invoice: 4565.790000000001,
    total_margin: 928.8800000000001,
    region: 'India',
  },
  {
    id: 113,
    customer_id: 27,
    customer_name: 'Daniels Jackson',
    date: '2020-10-24',
    invoice_lines: [
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 65,
        total_line: 1749.8000000000002,
        total_margin: 425.1,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 14,
        total_line: 619.7800000000001,
        total_margin: 23.38,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 22,
        total_line: 753.94,
        total_margin: 98.78,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 108,
        total_line: 3894.4800000000005,
        total_margin: 443.88000000000005,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 132,
        total_line: 425.04,
        total_margin: 34.32,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 34,
        total_line: 1539.52,
        total_margin: 153,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 125,
        total_line: 3942.5,
        total_margin: 82.5,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 109,
        total_line: 3069.44,
        total_margin: 127.52999999999999,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 139,
        total_line: 6881.889999999999,
        total_margin: 524.03,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 131,
        total_line: 6273.59,
        total_margin: 1041.45,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 145,
        total_line: 2869.5499999999997,
        total_margin: 349.45000000000005,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 48,
        total_line: 2326.56,
        total_margin: 443.04,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 121,
        total_line: 494.89,
        total_margin: 91.96000000000001,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 99,
        total_line: 1452.33,
        total_margin: 218.79,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 67,
        total_line: 2570.79,
        total_margin: 224.45000000000002,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 74,
        total_line: 816.2199999999999,
        total_margin: 69.56,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 100,
        total_line: 952.9999999999999,
        total_margin: 92,
      },
    ],
    total_invoice: 40633.32,
    total_margin: 4443.22,
    region: 'Brazil',
  },
  {
    id: 114,
    customer_id: 21,
    customer_name: 'Jack Cook',
    date: '2020-05-26',
    invoice_lines: [
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 47,
        total_line: 689.49,
        total_margin: 103.87,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 128,
        total_line: 4005.12,
        total_margin: 824.32,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 117,
        total_line: 4009.59,
        total_margin: 525.33,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 64,
        total_line: 3064.96,
        total_margin: 508.8,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 7,
        total_line: 66.71,
        total_margin: 6.44,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 11,
        total_line: 486.97,
        total_margin: 18.369999999999997,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 96,
        total_line: 1208.6399999999999,
        total_margin: 44.160000000000004,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 140,
        total_line: 3768.8,
        total_margin: 915.6,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 89,
        total_line: 1714.14,
        total_margin: 227.84,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 91,
        total_line: 1656.2,
        total_margin: 46.410000000000004,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 122,
        total_line: 2571.7599999999998,
        total_margin: 31.720000000000002,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 35,
        total_line: 581,
        total_margin: 14,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 54,
        total_line: 2054.16,
        total_margin: 369.36,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 41,
        total_line: 1478.46,
        total_margin: 168.51000000000002,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 86,
        total_line: 1272.8,
        total_margin: 67.94,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 138,
        total_line: 2256.3,
        total_margin: 133.85999999999999,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 114,
        total_line: 1403.3400000000001,
        total_margin: 291.84000000000003,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 78,
        total_line: 1396.98,
        total_margin: 145.08,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 2,
        total_line: 47.7,
        total_margin: 11.48,
      },
    ],
    total_invoice: 33733.119999999995,
    total_margin: 4454.929999999999,
    region: 'Europe',
  },
  {
    id: 115,
    customer_id: 9,
    customer_name: 'Daniels Martins',
    date: '2020-01-21',
    invoice_lines: [
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 75,
        total_line: 2548.4999999999995,
        total_margin: 546,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 66,
        total_line: 745.8000000000001,
        total_margin: 181.5,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 149,
        total_line: 7135.61,
        total_margin: 1184.55,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 59,
        total_line: 241.31,
        total_margin: 44.84,
      },
    ],
    total_invoice: 10671.22,
    total_margin: 1956.8899999999999,
    region: 'Australia',
  },
  {
    id: 116,
    customer_id: 31,
    customer_name: 'Martijn Castex',
    date: '2020-03-15',
    invoice_lines: [
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 78,
        total_line: 1543.62,
        total_margin: 187.98000000000002,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 129,
        total_line: 4311.18,
        total_margin: 518.5799999999999,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 91,
        total_line: 293.02000000000004,
        total_margin: 23.66,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 21,
        total_line: 343.35,
        total_margin: 20.37,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 51,
        total_line: 2257.77,
        total_margin: 85.17,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 127,
        total_line: 373.38,
        total_margin: 86.36,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 94,
        total_line: 1062.2,
        total_margin: 258.5,
      },
    ],
    total_invoice: 10184.52,
    total_margin: 1180.62,
    region: 'Australia',
  },
  {
    id: 117,
    customer_id: 12,
    customer_name: 'Trisha Wu',
    date: '2020-08-18',
    invoice_lines: [
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 90,
        total_line: 992.6999999999999,
        total_margin: 84.6,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 90,
        total_line: 1494.0000000000002,
        total_margin: 36,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 90,
        total_line: 3423.6,
        total_margin: 615.6,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 57,
        total_line: 543.2099999999999,
        total_margin: 52.440000000000005,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 99,
        total_line: 4798.53,
        total_margin: 913.7700000000001,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 70,
        total_line: 1144.5,
        total_margin: 67.89999999999999,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 91,
        total_line: 3281.46,
        total_margin: 374.01000000000005,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 41,
        total_line: 885.6,
        total_margin: 168.51000000000002,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 116,
        total_line: 5135.320000000001,
        total_margin: 193.72,
      },
    ],
    total_invoice: 21698.92,
    total_margin: 2506.5500000000006,
    region: 'Australia',
  },
  {
    id: 118,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-05-21',
    invoice_lines: [
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 148,
        total_line: 2650.68,
        total_margin: 275.28000000000003,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 132,
        total_line: 3148.2000000000003,
        total_margin: 757.6800000000001,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 33,
        total_line: 271.59000000000003,
        total_margin: 13.53,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 132,
        total_line: 6398.04,
        total_margin: 1218.3600000000001,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 96,
        total_line: 282.24,
        total_margin: 65.28,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 93,
        total_line: 3537.72,
        total_margin: 636.12,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 116,
        total_line: 3266.56,
        total_margin: 135.72,
      },
    ],
    total_invoice: 19555.03,
    total_margin: 3101.9700000000003,
    region: 'Europe',
  },
  {
    id: 119,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-02-02',
    invoice_lines: [
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 149,
        total_line: 4979.58,
        total_margin: 598.9799999999999,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 91,
        total_line: 1875.51,
        total_margin: 170.17000000000002,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 30,
        total_line: 1311.8999999999999,
        total_margin: 300.3,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 147,
        total_line: 5300.820000000001,
        total_margin: 604.1700000000001,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 62,
        total_line: 1029.82,
        total_margin: 128.34,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 51,
        total_line: 627.8100000000001,
        total_margin: 130.56,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 85,
        total_line: 2912.9500000000003,
        total_margin: 381.65000000000003,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 123,
        total_line: 2162.3399999999997,
        total_margin: 357.93,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 133,
        total_line: 6022.24,
        total_margin: 598.5,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 30,
        total_line: 715.5,
        total_margin: 172.20000000000002,
      },
    ],
    total_invoice: 26938.47,
    total_margin: 3442.7999999999993,
    region: 'Australia',
  },
  {
    id: 120,
    customer_id: 11,
    customer_name: 'Jean Martins',
    date: '2020-10-25',
    invoice_lines: [
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 116,
        total_line: 1925.6000000000001,
        total_margin: 46.400000000000006,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 52,
        total_line: 1001.5200000000001,
        total_margin: 133.12,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 15,
        total_line: 222,
        total_margin: 11.850000000000001,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 51,
        total_line: 2309.28,
        total_margin: 229.5,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 94,
        total_line: 3389.6400000000003,
        total_margin: 386.34000000000003,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 128,
        total_line: 2092.8,
        total_margin: 124.16,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 10,
        total_line: 272.7,
        total_margin: 65.6,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 131,
        total_line: 3890.7,
        total_margin: 108.72999999999999,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 24,
        total_line: 288.48,
        total_margin: 55.92,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 10,
        total_line: 110.3,
        total_margin: 9.399999999999999,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 20,
        total_line: 364,
        total_margin: 10.2,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 90,
        total_line: 3438.9,
        total_margin: 794.7,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 21,
        total_line: 237.3,
        total_margin: 57.75,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 22,
        total_line: 394.02,
        total_margin: 40.92,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 90,
        total_line: 3086.1,
        total_margin: 565.2,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 39,
        total_line: 491.01,
        total_margin: 17.94,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 122,
        total_line: 4145.5599999999995,
        total_margin: 888.1600000000001,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 114,
        total_line: 335.15999999999997,
        total_margin: 77.52000000000001,
      },
    ],
    total_invoice: 27995.069999999996,
    total_margin: 3623.4100000000003,
    region: 'USA',
  },
  {
    id: 121,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-01-02',
    invoice_lines: [
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 19,
        total_line: 376.01,
        total_margin: 45.790000000000006,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 148,
        total_line: 2601.8399999999997,
        total_margin: 430.68,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 56,
        total_line: 164.64,
        total_margin: 38.080000000000005,
      },
    ],
    total_invoice: 3142.4899999999993,
    total_margin: 514.5500000000001,
    region: 'India',
  },
  {
    id: 122,
    customer_id: 12,
    customer_name: 'Trisha Wu',
    date: '2020-01-05',
    invoice_lines: [
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 59,
        total_line: 666.7,
        total_margin: 162.25,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 38,
        total_line: 362.14,
        total_margin: 34.96,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 138,
        total_line: 2980.8,
        total_margin: 567.1800000000001,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 137,
        total_line: 2887.9599999999996,
        total_margin: 35.620000000000005,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 102,
        total_line: 3495.5400000000004,
        total_margin: 457.98,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 42,
        total_line: 371.28,
        total_margin: 68.04,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 18,
        total_line: 687.78,
        total_margin: 158.94,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 8,
        total_line: 25.76,
        total_margin: 2.08,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 77,
        total_line: 1139.6000000000001,
        total_margin: 60.830000000000005,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 144,
        total_line: 2354.4,
        total_margin: 139.68,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 76,
        total_line: 2582.4799999999996,
        total_margin: 553.28,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 87,
        total_line: 4166.43,
        total_margin: 691.65,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 63,
        total_line: 2105.46,
        total_margin: 253.25999999999996,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 66,
        total_line: 194.04,
        total_margin: 44.88,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 95,
        total_line: 388.55,
        total_margin: 72.2,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 126,
        total_line: 4793.04,
        total_margin: 861.84,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 141,
        total_line: 2068.47,
        total_margin: 311.61,
      },
    ],
    total_invoice: 31270.430000000004,
    total_margin: 4476.28,
    region: 'Brazil',
  },
  {
    id: 123,
    customer_id: 24,
    customer_name: 'Pablo Mohaman',
    date: '2020-04-12',
    invoice_lines: [
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 49,
        total_line: 540.4699999999999,
        total_margin: 46.059999999999995,
      },
    ],
    total_invoice: 540.4699999999999,
    total_margin: 46.059999999999995,
    region: 'Australia',
  },
  {
    id: 124,
    customer_id: 26,
    customer_name: 'Magda Castex',
    date: '2020-01-29',
    invoice_lines: [
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 87,
        total_line: 2722.23,
        total_margin: 560.2800000000001,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 31,
        total_line: 544.9799999999999,
        total_margin: 90.21000000000001,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 6,
        total_line: 19.32,
        total_margin: 1.56,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 144,
        total_line: 2354.4,
        total_margin: 139.68,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 89,
        total_line: 261.65999999999997,
        total_margin: 60.52,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 134,
        total_line: 4478.280000000001,
        total_margin: 538.68,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 92,
        total_line: 1647.72,
        total_margin: 171.12,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 136,
        total_line: 5172.08,
        total_margin: 208.08,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 25,
        total_line: 455,
        total_margin: 12.75,
      },
    ],
    total_invoice: 17655.67,
    total_margin: 1782.8799999999997,
    region: 'USA',
  },
  {
    id: 125,
    customer_id: 18,
    customer_name: 'Jack Wu',
    date: '2020-10-03',
    invoice_lines: [
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 19,
        total_line: 722.57,
        total_margin: 29.07,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 44,
        total_line: 605,
        total_margin: 80.52000000000001,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 42,
        total_line: 1597.68,
        total_margin: 287.28,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 135,
        total_line: 5976.450000000001,
        total_margin: 225.45,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 86,
        total_line: 948.5799999999999,
        total_margin: 80.83999999999999,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 126,
        total_line: 1864.8000000000002,
        total_margin: 99.54,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 7,
        total_line: 86.17,
        total_margin: 17.92,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 77,
        total_line: 2640.33,
        total_margin: 483.56,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 57,
        total_line: 183.54000000000002,
        total_margin: 14.82,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 46,
        total_line: 1658.7600000000002,
        total_margin: 189.06,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 129,
        total_line: 6386.79,
        total_margin: 486.33,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 5,
        total_line: 157.7,
        total_margin: 3.3000000000000003,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 27,
        total_line: 448.46999999999997,
        total_margin: 55.88999999999999,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 148,
        total_line: 2601.8399999999997,
        total_margin: 430.68,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 56,
        total_line: 1108.24,
        total_margin: 134.96,
      },
    ],
    total_invoice: 26986.920000000006,
    total_margin: 2619.2199999999993,
    region: 'Europe',
  },
  {
    id: 126,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-12-18',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 86,
        total_line: 3807.2200000000003,
        total_margin: 143.62,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 14,
        total_line: 168.28,
        total_margin: 32.620000000000005,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 50,
        total_line: 1577,
        total_margin: 33,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 124,
        total_line: 3682.7999999999997,
        total_margin: 102.92,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 58,
        total_line: 1814.82,
        total_margin: 373.52000000000004,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 89,
        total_line: 1095.5900000000001,
        total_margin: 227.84,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 50,
        total_line: 687.5,
        total_margin: 91.5,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 21,
        total_line: 720.09,
        total_margin: 131.88,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 123,
        total_line: 2162.3399999999997,
        total_margin: 357.93,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 137,
        total_line: 1127.51,
        total_margin: 56.169999999999995,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 1,
        total_line: 8.84,
        total_margin: 1.62,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 99,
        total_line: 859.3199999999999,
        total_margin: 71.28,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 135,
        total_line: 1286.55,
        total_margin: 124.2,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 51,
        total_line: 846.6,
        total_margin: 20.400000000000002,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 67,
        total_line: 2296.09,
        total_margin: 300.83000000000004,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 130,
        total_line: 4988.099999999999,
        total_margin: 435.5,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 3,
        total_line: 53.730000000000004,
        total_margin: 5.58,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 133,
        total_line: 2561.5800000000004,
        total_margin: 340.48,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 79,
        total_line: 1563.4099999999999,
        total_margin: 190.39000000000001,
      },
    ],
    total_invoice: 31307.369999999995,
    total_margin: 3041.28,
    region: 'India',
  },
  {
    id: 127,
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    date: '2020-09-16',
    invoice_lines: [
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 136,
        total_line: 2475.2,
        total_margin: 69.36,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 65,
        total_line: 1404,
        total_margin: 267.15000000000003,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 145,
        total_line: 4537.05,
        total_margin: 933.8000000000001,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 66,
        total_line: 2242.68,
        total_margin: 480.48,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 100,
        total_line: 1467,
        total_margin: 221,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 100,
        total_line: 2108,
        total_margin: 26,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 136,
        total_line: 2435.76,
        total_margin: 252.96,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 126,
        total_line: 4320.54,
        total_margin: 791.2800000000001,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 95,
        total_line: 1829.7,
        total_margin: 243.20000000000002,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 123,
        total_line: 1067.6399999999999,
        total_margin: 88.56,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 145,
        total_line: 5540.45,
        total_margin: 1280.35,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 123,
        total_line: 2218.92,
        total_margin: 351.78,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 78,
        total_line: 2967.12,
        total_margin: 533.52,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 49,
        total_line: 861.42,
        total_margin: 142.59,
      },
    ],
    total_invoice: 35475.48,
    total_margin: 5682.029999999999,
    region: 'India',
  },
  {
    id: 128,
    customer_id: 35,
    customer_name: 'Daniels Martins',
    date: '2020-12-07',
    invoice_lines: [
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 67,
        total_line: 2297.43,
        total_margin: 420.76,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 67,
        total_line: 2113.18,
        total_margin: 44.22,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 112,
        total_line: 5428.639999999999,
        total_margin: 1033.76,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 4,
        total_line: 58.68,
        total_margin: 8.84,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 117,
        total_line: 3910.1400000000003,
        total_margin: 470.34,
      },
    ],
    total_invoice: 13808.07,
    total_margin: 1977.9199999999998,
    region: 'India',
  },
  {
    id: 129,
    customer_id: 5,
    customer_name: 'Tim Smith',
    date: '2020-05-14',
    invoice_lines: [
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 33,
        total_line: 1260.93,
        total_margin: 291.39,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 56,
        total_line: 164.64,
        total_margin: 38.080000000000005,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 34,
        total_line: 1683.34,
        total_margin: 128.18,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 102,
        total_line: 2018.58,
        total_margin: 245.82000000000002,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 105,
        total_line: 1000.65,
        total_margin: 96.60000000000001,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 103,
        total_line: 1163.9,
        total_margin: 283.25,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 22,
        total_line: 386.76,
        total_margin: 64.02000000000001,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 50,
        total_line: 1577,
        total_margin: 33,
      },
    ],
    total_invoice: 9255.8,
    total_margin: 1180.3400000000001,
    region: 'India',
  },
  {
    id: 130,
    customer_id: 20,
    customer_name: 'Magda Del Piero',
    date: '2020-10-31',
    invoice_lines: [
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 60,
        total_line: 2873.4,
        total_margin: 477,
      },
    ],
    total_invoice: 2873.4,
    total_margin: 477,
    region: 'Brazil',
  },
  {
    id: 131,
    customer_id: 30,
    customer_name: 'Jean Castex',
    date: '2020-06-09',
    invoice_lines: [
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 36,
        total_line: 758.8799999999999,
        total_margin: 9.36,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 10,
        total_line: 360.6,
        total_margin: 41.1,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 143,
        total_line: 4900.610000000001,
        total_margin: 642.07,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 4,
        total_line: 86.4,
        total_margin: 16.44,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 45,
        total_line: 666,
        total_margin: 35.550000000000004,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 133,
        total_line: 1637.23,
        total_margin: 340.48,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 146,
        total_line: 1290.6399999999999,
        total_margin: 236.52,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 23,
        total_line: 1041.44,
        total_margin: 103.5,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 81,
        total_line: 703.0799999999999,
        total_margin: 58.32,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 85,
        total_line: 810.05,
        total_margin: 78.2,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 48,
        total_line: 2124.96,
        total_margin: 80.16,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 27,
        total_line: 1308.69,
        total_margin: 249.21,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 47,
        total_line: 1611.6299999999999,
        total_margin: 295.16,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 128,
        total_line: 4349.44,
        total_margin: 931.84,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 111,
        total_line: 2647.3500000000004,
        total_margin: 637.14,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 11,
        total_line: 309.76,
        total_margin: 12.87,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 115,
        total_line: 1299.5,
        total_margin: 316.25,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 137,
        total_line: 5991.009999999999,
        total_margin: 1371.37,
      },
    ],
    total_invoice: 31897.269999999997,
    total_margin: 5455.54,
    region: 'Australia',
  },
  {
    id: 132,
    customer_id: 7,
    customer_name: 'Jean Cook',
    date: '2020-10-01',
    invoice_lines: [
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 81,
        total_line: 1461.24,
        total_margin: 231.66,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 50,
        total_line: 2394.5,
        total_margin: 397.5,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 66,
        total_line: 212.52,
        total_margin: 17.16,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 145,
        total_line: 6340.849999999999,
        total_margin: 1451.45,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 26,
        total_line: 357.5,
        total_margin: 47.58,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 48,
        total_line: 1292.16,
        total_margin: 313.92,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 118,
        total_line: 2335.22,
        total_margin: 284.38,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 110,
        total_line: 1933.7999999999997,
        total_margin: 320.1,
      },
    ],
    total_invoice: 16327.789999999997,
    total_margin: 3063.75,
    region: 'India',
  },
  {
    id: 133,
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    date: '2020-07-12',
    invoice_lines: [
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 15,
        total_line: 509.69999999999993,
        total_margin: 109.2,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 142,
        total_line: 5120.52,
        total_margin: 583.62,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 136,
        total_line: 3661.1200000000003,
        total_margin: 889.44,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 37,
        total_line: 614.5699999999999,
        total_margin: 76.58999999999999,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 34,
        total_line: 618.8,
        total_margin: 17.34,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 142,
        total_line: 7030.42,
        total_margin: 535.34,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 147,
        total_line: 3517.71,
        total_margin: 180.81,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 86,
        total_line: 252.84,
        total_margin: 58.480000000000004,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 84,
        total_line: 3803.52,
        total_margin: 378,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 134,
        total_line: 1610.6799999999998,
        total_margin: 312.22,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 129,
        total_line: 4068.66,
        total_margin: 85.14,
      },
    ],
    total_invoice: 30808.539999999997,
    total_margin: 3226.18,
    region: 'Brazil',
  },
  {
    id: 134,
    customer_id: 14,
    customer_name: 'Magda Jackson',
    date: '2020-10-23',
    invoice_lines: [
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 16,
        total_line: 261.6,
        total_margin: 15.52,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 4,
        total_line: 174.92,
        total_margin: 40.04,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 25,
        total_line: 455,
        total_margin: 12.75,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 47,
        total_line: 905.22,
        total_margin: 120.32000000000001,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 104,
        total_line: 2192.3199999999997,
        total_margin: 27.04,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 97,
        total_line: 1749.8799999999999,
        total_margin: 277.42,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 30,
        total_line: 360.59999999999997,
        total_margin: 69.9,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 8,
        total_line: 70.72,
        total_margin: 12.96,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 28,
        total_line: 1340.92,
        total_margin: 222.6,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 105,
        total_line: 1554,
        total_margin: 82.95,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 60,
        total_line: 1431,
        total_margin: 344.40000000000003,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 41,
        total_line: 167.69,
        total_margin: 31.16,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 82,
        total_line: 2309.12,
        total_margin: 95.94,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 11,
        total_line: 422.07,
        total_margin: 36.85,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 35,
        total_line: 1337.3500000000001,
        total_margin: 309.05,
      },
    ],
    total_invoice: 14732.410000000002,
    total_margin: 1698.9,
    region: 'India',
  },
  {
    id: 135,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-03-08',
    invoice_lines: [
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 56,
        total_line: 1902.8799999999999,
        total_margin: 407.68,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 132,
        total_line: 4523.64,
        total_margin: 592.6800000000001,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 132,
        total_line: 3148.2000000000003,
        total_margin: 757.6800000000001,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 143,
        total_line: 7079.929999999999,
        total_margin: 539.11,
      },
    ],
    total_invoice: 16654.65,
    total_margin: 2297.15,
    region: 'India',
  },
  {
    id: 136,
    customer_id: 13,
    customer_name: 'Mike Jackson',
    date: '2020-08-24',
    invoice_lines: [
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 36,
        total_line: 1369.44,
        total_margin: 246.24,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 42,
        total_line: 577.5,
        total_margin: 76.86,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 139,
        total_line: 6656.71,
        total_margin: 1105.05,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 43,
        total_line: 713.8000000000001,
        total_margin: 17.2,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 46,
        total_line: 399.28,
        total_margin: 33.12,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 107,
        total_line: 1569.69,
        total_margin: 236.47,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 45,
        total_line: 866.7,
        total_margin: 115.2,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 23,
        total_line: 548.5500000000001,
        total_margin: 132.02,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 87,
        total_line: 2956.2599999999998,
        total_margin: 633.36,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 4,
        total_line: 198.04,
        total_margin: 15.08,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 101,
        total_line: 3375.42,
        total_margin: 406.02,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 21,
        total_line: 382.2,
        total_margin: 10.71,
      },
    ],
    total_invoice: 19613.59,
    total_margin: 3027.33,
    region: 'India',
  },
  {
    id: 137,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-07-21',
    invoice_lines: [
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 58,
        total_line: 2206.32,
        total_margin: 396.71999999999997,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 8,
        total_line: 271.84,
        total_margin: 58.24,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 17,
        total_line: 457.64000000000004,
        total_margin: 111.18,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 49,
        total_line: 1058.4,
        total_margin: 201.39000000000001,
      },
    ],
    total_invoice: 3994.2000000000003,
    total_margin: 767.53,
    region: 'Australia',
  },
  {
    id: 138,
    customer_id: 26,
    customer_name: 'Magda Castex',
    date: '2020-04-19',
    invoice_lines: [
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 8,
        total_line: 132.88,
        total_margin: 16.56,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 98,
        total_line: 4750.0599999999995,
        total_margin: 904.5400000000001,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 20,
        total_line: 296,
        total_margin: 15.8,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 92,
        total_line: 3515.32,
        total_margin: 812.36,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 50,
        total_line: 2213.5,
        total_margin: 83.5,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 6,
        total_line: 115.56,
        total_margin: 15.36,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 4,
        total_line: 71.64,
        total_margin: 7.44,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 26,
        total_line: 425.1,
        total_margin: 25.22,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 88,
        total_line: 838.64,
        total_margin: 80.96000000000001,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 48,
        total_line: 416.64,
        total_margin: 34.56,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 7,
        total_line: 207.9,
        total_margin: 5.81,
      },
    ],
    total_invoice: 12983.239999999998,
    total_margin: 2002.11,
    region: 'Europe',
  },
  {
    id: 139,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-12-21',
    invoice_lines: [
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 131,
        total_line: 2384.2,
        total_margin: 66.81,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 29,
        total_line: 1102.8700000000001,
        total_margin: 44.37,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 49,
        total_line: 157.78,
        total_margin: 12.74,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 92,
        total_line: 2901.68,
        total_margin: 60.720000000000006,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 86,
        total_line: 3286.06,
        total_margin: 759.38,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 148,
        total_line: 5071.96,
        total_margin: 664.52,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 52,
        total_line: 625.04,
        total_margin: 121.16,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 71,
        total_line: 1178.6000000000001,
        total_margin: 28.400000000000002,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 10,
        total_line: 380.4,
        total_margin: 68.4,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 123,
        total_line: 1087.32,
        total_margin: 199.26000000000002,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 96,
        total_line: 3683.5199999999995,
        total_margin: 321.6,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 54,
        total_line: 974.16,
        total_margin: 154.44,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 132,
        total_line: 2364.12,
        total_margin: 245.52,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 56,
        total_line: 2714.3199999999997,
        total_margin: 516.88,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 91,
        total_line: 1251.25,
        total_margin: 166.53,
      },
    ],
    total_invoice: 29163.28,
    total_margin: 3430.7300000000005,
    region: 'USA',
  },
  {
    id: 140,
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    date: '2020-10-28',
    invoice_lines: [
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 117,
        total_line: 3474.9,
        total_margin: 97.11,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 118,
        total_line: 4009.6399999999994,
        total_margin: 859.0400000000001,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 100,
        total_line: 1661,
        total_margin: 206.99999999999997,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 49,
        total_line: 425.32,
        total_margin: 35.28,
      },
    ],
    total_invoice: 9570.859999999999,
    total_margin: 1198.43,
    region: 'USA',
  },
  {
    id: 141,
    customer_id: 28,
    customer_name: 'Allan Cook',
    date: '2020-07-26',
    invoice_lines: [
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 141,
        total_line: 4832.070000000001,
        total_margin: 633.09,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 8,
        total_line: 98.48,
        total_margin: 20.48,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 124,
        total_line: 4251.96,
        total_margin: 778.72,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 52,
        total_line: 1001.5200000000001,
        total_margin: 133.12,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 121,
        total_line: 1775.07,
        total_margin: 267.40999999999997,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 132,
        total_line: 3148.2000000000003,
        total_margin: 757.6800000000001,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 80,
        total_line: 3877.6,
        total_margin: 738.4000000000001,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 96,
        total_line: 4198.08,
        total_margin: 960.96,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 144,
        total_line: 1272.96,
        total_margin: 233.28000000000003,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 2,
        total_line: 72.12,
        total_margin: 8.22,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 118,
        total_line: 1024.24,
        total_margin: 84.96,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 9,
        total_line: 342.27,
        total_margin: 13.77,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 65,
        total_line: 534.95,
        total_margin: 26.65,
      },
    ],
    total_invoice: 26429.520000000004,
    total_margin: 4656.740000000001,
    region: 'Brazil',
  },
  {
    id: 142,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-05-24',
    invoice_lines: [
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 93,
        total_line: 1278.75,
        total_margin: 170.19,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 57,
        total_line: 503.88,
        total_margin: 92.34,
      },
    ],
    total_invoice: 1782.63,
    total_margin: 262.53,
    region: 'Brazil',
  },
  {
    id: 143,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-08-14',
    invoice_lines: [
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 77,
        total_line: 314.93,
        total_margin: 58.52,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 74,
        total_line: 2473.08,
        total_margin: 297.47999999999996,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 129,
        total_line: 2109.15,
        total_margin: 125.13,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 148,
        total_line: 2601.8399999999997,
        total_margin: 430.68,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 145,
        total_line: 2639,
        total_margin: 73.95,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 138,
        total_line: 2844.18,
        total_margin: 258.06,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 110,
        total_line: 4203.1,
        total_margin: 971.3,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 78,
        total_line: 1644.2399999999998,
        total_margin: 20.28,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 19,
        total_line: 535.04,
        total_margin: 22.229999999999997,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 93,
        total_line: 1791.18,
        total_margin: 238.08,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 146,
        total_line: 6463.42,
        total_margin: 243.82,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 41,
        total_line: 1393.1799999999998,
        total_margin: 298.48,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 61,
        total_line: 750.9100000000001,
        total_margin: 156.16,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 90,
        total_line: 1494.8999999999999,
        total_margin: 186.29999999999998,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 6,
        total_line: 178.2,
        total_margin: 4.9799999999999995,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 35,
        total_line: 581,
        total_margin: 14,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 134,
        total_line: 2399.94,
        total_margin: 249.24,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 131,
        total_line: 421.82000000000005,
        total_margin: 34.06,
      },
    ],
    total_invoice: 34839.11,
    total_margin: 3682.7500000000005,
    region: 'USA',
  },
  {
    id: 144,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-08-28',
    invoice_lines: [
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 116,
        total_line: 2295.64,
        total_margin: 279.56,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 92,
        total_line: 2901.68,
        total_margin: 60.720000000000006,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 74,
        total_line: 1095.2,
        total_margin: 58.46,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 24,
        total_line: 392.40000000000003,
        total_margin: 23.28,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 2,
        total_line: 43.2,
        total_margin: 8.22,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 3,
        total_line: 131.19,
        total_margin: 30.03,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 42,
        total_line: 2035.74,
        total_margin: 387.66,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 60,
        total_line: 721.1999999999999,
        total_margin: 139.8,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 113,
        total_line: 1246.3899999999999,
        total_margin: 106.22,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 3,
        total_line: 114.63,
        total_margin: 26.490000000000002,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 55,
        total_line: 1001,
        total_margin: 28.05,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 71,
        total_line: 1463.31,
        total_margin: 132.77,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 117,
        total_line: 5179.59,
        total_margin: 195.39,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 8,
        total_line: 190.8,
        total_margin: 45.92,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 78,
        total_line: 2099.76,
        total_margin: 510.12,
      },
    ],
    total_invoice: 20911.729999999996,
    total_margin: 2032.69,
    region: 'USA',
  },
  {
    id: 145,
    customer_id: 28,
    customer_name: 'Allan Cook',
    date: '2020-11-25',
    invoice_lines: [
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 32,
        total_line: 1584.32,
        total_margin: 120.64,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 105,
        total_line: 3786.3,
        total_margin: 431.55,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 17,
        total_line: 233.75,
        total_margin: 31.11,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 75,
        total_line: 1100.25,
        total_margin: 165.75,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 124,
        total_line: 2256.7999999999997,
        total_margin: 63.24,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 139,
        total_line: 1570.7,
        total_margin: 382.25,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 4,
        total_line: 125.16,
        total_margin: 25.76,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 112,
        total_line: 4897.759999999999,
        total_margin: 1121.12,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 26,
        total_line: 213.98000000000002,
        total_margin: 10.66,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 25,
        total_line: 370,
        total_margin: 19.75,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 15,
        total_line: 358.95,
        total_margin: 18.45,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 68,
        total_line: 1129.48,
        total_margin: 140.76,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 124,
        total_line: 4251.96,
        total_margin: 778.72,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 29,
        total_line: 1283.8300000000002,
        total_margin: 48.43,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 63,
        total_line: 2159.01,
        total_margin: 282.87,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 65,
        total_line: 1079,
        total_margin: 26,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 42,
        total_line: 1182.72,
        total_margin: 49.14,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 69,
        total_line: 1881.6299999999999,
        total_margin: 452.64,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 107,
        total_line: 4069.21,
        total_margin: 163.71,
      },
    ],
    total_invoice: 33534.810000000005,
    total_margin: 4332.55,
    region: 'India',
  },
  {
    id: 146,
    customer_id: 20,
    customer_name: 'Magda Del Piero',
    date: '2020-07-01',
    invoice_lines: [
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 114,
        total_line: 1892.4,
        total_margin: 45.6,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 148,
        total_line: 2458.2799999999997,
        total_margin: 306.35999999999996,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 98,
        total_line: 2672.46,
        total_margin: 642.88,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 27,
        total_line: 917.4599999999999,
        total_margin: 196.56,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 149,
        total_line: 2048.75,
        total_margin: 272.67,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 77,
        total_line: 1258.95,
        total_margin: 74.69,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 108,
        total_line: 2080.0800000000004,
        total_margin: 276.48,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 149,
        total_line: 3565.57,
        total_margin: 183.27,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 114,
        total_line: 1370.28,
        total_margin: 265.62,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 128,
        total_line: 1053.44,
        total_margin: 52.48,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 102,
        total_line: 1826.82,
        total_margin: 189.72,
      },
    ],
    total_invoice: 21144.489999999998,
    total_margin: 2506.33,
    region: 'Brazil',
  },
  {
    id: 147,
    customer_id: 3,
    customer_name: 'John Wu',
    date: '2020-06-08',
    invoice_lines: [
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 129,
        total_line: 5641.169999999999,
        total_margin: 1291.29,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 43,
        total_line: 1345.47,
        total_margin: 276.92,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 22,
        total_line: 242.66,
        total_margin: 20.68,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 69,
        total_line: 1422.09,
        total_margin: 129.03,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 28,
        total_line: 951.4399999999999,
        total_margin: 203.84,
      },
    ],
    total_invoice: 9602.83,
    total_margin: 1921.76,
    region: 'USA',
  },
  {
    id: 148,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-07-05',
    invoice_lines: [
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 41,
        total_line: 670.35,
        total_margin: 39.769999999999996,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 75,
        total_line: 923.25,
        total_margin: 192,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 145,
        total_line: 4537.05,
        total_margin: 933.8000000000001,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 3,
        total_line: 101.94,
        total_margin: 21.84,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 75,
        total_line: 2877.75,
        total_margin: 251.25,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 44,
        total_line: 2107.16,
        total_margin: 349.8,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 12,
        total_line: 543.36,
        total_margin: 54,
      },
    ],
    total_invoice: 11760.86,
    total_margin: 1842.46,
    region: 'USA',
  },
  {
    id: 149,
    customer_id: 22,
    customer_name: 'Martin Cook',
    date: '2020-07-09',
    invoice_lines: [
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 137,
        total_line: 2408.4599999999996,
        total_margin: 398.67,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 134,
        total_line: 1649.54,
        total_margin: 343.04,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 106,
        total_line: 3542.52,
        total_margin: 426.11999999999995,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 36,
        total_line: 741.96,
        total_margin: 67.32000000000001,
      },
    ],
    total_invoice: 8342.48,
    total_margin: 1235.1499999999999,
    region: 'Brazil',
  },
  {
    id: 150,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-06-22',
    invoice_lines: [
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 61,
        total_line: 689.3000000000001,
        total_margin: 167.75,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 56,
        total_line: 1919.1200000000001,
        total_margin: 251.44,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 104,
        total_line: 1250.08,
        total_margin: 242.32,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 117,
        total_line: 962.9100000000001,
        total_margin: 47.97,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 102,
        total_line: 1509.6000000000001,
        total_margin: 80.58,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 31,
        total_line: 1053.3799999999999,
        total_margin: 225.68,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 103,
        total_line: 2808.81,
        total_margin: 675.68,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 134,
        total_line: 1965.78,
        total_margin: 296.14,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 109,
        total_line: 1782.15,
        total_margin: 105.73,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 120,
        total_line: 3564,
        total_margin: 99.6,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 50,
        total_line: 1564.5,
        total_margin: 322,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 5,
        total_line: 96.30000000000001,
        total_margin: 12.8,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 101,
        total_line: 1775.58,
        total_margin: 293.91,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 136,
        total_line: 399.84,
        total_margin: 92.48,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 74,
        total_line: 642.3199999999999,
        total_margin: 53.28,
      },
    ],
    total_invoice: 21983.670000000002,
    total_margin: 2967.36,
    region: 'Europe',
  },
  {
    id: 151,
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    date: '2020-05-23',
    invoice_lines: [
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 113,
        total_line: 2704.09,
        total_margin: 138.99,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 120,
        total_line: 5746.8,
        total_margin: 954,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 82,
        total_line: 1955.7,
        total_margin: 470.68,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 123,
        total_line: 4678.92,
        total_margin: 841.3199999999999,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 45,
        total_line: 618.75,
        total_margin: 82.35000000000001,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 61,
        total_line: 2319.83,
        total_margin: 93.33,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 105,
        total_line: 911.4,
        total_margin: 75.6,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 68,
        total_line: 1128.8000000000002,
        total_margin: 27.200000000000003,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 107,
        total_line: 3575.94,
        total_margin: 430.13999999999993,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 121,
        total_line: 995.83,
        total_margin: 49.61,
      },
    ],
    total_invoice: 24636.06,
    total_margin: 3163.2199999999993,
    region: 'Australia',
  },
  {
    id: 152,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-03-07',
    invoice_lines: [
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 41,
        total_line: 563.75,
        total_margin: 75.03,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 41,
        total_line: 1405.0700000000002,
        total_margin: 184.09,
      },
    ],
    total_invoice: 1968.8200000000002,
    total_margin: 259.12,
    region: 'India',
  },
  {
    id: 153,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-09-07',
    invoice_lines: [
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 134,
        total_line: 1514.2,
        total_margin: 368.5,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 16,
        total_line: 608.64,
        total_margin: 109.44,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 39,
        total_line: 1765.92,
        total_margin: 175.5,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 105,
        total_line: 1000.65,
        total_margin: 96.60000000000001,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 14,
        total_line: 376.88,
        total_margin: 91.56,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 55,
        total_line: 985.05,
        total_margin: 102.30000000000001,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 66,
        total_line: 1096.26,
        total_margin: 136.61999999999998,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 118,
        total_line: 1929.3000000000002,
        total_margin: 114.46,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 78,
        total_line: 2127.06,
        total_margin: 511.67999999999995,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 102,
        total_line: 4460.46,
        total_margin: 1021.02,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 25,
        total_line: 596.25,
        total_margin: 143.5,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 119,
        total_line: 2355.0099999999998,
        total_margin: 286.79,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 109,
        total_line: 3642.78,
        total_margin: 438.17999999999995,
      },
    ],
    total_invoice: 22458.46,
    total_margin: 3596.1499999999996,
    region: 'Brazil',
  },
  {
    id: 154,
    customer_id: 3,
    customer_name: 'John Wu',
    date: '2020-06-23',
    invoice_lines: [
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 77,
        total_line: 2776.6200000000003,
        total_margin: 316.47,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 92,
        total_line: 4165.76,
        total_margin: 414,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 126,
        total_line: 6034.14,
        total_margin: 1001.7,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 61,
        total_line: 2956.67,
        total_margin: 563.03,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 66,
        total_line: 1079.1000000000001,
        total_margin: 64.02,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 97,
        total_line: 3689.88,
        total_margin: 663.48,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 118,
        total_line: 5223.860000000001,
        total_margin: 197.06,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 126,
        total_line: 2215.08,
        total_margin: 366.66,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 85,
        total_line: 2912.9500000000003,
        total_margin: 381.65000000000003,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 12,
        total_line: 165,
        total_margin: 21.96,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 36,
        total_line: 1135.44,
        total_margin: 23.76,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 23,
        total_line: 276.46,
        total_margin: 53.59,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 83,
        total_line: 2465.1,
        total_margin: 68.89,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 86,
        total_line: 3299.8199999999997,
        total_margin: 288.1,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 89,
        total_line: 1305.6299999999999,
        total_margin: 196.69,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 5,
        total_line: 140.8,
        total_margin: 5.85,
      },
    ],
    total_invoice: 39842.31,
    total_margin: 4626.910000000001,
    region: 'USA',
  },
  {
    id: 155,
    customer_id: 18,
    customer_name: 'Jack Wu',
    date: '2020-01-17',
    invoice_lines: [
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 79,
        total_line: 972.49,
        total_margin: 202.24,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 112,
        total_line: 1643.04,
        total_margin: 247.51999999999998,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 54,
        total_line: 1040.0400000000002,
        total_margin: 138.24,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 66,
        total_line: 194.04,
        total_margin: 44.88,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 19,
        total_line: 511.48,
        total_margin: 124.26,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 71,
        total_line: 2412.58,
        total_margin: 516.88,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 92,
        total_line: 1039.6000000000001,
        total_margin: 253,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 43,
        total_line: 928.8000000000001,
        total_margin: 176.73000000000002,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 120,
        total_line: 3754.7999999999997,
        total_margin: 772.8000000000001,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 38,
        total_line: 1128.6,
        total_margin: 31.54,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 61,
        total_line: 2199.6600000000003,
        total_margin: 250.71,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 120,
        total_line: 1510.8,
        total_margin: 55.2,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 135,
        total_line: 5179.95,
        total_margin: 452.25,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 19,
        total_line: 830.8699999999999,
        total_margin: 190.19,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 119,
        total_line: 1945.65,
        total_margin: 115.42999999999999,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 90,
        total_line: 368.09999999999997,
        total_margin: 68.4,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 143,
        total_line: 2829.97,
        total_margin: 344.63,
      },
    ],
    total_invoice: 28490.47,
    total_margin: 3984.9,
    region: 'USA',
  },
  {
    id: 156,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-02-28',
    invoice_lines: [
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 144,
        total_line: 6520.32,
        total_margin: 648,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 93,
        total_line: 3537.72,
        total_margin: 636.12,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 137,
        total_line: 2959.2000000000003,
        total_margin: 563.07,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 137,
        total_line: 4694.990000000001,
        total_margin: 615.13,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 87,
        total_line: 3137.2200000000003,
        total_margin: 357.57000000000005,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 85,
        total_line: 4119.95,
        total_margin: 784.5500000000001,
      },
    ],
    total_invoice: 24969.4,
    total_margin: 3604.4400000000005,
    region: 'Australia',
  },
  {
    id: 157,
    customer_id: 22,
    customer_name: 'Martin Cook',
    date: '2020-08-09',
    invoice_lines: [
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 103,
        total_line: 847.69,
        total_margin: 42.23,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 125,
        total_line: 1378.75,
        total_margin: 117.5,
      },
    ],
    total_invoice: 2226.44,
    total_margin: 159.73,
    region: 'Australia',
  },
  {
    id: 158,
    customer_id: 28,
    customer_name: 'Allan Cook',
    date: '2020-10-26',
    invoice_lines: [
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 87,
        total_line: 3939.36,
        total_margin: 391.5,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 135,
        total_line: 3634.2000000000003,
        total_margin: 882.9,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 134,
        total_line: 3654.18,
        total_margin: 879.04,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 129,
        total_line: 1892.43,
        total_margin: 285.09,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 99,
        total_line: 3765.96,
        total_margin: 677.16,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 82,
        total_line: 926.6,
        total_margin: 225.5,
      },
    ],
    total_invoice: 17812.73,
    total_margin: 3341.19,
    region: 'Brazil',
  },
  {
    id: 159,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-09-16',
    invoice_lines: [
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 64,
        total_line: 938.88,
        total_margin: 141.44,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 124,
        total_line: 4144.08,
        total_margin: 498.47999999999996,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 83,
        total_line: 1021.73,
        total_margin: 212.48000000000002,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 15,
        total_line: 123.45,
        total_margin: 6.1499999999999995,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 35,
        total_line: 1331.05,
        total_margin: 53.550000000000004,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 29,
        total_line: 573.91,
        total_margin: 69.89,
      },
    ],
    total_invoice: 8133.1,
    total_margin: 981.9899999999999,
    region: 'Brazil',
  },
  {
    id: 160,
    customer_id: 4,
    customer_name: 'Daniels Smith',
    date: '2020-09-29',
    invoice_lines: [
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 27,
        total_line: 305.1,
        total_margin: 74.25,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 9,
        total_line: 74.07000000000001,
        total_margin: 3.69,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 122,
        total_line: 4640.88,
        total_margin: 834.48,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 141,
        total_line: 414.54,
        total_margin: 95.88000000000001,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 2,
        total_line: 29.34,
        total_margin: 4.42,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 79,
        total_line: 685.72,
        total_margin: 56.879999999999995,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 142,
        total_line: 4478.68,
        total_margin: 93.72,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 137,
        total_line: 2711.23,
        total_margin: 330.17,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 82,
        total_line: 2207.44,
        total_margin: 536.28,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 80,
        total_line: 1914.4,
        total_margin: 98.4,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 43,
        total_line: 714.23,
        total_margin: 89.00999999999999,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 74,
        total_line: 910.94,
        total_margin: 189.44,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 110,
        total_line: 2002,
        total_margin: 56.1,
      },
    ],
    total_invoice: 21088.57,
    total_margin: 2462.7200000000003,
    region: 'Europe',
  },
  {
    id: 161,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-03-26',
    invoice_lines: [
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 146,
        total_line: 1391.3799999999999,
        total_margin: 134.32,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 67,
        total_line: 1199.97,
        total_margin: 124.62,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 132,
        total_line: 6398.04,
        total_margin: 1218.3600000000001,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 28,
        total_line: 344.68,
        total_margin: 71.68,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 60,
        total_line: 1435.8,
        total_margin: 73.8,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 9,
        total_line: 194.4,
        total_margin: 36.99,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 100,
        total_line: 4951,
        total_margin: 377,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 48,
        total_line: 1841.7599999999998,
        total_margin: 160.8,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 90,
        total_line: 2146.5,
        total_margin: 516.6,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 46,
        total_line: 1238.3200000000002,
        total_margin: 300.84,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 31,
        total_line: 597.0600000000001,
        total_margin: 79.36,
      },
    ],
    total_invoice: 21738.91,
    total_margin: 3094.3700000000003,
    region: 'Europe',
  },
  {
    id: 162,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-08-08',
    invoice_lines: [
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 88,
        total_line: 1460.8000000000002,
        total_margin: 35.2,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 48,
        total_line: 590.88,
        total_margin: 122.88,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 59,
        total_line: 1167.61,
        total_margin: 142.19,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 137,
        total_line: 5991.009999999999,
        total_margin: 1371.37,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 137,
        total_line: 2493.4,
        total_margin: 69.87,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 147,
        total_line: 4365.9,
        total_margin: 122.00999999999999,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 46,
        total_line: 674.82,
        total_margin: 101.66,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 99,
        total_line: 2086.9199999999996,
        total_margin: 25.740000000000002,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 123,
        total_line: 361.62,
        total_margin: 83.64,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 51,
        total_line: 2525.0099999999998,
        total_margin: 192.27,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 139,
        total_line: 1324.6699999999998,
        total_margin: 127.88000000000001,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 114,
        total_line: 4374.179999999999,
        total_margin: 381.90000000000003,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 21,
        total_line: 182.28,
        total_margin: 15.12,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 90,
        total_line: 3084.3,
        total_margin: 404.1,
      },
    ],
    total_invoice: 30683.39999999999,
    total_margin: 3195.83,
    region: 'USA',
  },
  {
    id: 163,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-03-20',
    invoice_lines: [
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 132,
        total_line: 5019.96,
        total_margin: 201.96,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 72,
        total_line: 886.32,
        total_margin: 184.32,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 52,
        total_line: 1029.08,
        total_margin: 125.32000000000001,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 13,
        total_line: 311.09,
        total_margin: 15.99,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 20,
        total_line: 545.4,
        total_margin: 131.2,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 111,
        total_line: 963.48,
        total_margin: 79.92,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 122,
        total_line: 4183.38,
        total_margin: 766.1600000000001,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 85,
        total_line: 2840.7000000000003,
        total_margin: 341.7,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 138,
        total_line: 3714.96,
        total_margin: 902.52,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 1,
        total_line: 38.21,
        total_margin: 8.83,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 146,
        total_line: 1391.3799999999999,
        total_margin: 134.32,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 13,
        total_line: 156.26,
        total_margin: 30.29,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 54,
        total_line: 2673.54,
        total_margin: 203.58,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 35,
        total_line: 1530.55,
        total_margin: 350.34999999999997,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 66,
        total_line: 1096.26,
        total_margin: 136.61999999999998,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 47,
        total_line: 990.7599999999999,
        total_margin: 12.22,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 132,
        total_line: 4485.36,
        total_margin: 960.96,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 115,
        total_line: 1880.2500000000002,
        total_margin: 111.55,
      },
    ],
    total_invoice: 33736.939999999995,
    total_margin: 4697.81,
    region: 'Brazil',
  },
  {
    id: 164,
    customer_id: 21,
    customer_name: 'Jack Cook',
    date: '2020-07-10',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 104,
        total_line: 4604.08,
        total_margin: 173.68,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 106,
        total_line: 3601.8799999999997,
        total_margin: 771.6800000000001,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 68,
        total_line: 1830.5600000000002,
        total_margin: 444.72,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 94,
        total_line: 1810.44,
        total_margin: 240.64000000000001,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 137,
        total_line: 4697.73,
        total_margin: 860.36,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 115,
        total_line: 2059.65,
        total_margin: 213.9,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 29,
        total_line: 238.67000000000002,
        total_margin: 11.889999999999999,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 12,
        total_line: 581.64,
        total_margin: 110.76,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 78,
        total_line: 1295.58,
        total_margin: 161.45999999999998,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 73,
        total_line: 1504.53,
        total_margin: 136.51000000000002,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 93,
        total_line: 4453.77,
        total_margin: 739.35,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 90,
        total_line: 1237.5,
        total_margin: 164.70000000000002,
      },
    ],
    total_invoice: 27916.029999999995,
    total_margin: 4029.6500000000005,
    region: 'India',
  },
  {
    id: 165,
    customer_id: 26,
    customer_name: 'Magda Castex',
    date: '2020-04-15',
    invoice_lines: [
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 44,
        total_line: 129.35999999999999,
        total_margin: 29.92,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 56,
        total_line: 533.68,
        total_margin: 51.52,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 90,
        total_line: 1237.5,
        total_margin: 164.70000000000002,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 78,
        total_line: 1543.62,
        total_margin: 187.98000000000002,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 110,
        total_line: 3771.9,
        total_margin: 690.8000000000001,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 40,
        total_line: 1980.3999999999999,
        total_margin: 150.8,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 66,
        total_line: 1201.2,
        total_margin: 33.660000000000004,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 66,
        total_line: 2379.96,
        total_margin: 271.26000000000005,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 110,
        total_line: 3097.6,
        total_margin: 128.7,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 102,
        total_line: 2745.84,
        total_margin: 667.08,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 75,
        total_line: 1226.25,
        total_margin: 72.75,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 108,
        total_line: 3701.1600000000003,
        total_margin: 484.92,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 79,
        total_line: 3018.59,
        total_margin: 697.57,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 111,
        total_line: 3500.94,
        total_margin: 73.26,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 135,
        total_line: 6543.45,
        total_margin: 1246.05,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 34,
        total_line: 279.82,
        total_margin: 13.94,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 62,
        total_line: 2807.36,
        total_margin: 279,
      },
    ],
    total_invoice: 39698.63,
    total_margin: 5243.91,
    region: 'Europe',
  },
  {
    id: 166,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-11-29',
    invoice_lines: [
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 36,
        total_line: 597.96,
        total_margin: 74.52,
      },
    ],
    total_invoice: 597.96,
    total_margin: 74.52,
    region: 'Europe',
  },
  {
    id: 167,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-03-31',
    invoice_lines: [
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 136,
        total_line: 437.92,
        total_margin: 35.36,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 141,
        total_line: 2543.64,
        total_margin: 403.26,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 45,
        total_line: 1227.15,
        total_margin: 295.2,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 99,
        total_line: 4901.49,
        total_margin: 373.23,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 79,
        total_line: 752.87,
        total_margin: 72.68,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 70,
        total_line: 205.79999999999998,
        total_margin: 47.6,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 27,
        total_line: 234.35999999999999,
        total_margin: 19.439999999999998,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 83,
        total_line: 1749.6399999999999,
        total_margin: 21.580000000000002,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 94,
        total_line: 4256.32,
        total_margin: 423,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 133,
        total_line: 4557.910000000001,
        total_margin: 597.1700000000001,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 86,
        total_line: 3299.8199999999997,
        total_margin: 288.1,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 8,
        total_line: 132.8,
        total_margin: 3.2,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 30,
        total_line: 490.50000000000006,
        total_margin: 29.099999999999998,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 95,
        total_line: 3425.7000000000003,
        total_margin: 390.45000000000005,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 3,
        total_line: 71.78999999999999,
        total_margin: 3.69,
      },
    ],
    total_invoice: 28287.710000000003,
    total_margin: 3003.06,
    region: 'Europe',
  },
  {
    id: 168,
    customer_id: 28,
    customer_name: 'Allan Cook',
    date: '2020-05-12',
    invoice_lines: [
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 58,
        total_line: 2871.58,
        total_margin: 218.66,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 65,
        total_line: 1079,
        total_margin: 26,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 83,
        total_line: 2844.4100000000003,
        total_margin: 372.67,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 9,
        total_line: 305.82,
        total_margin: 65.52,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 148,
        total_line: 2669.92,
        total_margin: 423.28,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 14,
        total_line: 207.20000000000002,
        total_margin: 11.06,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 30,
        total_line: 938.6999999999999,
        total_margin: 193.20000000000002,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 24,
        total_line: 228.71999999999997,
        total_margin: 22.080000000000002,
      },
    ],
    total_invoice: 11145.35,
    total_margin: 1332.47,
    region: 'Australia',
  },
  {
    id: 169,
    customer_id: 21,
    customer_name: 'Jack Cook',
    date: '2020-07-22',
    invoice_lines: [
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 139,
        total_line: 3741.88,
        total_margin: 909.0600000000001,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 53,
        total_line: 931.7399999999999,
        total_margin: 154.23000000000002,
      },
    ],
    total_invoice: 4673.62,
    total_margin: 1063.29,
    region: 'Brazil',
  },
  {
    id: 170,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-02-12',
    invoice_lines: [
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 89,
        total_line: 1605.56,
        total_margin: 254.54,
      },
    ],
    total_invoice: 1605.56,
    total_margin: 254.54,
    region: 'Europe',
  },
  {
    id: 171,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-05-18',
    invoice_lines: [
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 45,
        total_line: 1967.85,
        total_margin: 450.45,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 78,
        total_line: 1295.58,
        total_margin: 161.45999999999998,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 40,
        total_line: 716.4,
        total_margin: 74.4,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 41,
        total_line: 463.3,
        total_margin: 112.75,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 56,
        total_line: 1209.6000000000001,
        total_margin: 230.16000000000003,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 86,
        total_line: 2874.1200000000003,
        total_margin: 345.71999999999997,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 72,
        total_line: 1298.8799999999999,
        total_margin: 205.92,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 5,
        total_line: 105.39999999999999,
        total_margin: 1.3,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 12,
        total_line: 356.4,
        total_margin: 9.959999999999999,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 63,
        total_line: 2789.01,
        total_margin: 105.21,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 77,
        total_line: 2942.17,
        total_margin: 679.91,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 64,
        total_line: 2193.28,
        total_margin: 287.36,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 42,
        total_line: 1597.26,
        total_margin: 64.26,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 38,
        total_line: 906.3000000000001,
        total_margin: 218.12,
      },
    ],
    total_invoice: 20715.549999999996,
    total_margin: 2946.9800000000005,
    region: 'Brazil',
  },
  {
    id: 172,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-01-06',
    invoice_lines: [
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 59,
        total_line: 1971.7800000000002,
        total_margin: 237.17999999999998,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 32,
        total_line: 1217.28,
        total_margin: 218.88,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 105,
        total_line: 4012.05,
        total_margin: 927.15,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 30,
        total_line: 88.2,
        total_margin: 20.400000000000002,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 93,
        total_line: 1376.4,
        total_margin: 73.47,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 18,
        total_line: 370.98,
        total_margin: 33.660000000000004,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 88,
        total_line: 2613.6,
        total_margin: 73.03999999999999,
      },
    ],
    total_invoice: 11650.29,
    total_margin: 1583.7800000000002,
    region: 'Brazil',
  },
  {
    id: 173,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-02-28',
    invoice_lines: [
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 80,
        total_line: 2376,
        total_margin: 66.39999999999999,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 62,
        total_line: 1128.3999999999999,
        total_margin: 31.62,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 18,
        total_line: 891.18,
        total_margin: 67.86,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 66,
        total_line: 628.9799999999999,
        total_margin: 60.720000000000006,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 128,
        total_line: 1538.56,
        total_margin: 298.24,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 73,
        total_line: 1741.0500000000002,
        total_margin: 419.02000000000004,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 81,
        total_line: 2920.86,
        total_margin: 332.91,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 88,
        total_line: 3015.76,
        total_margin: 395.12,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 56,
        total_line: 1920.24,
        total_margin: 351.68,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 138,
        total_line: 2426.04,
        total_margin: 401.58000000000004,
      },
    ],
    total_invoice: 18587.07,
    total_margin: 2425.1500000000005,
    region: 'India',
  },
  {
    id: 174,
    customer_id: 32,
    customer_name: 'John Muijs',
    date: '2020-12-15',
    invoice_lines: [
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 55,
        total_line: 2665.85,
        total_margin: 507.65000000000003,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 50,
        total_line: 1564.5,
        total_margin: 322,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 26,
        total_line: 993.46,
        total_margin: 229.58,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 112,
        total_line: 4958.240000000001,
        total_margin: 187.04,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 88,
        total_line: 1302.4,
        total_margin: 69.52000000000001,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 72,
        total_line: 2406.2400000000002,
        total_margin: 289.43999999999994,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 35,
        total_line: 1676.15,
        total_margin: 278.25,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 99,
        total_line: 2940.2999999999997,
        total_margin: 82.17,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 84,
        total_line: 1617.8400000000001,
        total_margin: 215.04,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 84,
        total_line: 270.48,
        total_margin: 21.84,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 29,
        total_line: 780.6800000000001,
        total_margin: 189.66,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 148,
        total_line: 4167.68,
        total_margin: 173.16,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 60,
        total_line: 1092,
        total_margin: 30.6,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 80,
        total_line: 2181.6,
        total_margin: 524.8,
      },
    ],
    total_invoice: 28617.42,
    total_margin: 3120.75,
    region: 'Brazil',
  },
  {
    id: 175,
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    date: '2020-01-13',
    invoice_lines: [
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 66,
        total_line: 745.8000000000001,
        total_margin: 181.5,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 76,
        total_line: 2903.96,
        total_margin: 671.08,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 84,
        total_line: 1662.36,
        total_margin: 202.44,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 126,
        total_line: 4320.54,
        total_margin: 791.2800000000001,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 11,
        total_line: 231.88,
        total_margin: 2.8600000000000003,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 47,
        total_line: 826.2599999999999,
        total_margin: 136.77,
      },
    ],
    total_invoice: 10690.8,
    total_margin: 1985.93,
    region: 'Europe',
  },
  {
    id: 176,
    customer_id: 21,
    customer_name: 'Jack Cook',
    date: '2020-01-02',
    invoice_lines: [
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 136,
        total_line: 399.84,
        total_margin: 92.48,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 107,
        total_line: 945.88,
        total_margin: 173.34,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 140,
        total_line: 3350.2,
        total_margin: 172.2,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 107,
        total_line: 2060.82,
        total_margin: 273.92,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 41,
        total_line: 739.64,
        total_margin: 117.25999999999999,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 119,
        total_line: 2570.4,
        total_margin: 489.09000000000003,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 51,
        total_line: 1051.11,
        total_margin: 95.37,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 31,
        total_line: 845.37,
        total_margin: 203.35999999999999,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 130,
        total_line: 2125.5,
        total_margin: 126.1,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 142,
        total_line: 457.24,
        total_margin: 36.92,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 136,
        total_line: 6733.36,
        total_margin: 512.72,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 103,
        total_line: 1416.25,
        total_margin: 188.49,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 27,
        total_line: 1308.69,
        total_margin: 249.21,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 85,
        total_line: 1046.3500000000001,
        total_margin: 217.6,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 75,
        total_line: 1365,
        total_margin: 38.25,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 114,
        total_line: 1288.2,
        total_margin: 313.5,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 141,
        total_line: 5363.64,
        total_margin: 964.4399999999999,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 44,
        total_line: 730.8399999999999,
        total_margin: 91.08,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 137,
        total_line: 560.3299999999999,
        total_margin: 104.12,
      },
    ],
    total_invoice: 34358.659999999996,
    total_margin: 4459.45,
    region: 'Australia',
  },
  {
    id: 177,
    customer_id: 27,
    customer_name: 'Daniels Jackson',
    date: '2020-09-16',
    invoice_lines: [
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 137,
        total_line: 2009.79,
        total_margin: 302.77,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 19,
        total_line: 239.21,
        total_margin: 8.74,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 14,
        total_line: 252.56,
        total_margin: 40.04,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 16,
        total_line: 286.56,
        total_margin: 29.76,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 72,
        total_line: 1555.2,
        total_margin: 295.92,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 80,
        total_line: 1686.3999999999999,
        total_margin: 20.8,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 76,
        total_line: 2890.28,
        total_margin: 116.28,
      },
    ],
    total_invoice: 8920,
    total_margin: 814.31,
    region: 'Brazil',
  },
  {
    id: 178,
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    date: '2020-03-19',
    invoice_lines: [
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 146,
        total_line: 3153.6000000000004,
        total_margin: 600.0600000000001,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 125,
        total_line: 2075,
        total_margin: 50,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 61,
        total_line: 2320.44,
        total_margin: 417.24,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 19,
        total_line: 181.07,
        total_margin: 17.48,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 54,
        total_line: 1703.1599999999999,
        total_margin: 35.64,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 85,
        total_line: 1021.6999999999999,
        total_margin: 198.05,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 140,
        total_line: 2885.4,
        total_margin: 261.8,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 47,
        total_line: 2080.69,
        total_margin: 78.49,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 75,
        total_line: 2852.25,
        total_margin: 114.75,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 78,
        total_line: 1371.2399999999998,
        total_margin: 226.98000000000002,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 37,
        total_line: 667.48,
        total_margin: 105.82,
      },
    ],
    total_invoice: 20312.030000000002,
    total_margin: 2106.3100000000004,
    region: 'India',
  },
  {
    id: 179,
    customer_id: 37,
    customer_name: 'John Wu',
    date: '2020-12-13',
    invoice_lines: [
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 96,
        total_line: 914.8799999999999,
        total_margin: 88.32000000000001,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 87,
        total_line: 1721.73,
        total_margin: 209.67000000000002,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 46,
        total_line: 885.96,
        total_margin: 117.76,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 133,
        total_line: 4161.57,
        total_margin: 856.5200000000001,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 89,
        total_line: 2807.06,
        total_margin: 58.74,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 4,
        total_line: 45.2,
        total_margin: 11,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 129,
        total_line: 4929.09,
        total_margin: 1139.07,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 33,
        total_line: 888.36,
        total_margin: 215.82,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 12,
        total_line: 401.04,
        total_margin: 48.239999999999995,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 30,
        total_line: 440.1,
        total_margin: 66.3,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 40,
        total_line: 1370.8000000000002,
        total_margin: 179.60000000000002,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 128,
        total_line: 2092.8,
        total_margin: 124.16,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 12,
        total_line: 594.12,
        total_margin: 45.24,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 118,
        total_line: 2128.72,
        total_margin: 337.47999999999996,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 73,
        total_line: 1283.34,
        total_margin: 212.43,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 7,
        total_line: 207.9,
        total_margin: 5.81,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 46,
        total_line: 764.06,
        total_margin: 95.22,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 23,
        total_line: 1005.79,
        total_margin: 230.23,
      },
    ],
    total_invoice: 26642.52,
    total_margin: 4041.609999999999,
    region: 'USA',
  },
  {
    id: 180,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-09-20',
    invoice_lines: [
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 25,
        total_line: 1093.25,
        total_margin: 250.25,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 69,
        total_line: 222.18,
        total_margin: 17.94,
      },
    ],
    total_invoice: 1315.43,
    total_margin: 268.19,
    region: 'Europe',
  },
  {
    id: 181,
    customer_id: 38,
    customer_name: 'Mike Muijs',
    date: '2020-03-21',
    invoice_lines: [
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 80,
        total_line: 1100,
        total_margin: 146.4,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 73,
        total_line: 3192.29,
        total_margin: 730.73,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 70,
        total_line: 3352.3,
        total_margin: 556.5,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 31,
        total_line: 613.49,
        total_margin: 74.71000000000001,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 112,
        total_line: 1860.32,
        total_margin: 231.83999999999997,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 86,
        total_line: 3807.2200000000003,
        total_margin: 143.62,
      },
    ],
    total_invoice: 13925.619999999999,
    total_margin: 1883.8000000000002,
    region: 'Brazil',
  },
  {
    id: 182,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-03-18',
    invoice_lines: [
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 129,
        total_line: 1140.36,
        total_margin: 208.98000000000002,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 65,
        total_line: 2472.6,
        total_margin: 444.59999999999997,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 31,
        total_line: 613.49,
        total_margin: 74.71000000000001,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 139,
        total_line: 4128.3,
        total_margin: 115.36999999999999,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 144,
        total_line: 3035.5199999999995,
        total_margin: 37.44,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 2,
        total_line: 54.54,
        total_margin: 13.12,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 39,
        total_line: 803.79,
        total_margin: 72.93,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 116,
        total_line: 4182.96,
        total_margin: 476.76000000000005,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 134,
        total_line: 1102.8200000000002,
        total_margin: 54.94,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 69,
        total_line: 2366.0099999999998,
        total_margin: 433.32,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 10,
        total_line: 382.1,
        total_margin: 88.3,
      },
    ],
    total_invoice: 20282.489999999998,
    total_margin: 2020.4699999999998,
    region: 'Brazil',
  },
  {
    id: 183,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-09-07',
    invoice_lines: [
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 99,
        total_line: 3765.96,
        total_margin: 677.16,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 149,
        total_line: 4699.46,
        total_margin: 98.34,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 56,
        total_line: 1527.12,
        total_margin: 367.35999999999996,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 138,
        total_line: 4689.24,
        total_margin: 1004.64,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 34,
        total_line: 375.02,
        total_margin: 31.959999999999997,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 112,
        total_line: 3326.4,
        total_margin: 92.96,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 23,
        total_line: 259.90000000000003,
        total_margin: 63.25,
      },
    ],
    total_invoice: 18643.100000000002,
    total_margin: 2335.67,
    region: 'Brazil',
  },
  {
    id: 184,
    customer_id: 27,
    customer_name: 'Daniels Jackson',
    date: '2020-12-08',
    invoice_lines: [
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 107,
        total_line: 3669.0299999999997,
        total_margin: 671.96,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 147,
        total_line: 2440.2000000000003,
        total_margin: 58.800000000000004,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 48,
        total_line: 1644.96,
        total_margin: 215.52,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 57,
        total_line: 1605.1200000000001,
        total_margin: 66.69,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 76,
        total_line: 1463.7600000000002,
        total_margin: 194.56,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 116,
        total_line: 5135.320000000001,
        total_margin: 193.72,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 56,
        total_line: 1154.1599999999999,
        total_margin: 104.72,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 144,
        total_line: 1272.96,
        total_margin: 233.28000000000003,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 115,
        total_line: 2424.2,
        total_margin: 29.900000000000002,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 32,
        total_line: 872.64,
        total_margin: 209.92,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 40,
        total_line: 492.40000000000003,
        total_margin: 102.4,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 139,
        total_line: 1670.78,
        total_margin: 323.87,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 146,
        total_line: 3482.1000000000004,
        total_margin: 838.0400000000001,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 117,
        total_line: 4219.02,
        total_margin: 480.87000000000006,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 37,
        total_line: 1236.54,
        total_margin: 148.73999999999998,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 92,
        total_line: 3530.04,
        total_margin: 308.2,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 5,
        total_line: 134.60000000000002,
        total_margin: 32.7,
      },
    ],
    total_invoice: 36447.829999999994,
    total_margin: 4213.889999999999,
    region: 'Australia',
  },
  {
    id: 185,
    customer_id: 4,
    customer_name: 'Daniels Smith',
    date: '2020-12-06',
    invoice_lines: [
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 41,
        total_line: 734.3100000000001,
        total_margin: 76.26,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 95,
        total_line: 2557.4,
        total_margin: 621.3,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 48,
        total_line: 1825.92,
        total_margin: 328.32,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 121,
        total_line: 4111.58,
        total_margin: 880.88,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 140,
        total_line: 2461.2,
        total_margin: 407.40000000000003,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 75,
        total_line: 1100.25,
        total_margin: 165.75,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 103,
        total_line: 910.52,
        total_margin: 166.86,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 41,
        total_line: 1405.0700000000002,
        total_margin: 184.09,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 26,
        total_line: 293.8,
        total_margin: 71.5,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 38,
        total_line: 467.78000000000003,
        total_margin: 97.28,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 14,
        total_line: 207.20000000000002,
        total_margin: 11.06,
      },
    ],
    total_invoice: 16075.03,
    total_margin: 3010.7000000000003,
    region: 'USA',
  },
  {
    id: 186,
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    date: '2020-05-19',
    invoice_lines: [
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 84,
        total_line: 1504.44,
        total_margin: 156.24,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 2,
        total_line: 16.46,
        total_margin: 0.82,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 36,
        total_line: 597.96,
        total_margin: 74.52,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 25,
        total_line: 451,
        total_margin: 71.5,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 24,
        total_line: 505.91999999999996,
        total_margin: 6.24,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 65,
        total_line: 1930.5,
        total_margin: 53.949999999999996,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 143,
        total_line: 1966.25,
        total_margin: 261.69,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 84,
        total_line: 729.12,
        total_margin: 60.48,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 70,
        total_line: 1026.9,
        total_margin: 154.7,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 103,
        total_line: 4559.81,
        total_margin: 172.01,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 58,
        total_line: 2205.7400000000002,
        total_margin: 88.74,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 73,
        total_line: 1211.8000000000002,
        total_margin: 29.200000000000003,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 54,
        total_line: 2071.98,
        total_margin: 180.9,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 102,
        total_line: 1793.1599999999999,
        total_margin: 296.82,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 48,
        total_line: 924.48,
        total_margin: 122.88,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 136,
        total_line: 3254.48,
        total_margin: 167.28,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 136,
        total_line: 3708.72,
        total_margin: 892.16,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 93,
        total_line: 1840.47,
        total_margin: 224.13000000000002,
      },
    ],
    total_invoice: 30299.190000000002,
    total_margin: 3014.26,
    region: 'Australia',
  },
  {
    id: 187,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-01-21',
    invoice_lines: [
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 135,
        total_line: 4626.450000000001,
        total_margin: 606.15,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 125,
        total_line: 1412.5,
        total_margin: 343.75,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 84,
        total_line: 3029.04,
        total_margin: 345.24,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 86,
        total_line: 1033.72,
        total_margin: 200.38,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 30,
        total_line: 444,
        total_margin: 23.700000000000003,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 84,
        total_line: 4158.84,
        total_margin: 316.68,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 3,
        total_line: 101.94,
        total_margin: 21.84,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 62,
        total_line: 1939.98,
        total_margin: 399.28000000000003,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 72,
        total_line: 211.68,
        total_margin: 48.96,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 84,
        total_line: 4022.76,
        total_margin: 667.8000000000001,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 17,
        total_line: 769.76,
        total_margin: 76.5,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 79,
        total_line: 1158.93,
        total_margin: 174.59,
      },
    ],
    total_invoice: 22909.600000000002,
    total_margin: 3224.8700000000003,
    region: 'India',
  },
  {
    id: 188,
    customer_id: 8,
    customer_name: 'Tim Jackson',
    date: '2020-03-22',
    invoice_lines: [
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 77,
        total_line: 247.94000000000003,
        total_margin: 20.02,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 113,
        total_line: 2236.27,
        total_margin: 272.33000000000004,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 122,
        total_line: 1378.6000000000001,
        total_margin: 335.5,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 148,
        total_line: 3984.1600000000003,
        total_margin: 967.92,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 23,
        total_line: 253.69,
        total_margin: 21.619999999999997,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 106,
        total_line: 4635.38,
        total_margin: 1061.06,
      },
    ],
    total_invoice: 12736.04,
    total_margin: 2678.45,
    region: 'Australia',
  },
  {
    id: 189,
    customer_id: 11,
    customer_name: 'Jean Martins',
    date: '2020-01-08',
    invoice_lines: [
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 138,
        total_line: 6034.74,
        total_margin: 1381.3799999999999,
      },
    ],
    total_invoice: 6034.74,
    total_margin: 1381.3799999999999,
    region: 'Brazil',
  },
  {
    id: 190,
    customer_id: 2,
    customer_name: 'Jack Muijs',
    date: '2020-02-06',
    invoice_lines: [
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 109,
        total_line: 350.98,
        total_margin: 28.34,
      },
    ],
    total_invoice: 350.98,
    total_margin: 28.34,
    region: 'Australia',
  },
  {
    id: 191,
    customer_id: 9,
    customer_name: 'Daniels Martins',
    date: '2020-04-03',
    invoice_lines: [
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 14,
        total_line: 288.53999999999996,
        total_margin: 26.18,
      },
    ],
    total_invoice: 288.53999999999996,
    total_margin: 26.18,
    region: 'Brazil',
  },
  {
    id: 192,
    customer_id: 37,
    customer_name: 'John Wu',
    date: '2020-11-27',
    invoice_lines: [
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 97,
        total_line: 2611.2400000000002,
        total_margin: 634.38,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 6,
        total_line: 228.18,
        total_margin: 9.18,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 148,
        total_line: 7173.5599999999995,
        total_margin: 1366.04,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 35,
        total_line: 692.65,
        total_margin: 84.35000000000001,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 2,
        total_line: 62.58,
        total_margin: 12.88,
      },
    ],
    total_invoice: 10768.21,
    total_margin: 2106.83,
    region: 'USA',
  },
  {
    id: 193,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-03-31',
    invoice_lines: [
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 51,
        total_line: 1956.87,
        total_margin: 170.85,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 35,
        total_line: 333.54999999999995,
        total_margin: 32.2,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 146,
        total_line: 3482.1000000000004,
        total_margin: 838.0400000000001,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 100,
        total_line: 2108,
        total_margin: 26,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 35,
        total_line: 1732.85,
        total_margin: 131.95,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 32,
        total_line: 950.4,
        total_margin: 26.56,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 24,
        total_line: 432.96,
        total_margin: 68.64,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 106,
        total_line: 1457.5,
        total_margin: 193.98000000000002,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 87,
        total_line: 1879.2,
        total_margin: 357.57000000000005,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 24,
        total_line: 574.3199999999999,
        total_margin: 29.52,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 111,
        total_line: 1334.22,
        total_margin: 258.63,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 21,
        total_line: 798.63,
        total_margin: 32.13,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 76,
        total_line: 2606.04,
        total_margin: 477.28000000000003,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 54,
        total_line: 1112.94,
        total_margin: 100.98,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 20,
        total_line: 220.6,
        total_margin: 18.799999999999997,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 44,
        total_line: 1495.12,
        total_margin: 320.32,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 128,
        total_line: 376.32,
        total_margin: 87.04,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 131,
        total_line: 6273.59,
        total_margin: 1041.45,
      },
    ],
    total_invoice: 29125.209999999995,
    total_margin: 4211.940000000001,
    region: 'India',
  },
  {
    id: 194,
    customer_id: 4,
    customer_name: 'Daniels Smith',
    date: '2020-11-06',
    invoice_lines: [
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 148,
        total_line: 1284.6399999999999,
        total_margin: 106.56,
      },
    ],
    total_invoice: 1284.6399999999999,
    total_margin: 106.56,
    region: 'India',
  },
  {
    id: 195,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-02-26',
    invoice_lines: [
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 123,
        total_line: 5890.47,
        total_margin: 977.85,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 111,
        total_line: 1254.3000000000002,
        total_margin: 305.25,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 48,
        total_line: 1841.7599999999998,
        total_margin: 160.8,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 143,
        total_line: 2513.9399999999996,
        total_margin: 416.13,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 74,
        total_line: 1559.9199999999998,
        total_margin: 19.240000000000002,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 15,
        total_line: 273,
        total_margin: 7.65,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 90,
        total_line: 1494.0000000000002,
        total_margin: 36,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 94,
        total_line: 1129.8799999999999,
        total_margin: 219.02,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 98,
        total_line: 1939.4199999999998,
        total_margin: 236.18,
      },
    ],
    total_invoice: 17896.69,
    total_margin: 2378.12,
    region: 'Europe',
  },
  {
    id: 196,
    customer_id: 9,
    customer_name: 'Daniels Martins',
    date: '2020-10-07',
    invoice_lines: [
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 42,
        total_line: 364.56,
        total_margin: 30.24,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 109,
        total_line: 2157.11,
        total_margin: 262.69,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 124,
        total_line: 5422.5199999999995,
        total_margin: 1241.24,
      },
    ],
    total_invoice: 7944.19,
    total_margin: 1534.17,
    region: 'Australia',
  },
  {
    id: 197,
    customer_id: 13,
    customer_name: 'Mike Jackson',
    date: '2020-01-09',
    invoice_lines: [
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 123,
        total_line: 4179.54,
        total_margin: 895.44,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 70,
        total_line: 3392.9,
        total_margin: 646.1,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 146,
        total_line: 4568.34,
        total_margin: 940.24,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 41,
        total_line: 1559.23,
        total_margin: 62.730000000000004,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 17,
        total_line: 841.67,
        total_margin: 64.09,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 60,
        total_line: 2716.8,
        total_margin: 270,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 116,
        total_line: 1701.72,
        total_margin: 256.36,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 109,
        total_line: 3642.78,
        total_margin: 438.17999999999995,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 70,
        total_line: 618.8,
        total_margin: 113.4,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 93,
        total_line: 3188.97,
        total_margin: 584.0400000000001,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 92,
        total_line: 1504.2,
        total_margin: 89.24,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 114,
        total_line: 1687.2,
        total_margin: 90.06,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 78,
        total_line: 3453.0600000000004,
        total_margin: 130.26,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 137,
        total_line: 560.3299999999999,
        total_margin: 104.12,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 17,
        total_line: 214.03,
        total_margin: 7.82,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 134,
        total_line: 2761.74,
        total_margin: 250.58,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 37,
        total_line: 882.45,
        total_margin: 212.38,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 140,
        total_line: 2696.4,
        total_margin: 358.40000000000003,
      },
    ],
    total_invoice: 40170.159999999996,
    total_margin: 5513.44,
    region: 'Brazil',
  },
  {
    id: 198,
    customer_id: 27,
    customer_name: 'Daniels Jackson',
    date: '2020-12-06',
    invoice_lines: [
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 71,
        total_line: 1699.03,
        total_margin: 87.33,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 135,
        total_line: 552.15,
        total_margin: 102.6,
      },
    ],
    total_invoice: 2251.18,
    total_margin: 189.93,
    region: 'Australia',
  },
  {
    id: 199,
    customer_id: 32,
    customer_name: 'John Muijs',
    date: '2020-09-20',
    invoice_lines: [
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 54,
        total_line: 2053.62,
        total_margin: 82.62,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 66,
        total_line: 2510.64,
        total_margin: 451.44,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 73,
        total_line: 877.4599999999999,
        total_margin: 170.09,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 51,
        total_line: 2471.97,
        total_margin: 470.73,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 140,
        total_line: 3817.7999999999997,
        total_margin: 918.4,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 108,
        total_line: 1485,
        total_margin: 197.64000000000001,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 23,
        total_line: 725.42,
        total_margin: 15.180000000000001,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 43,
        total_line: 714.23,
        total_margin: 89.00999999999999,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 8,
        total_line: 305.68,
        total_margin: 70.64,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 45,
        total_line: 184.04999999999998,
        total_margin: 34.2,
      },
    ],
    total_invoice: 15145.869999999999,
    total_margin: 2499.9499999999994,
    region: 'India',
  },
  {
    id: 200,
    customer_id: 32,
    customer_name: 'John Muijs',
    date: '2020-11-10',
    invoice_lines: [
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 146,
        total_line: 4336.2,
        total_margin: 121.17999999999999,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 73,
        total_line: 1080.4,
        total_margin: 57.67,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 24,
        total_line: 815.52,
        total_margin: 174.72,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 73,
        total_line: 2801.0099999999998,
        total_margin: 244.55,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 4,
        total_line: 45.2,
        total_margin: 11,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 132,
        total_line: 5976.96,
        total_margin: 594,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 5,
        total_line: 171.35000000000002,
        total_margin: 22.450000000000003,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 79,
        total_line: 1311.4,
        total_margin: 31.6,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 103,
        total_line: 4559.81,
        total_margin: 172.01,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 15,
        total_line: 409.05,
        total_margin: 98.39999999999999,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 9,
        total_line: 173.34,
        total_margin: 23.04,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 108,
        total_line: 1298.1599999999999,
        total_margin: 251.64000000000001,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 137,
        total_line: 5991.009999999999,
        total_margin: 1371.37,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 19,
        total_line: 310.65000000000003,
        total_margin: 18.43,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 91,
        total_line: 1629.81,
        total_margin: 169.26000000000002,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 30,
        total_line: 246.9,
        total_margin: 12.299999999999999,
      },
    ],
    total_invoice: 31156.770000000004,
    total_margin: 3373.6200000000003,
    region: 'Brazil',
  },
  {
    id: 201,
    customer_id: 8,
    customer_name: 'Tim Jackson',
    date: '2020-04-13',
    invoice_lines: [
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 38,
        total_line: 1291.2399999999998,
        total_margin: 276.64,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 53,
        total_line: 2399.84,
        total_margin: 238.5,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 118,
        total_line: 3721.72,
        total_margin: 77.88000000000001,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 144,
        total_line: 1185.1200000000001,
        total_margin: 59.04,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 44,
        total_line: 1052.92,
        total_margin: 54.12,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 92,
        total_line: 3530.04,
        total_margin: 308.2,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 144,
        total_line: 1272.96,
        total_margin: 233.28000000000003,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 3,
        total_line: 57.78,
        total_margin: 7.68,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 14,
        total_line: 670.46,
        total_margin: 111.3,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 84,
        total_line: 3209.64,
        total_margin: 741.72,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 117,
        total_line: 2315.43,
        total_margin: 281.97,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 139,
        total_line: 3914.2400000000002,
        total_margin: 162.63,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 133,
        total_line: 543.97,
        total_margin: 101.08,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 6,
        total_line: 98.10000000000001,
        total_margin: 5.82,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 99,
        total_line: 3394.71,
        total_margin: 621.72,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 47,
        total_line: 2278.09,
        total_margin: 433.81,
      },
    ],
    total_invoice: 30936.260000000002,
    total_margin: 3715.39,
    region: 'USA',
  },
  {
    id: 202,
    customer_id: 24,
    customer_name: 'Pablo Mohaman',
    date: '2020-04-03',
    invoice_lines: [
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 32,
        total_line: 304.96,
        total_margin: 29.44,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 72,
        total_line: 211.68,
        total_margin: 48.96,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 81,
        total_line: 1749.6000000000001,
        total_margin: 332.91,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 78,
        total_line: 319.02,
        total_margin: 59.28,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 106,
        total_line: 1334.54,
        total_margin: 48.760000000000005,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 71,
        total_line: 2700.13,
        total_margin: 108.63,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 31,
        total_line: 638.91,
        total_margin: 57.970000000000006,
      },
    ],
    total_invoice: 7258.84,
    total_margin: 685.95,
    region: 'Australia',
  },
  {
    id: 203,
    customer_id: 25,
    customer_name: 'Pablo Doe',
    date: '2020-03-16',
    invoice_lines: [
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 134,
        total_line: 4226.36,
        total_margin: 88.44,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 50,
        total_line: 565,
        total_margin: 137.5,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 124,
        total_line: 1526.44,
        total_margin: 317.44,
      },
    ],
    total_invoice: 6317.799999999999,
    total_margin: 543.38,
    region: 'India',
  },
  {
    id: 204,
    customer_id: 34,
    customer_name: 'Mike Martins',
    date: '2020-02-09',
    invoice_lines: [
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 142,
        total_line: 3998.72,
        total_margin: 166.14,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 111,
        total_line: 4241.31,
        total_margin: 980.13,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 120,
        total_line: 4564.8,
        total_margin: 820.8,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 111,
        total_line: 2137.86,
        total_margin: 284.16,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 99,
        total_line: 2086.9199999999996,
        total_margin: 25.740000000000002,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 51,
        total_line: 208.59,
        total_margin: 38.76,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 88,
        total_line: 1576.08,
        total_margin: 163.68,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 17,
        total_line: 350.37,
        total_margin: 31.790000000000003,
      },
    ],
    total_invoice: 19164.649999999998,
    total_margin: 2511.2,
    region: 'India',
  },
  {
    id: 205,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-09-11',
    invoice_lines: [
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 125,
        total_line: 1378.75,
        total_margin: 117.5,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 128,
        total_line: 6337.28,
        total_margin: 482.56,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 96,
        total_line: 1320,
        total_margin: 175.68,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 105,
        total_line: 2164.0499999999997,
        total_margin: 196.35000000000002,
      },
    ],
    total_invoice: 11200.079999999998,
    total_margin: 972.09,
    region: 'India',
  },
  {
    id: 206,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-04-12',
    invoice_lines: [
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 122,
        total_line: 5524.16,
        total_margin: 549,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 95,
        total_line: 305.90000000000003,
        total_margin: 24.7,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 64,
        total_line: 2445.44,
        total_margin: 565.12,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 119,
        total_line: 4043.6199999999994,
        total_margin: 866.32,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 35,
        total_line: 1262.1000000000001,
        total_margin: 143.85000000000002,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 17,
        total_line: 405.45000000000005,
        total_margin: 97.58,
      },
    ],
    total_invoice: 13986.67,
    total_margin: 2246.57,
    region: 'Brazil',
  },
  {
    id: 207,
    customer_id: 24,
    customer_name: 'Pablo Mohaman',
    date: '2020-07-24',
    invoice_lines: [
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 24,
        total_line: 518.4000000000001,
        total_margin: 98.64000000000001,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 10,
        total_line: 206.1,
        total_margin: 18.700000000000003,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 109,
        total_line: 897.07,
        total_margin: 44.69,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 79,
        total_line: 1665.32,
        total_margin: 20.54,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 127,
        total_line: 5750.56,
        total_margin: 571.5,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 107,
        total_line: 5297.57,
        total_margin: 403.39,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 96,
        total_line: 2851.2,
        total_margin: 79.67999999999999,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 24,
        total_line: 822.96,
        total_margin: 150.72,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 60,
        total_line: 2056.2000000000003,
        total_margin: 269.40000000000003,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 14,
        total_line: 250.74,
        total_margin: 26.040000000000003,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 30,
        total_line: 1146.3,
        total_margin: 264.9,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 67,
        total_line: 581.56,
        total_margin: 48.239999999999995,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 36,
        total_line: 1203.1200000000001,
        total_margin: 144.71999999999997,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 132,
        total_line: 1815,
        total_margin: 241.56,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 107,
        total_line: 1881.0599999999997,
        total_margin: 311.37,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 141,
        total_line: 4791.179999999999,
        total_margin: 1026.48,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 54,
        total_line: 2617.38,
        total_margin: 498.42,
      },
    ],
    total_invoice: 34351.72,
    total_margin: 4218.99,
    region: 'Europe',
  },
  {
    id: 208,
    customer_id: 20,
    customer_name: 'Magda Del Piero',
    date: '2020-04-14',
    invoice_lines: [
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 144,
        total_line: 5502.24,
        total_margin: 1271.52,
      },
    ],
    total_invoice: 5502.24,
    total_margin: 1271.52,
    region: 'Europe',
  },
  {
    id: 209,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-03-14',
    invoice_lines: [
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 140,
        total_line: 2325.4,
        total_margin: 289.79999999999995,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 50,
        total_line: 1030.5,
        total_margin: 93.5,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 130,
        total_line: 2285.3999999999996,
        total_margin: 378.3,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 47,
        total_line: 1281.69,
        total_margin: 308.32,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 145,
        total_line: 2615.7999999999997,
        total_margin: 414.7,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 54,
        total_line: 896.4000000000001,
        total_margin: 21.6,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 58,
        total_line: 1970.84,
        total_margin: 422.24,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 43,
        total_line: 1473.6100000000001,
        total_margin: 193.07000000000002,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 120,
        total_line: 1323.6,
        total_margin: 112.8,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 135,
        total_line: 1111.05,
        total_margin: 55.349999999999994,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 63,
        total_line: 1507.59,
        total_margin: 77.49,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 49,
        total_line: 2375.0299999999997,
        total_margin: 452.27000000000004,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 119,
        total_line: 4291.14,
        total_margin: 489.09000000000003,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 72,
        total_line: 2406.2400000000002,
        total_margin: 289.43999999999994,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 89,
        total_line: 3385.56,
        total_margin: 608.76,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 87,
        total_line: 2449.92,
        total_margin: 101.78999999999999,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 108,
        total_line: 2332.8,
        total_margin: 443.88000000000005,
      },
    ],
    total_invoice: 35062.57,
    total_margin: 4752.4,
    region: 'Brazil',
  },
  {
    id: 210,
    customer_id: 6,
    customer_name: 'Trisha Muijs',
    date: '2020-05-03',
    invoice_lines: [
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 145,
        total_line: 4306.5,
        total_margin: 120.35,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 35,
        total_line: 1337.3500000000001,
        total_margin: 309.05,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 63,
        total_line: 2160.27,
        total_margin: 395.64000000000004,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 73,
        total_line: 1746.8899999999999,
        total_margin: 89.78999999999999,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 86,
        total_line: 1082.74,
        total_margin: 39.56,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 56,
        total_line: 984.4799999999999,
        total_margin: 162.96,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 143,
        total_line: 2375.23,
        total_margin: 296.01,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 9,
        total_line: 189.71999999999997,
        total_margin: 2.34,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 91,
        total_line: 1093.82,
        total_margin: 212.03,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 23,
        total_line: 719.67,
        total_margin: 148.12,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 73,
        total_line: 3538.31,
        total_margin: 673.7900000000001,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 96,
        total_line: 1731.84,
        total_margin: 274.56,
      },
    ],
    total_invoice: 21266.82,
    total_margin: 2724.2,
    region: 'USA',
  },
  {
    id: 211,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-05-29',
    invoice_lines: [
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 116,
        total_line: 2766.6000000000004,
        total_margin: 665.84,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 71,
        total_line: 783.13,
        total_margin: 66.74,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 134,
        total_line: 4594.86,
        total_margin: 841.52,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 134,
        total_line: 4592.18,
        total_margin: 601.6600000000001,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 98,
        total_line: 806.5400000000001,
        total_margin: 40.18,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 65,
        total_line: 1749.8000000000002,
        total_margin: 425.1,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 69,
        total_line: 849.39,
        total_margin: 176.64000000000001,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 40,
        total_line: 1811.2,
        total_margin: 180,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 60,
        total_line: 2908.2,
        total_margin: 553.8000000000001,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 56,
        total_line: 1154.1599999999999,
        total_margin: 104.72,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 51,
        total_line: 1940.04,
        total_margin: 348.84,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 67,
        total_line: 638.51,
        total_margin: 61.64,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 65,
        total_line: 2343.9,
        total_margin: 267.15000000000003,
      },
    ],
    total_invoice: 26938.510000000002,
    total_margin: 4333.83,
    region: 'Australia',
  },
  {
    id: 212,
    customer_id: 13,
    customer_name: 'Mike Jackson',
    date: '2020-04-25',
    invoice_lines: [
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 51,
        total_line: 896.5799999999999,
        total_margin: 148.41,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 96,
        total_line: 392.64,
        total_margin: 72.96000000000001,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 2,
        total_line: 53.84,
        total_margin: 13.08,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 88,
        total_line: 1290.96,
        total_margin: 194.48,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 33,
        total_line: 653.0699999999999,
        total_margin: 79.53,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 118,
        total_line: 1024.24,
        total_margin: 84.96,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 43,
        total_line: 1649.9099999999999,
        total_margin: 144.05,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 127,
        total_line: 1746.25,
        total_margin: 232.41,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 102,
        total_line: 299.88,
        total_margin: 69.36,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 40,
        total_line: 664,
        total_margin: 16,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 122,
        total_line: 1345.6599999999999,
        total_margin: 114.67999999999999,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 105,
        total_line: 3994.2,
        total_margin: 718.1999999999999,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 53,
        total_line: 1574.1,
        total_margin: 43.989999999999995,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 26,
        total_line: 213.98000000000002,
        total_margin: 10.66,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 11,
        total_line: 104.83,
        total_margin: 10.120000000000001,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 34,
        total_line: 618.8,
        total_margin: 17.34,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 131,
        total_line: 6485.8099999999995,
        total_margin: 493.87,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 46,
        total_line: 406.64,
        total_margin: 74.52000000000001,
      },
    ],
    total_invoice: 23415.39,
    total_margin: 2538.62,
    region: 'USA',
  },
  {
    id: 213,
    customer_id: 18,
    customer_name: 'Jack Wu',
    date: '2020-12-12',
    invoice_lines: [
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 3,
        total_line: 80.76,
        total_margin: 19.62,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 147,
        total_line: 2584.2599999999998,
        total_margin: 427.77000000000004,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 28,
        total_line: 959.5600000000001,
        total_margin: 125.72,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 93,
        total_line: 822.12,
        total_margin: 150.66,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 116,
        total_line: 5743.16,
        total_margin: 437.32,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 78,
        total_line: 2812.6800000000003,
        total_margin: 320.58000000000004,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 61,
        total_line: 838.75,
        total_margin: 111.63000000000001,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 63,
        total_line: 1030.0500000000002,
        total_margin: 61.11,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 56,
        total_line: 1108.24,
        total_margin: 134.96,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 42,
        total_line: 463.26,
        total_margin: 39.48,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 97,
        total_line: 4392.16,
        total_margin: 436.5,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 149,
        total_line: 1875.91,
        total_margin: 68.54,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 30,
        total_line: 1311.8999999999999,
        total_margin: 300.3,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 143,
        total_line: 2097.81,
        total_margin: 316.03,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 102,
        total_line: 2102.22,
        total_margin: 190.74,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 48,
        total_line: 1825.44,
        total_margin: 73.44,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 136,
        total_line: 1674.16,
        total_margin: 348.16,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 14,
        total_line: 619.7800000000001,
        total_margin: 23.38,
      },
    ],
    total_invoice: 32342.22,
    total_margin: 3585.94,
    region: 'Brazil',
  },
  {
    id: 214,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-08-07',
    invoice_lines: [
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 117,
        total_line: 343.98,
        total_margin: 79.56,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 149,
        total_line: 5372.9400000000005,
        total_margin: 612.3900000000001,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 120,
        total_line: 4564.8,
        total_margin: 820.8,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 95,
        total_line: 4549.55,
        total_margin: 755.25,
      },
    ],
    total_invoice: 14831.27,
    total_margin: 2268,
    region: 'Brazil',
  },
  {
    id: 215,
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    date: '2020-04-06',
    invoice_lines: [
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 145,
        total_line: 6419.150000000001,
        total_margin: 242.14999999999998,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 30,
        total_line: 537.3,
        total_margin: 55.800000000000004,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 48,
        total_line: 2376.48,
        total_margin: 180.96,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 140,
        total_line: 450.8,
        total_margin: 36.4,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 106,
        total_line: 1274.12,
        total_margin: 246.98000000000002,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 12,
        total_line: 581.64,
        total_margin: 110.76,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 75,
        total_line: 1444.5000000000002,
        total_margin: 192,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 34,
        total_line: 810.9000000000001,
        total_margin: 195.16,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 128,
        total_line: 1111.04,
        total_margin: 92.16,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 60,
        total_line: 1636.2,
        total_margin: 393.59999999999997,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 65,
        total_line: 2208.7,
        total_margin: 473.2,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 24,
        total_line: 212.16,
        total_margin: 38.88,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 138,
        total_line: 2980.8,
        total_margin: 567.1800000000001,
      },
    ],
    total_invoice: 22043.789999999997,
    total_margin: 2825.2300000000005,
    region: 'Brazil',
  },
  {
    id: 216,
    customer_id: 38,
    customer_name: 'Mike Muijs',
    date: '2020-03-26',
    invoice_lines: [
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 35,
        total_line: 1337.3500000000001,
        total_margin: 309.05,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 96,
        total_line: 1408.32,
        total_margin: 212.16,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 84,
        total_line: 2880.36,
        total_margin: 527.52,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 62,
        total_line: 852.5,
        total_margin: 113.46000000000001,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 73,
        total_line: 695.6899999999999,
        total_margin: 67.16,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 10,
        total_line: 40.9,
        total_margin: 7.6,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 52,
        total_line: 1995.2399999999998,
        total_margin: 174.20000000000002,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 90,
        total_line: 1897.1999999999998,
        total_margin: 23.400000000000002,
      },
    ],
    total_invoice: 11107.560000000001,
    total_margin: 1434.5500000000002,
    region: 'India',
  },
  {
    id: 217,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-08-28',
    invoice_lines: [
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 80,
        total_line: 1648.8,
        total_margin: 149.60000000000002,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 68,
        total_line: 3295.96,
        total_margin: 627.64,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 57,
        total_line: 1534.44,
        total_margin: 372.78000000000003,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 30,
        total_line: 593.6999999999999,
        total_margin: 72.30000000000001,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 123,
        total_line: 3653.1,
        total_margin: 102.08999999999999,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 133,
        total_line: 1502.9,
        total_margin: 365.75,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 31,
        total_line: 1403.68,
        total_margin: 139.5,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 108,
        total_line: 1793.8799999999999,
        total_margin: 223.55999999999997,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 149,
        total_line: 3140.9199999999996,
        total_margin: 38.74,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 13,
        total_line: 494.52,
        total_margin: 88.92,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 122,
        total_line: 2220.4,
        total_margin: 62.22,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 56,
        total_line: 1902.8799999999999,
        total_margin: 407.68,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 92,
        total_line: 1349.64,
        total_margin: 203.32,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 46,
        total_line: 1658.7600000000002,
        total_margin: 189.06,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 133,
        total_line: 2174.55,
        total_margin: 129.01,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 44,
        total_line: 1387.76,
        total_margin: 29.040000000000003,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 67,
        total_line: 3317.17,
        total_margin: 252.59,
      },
    ],
    total_invoice: 33073.06,
    total_margin: 3453.7999999999993,
    region: 'USA',
  },
  {
    id: 218,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-04-25',
    invoice_lines: [
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 17,
        total_line: 823.99,
        total_margin: 156.91,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 77,
        total_line: 2072.84,
        total_margin: 503.58,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 16,
        total_line: 534.72,
        total_margin: 64.32,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 133,
        total_line: 4161.57,
        total_margin: 856.5200000000001,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 26,
        total_line: 993.46,
        total_margin: 229.58,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 5,
        total_line: 190.2,
        total_margin: 34.2,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 29,
        total_line: 527.8,
        total_margin: 14.790000000000001,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 95,
        total_line: 1713.8,
        total_margin: 271.7,
      },
    ],
    total_invoice: 11018.38,
    total_margin: 2131.6,
    region: 'India',
  },
  {
    id: 219,
    customer_id: 14,
    customer_name: 'Magda Jackson',
    date: '2020-05-04',
    invoice_lines: [
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 55,
        total_line: 1001,
        total_margin: 28.05,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 122,
        total_line: 3326.94,
        total_margin: 800.3199999999999,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 23,
        total_line: 382.03,
        total_margin: 47.61,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 67,
        total_line: 196.98,
        total_margin: 45.56,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 113,
        total_line: 4317.7300000000005,
        total_margin: 997.79,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 41,
        total_line: 680.6,
        total_margin: 16.400000000000002,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 29,
        total_line: 1268.1699999999998,
        total_margin: 290.29,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 106,
        total_line: 3632.6200000000003,
        total_margin: 475.94,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 134,
        total_line: 6634.34,
        total_margin: 505.18,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 28,
        total_line: 414.40000000000003,
        total_margin: 22.12,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 60,
        total_line: 2282.4,
        total_margin: 410.4,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 98,
        total_line: 1347.5,
        total_margin: 179.34,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 50,
        total_line: 989.5,
        total_margin: 120.5,
      },
    ],
    total_invoice: 26474.210000000006,
    total_margin: 3939.5,
    region: 'Europe',
  },
  {
    id: 220,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-07-07',
    invoice_lines: [
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 113,
        total_line: 5477.11,
        total_margin: 1042.99,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 2,
        total_line: 54.54,
        total_margin: 13.12,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 43,
        total_line: 1550.5800000000002,
        total_margin: 176.73000000000002,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 142,
        total_line: 2734.92,
        total_margin: 363.52,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 54,
        total_line: 610.2,
        total_margin: 148.5,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 47,
        total_line: 1124.71,
        total_margin: 57.81,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 15,
        total_line: 357.75,
        total_margin: 86.10000000000001,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 112,
        total_line: 972.16,
        total_margin: 80.64,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 5,
        total_line: 218.64999999999998,
        total_margin: 50.05,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 88,
        total_line: 1587.52,
        total_margin: 251.67999999999998,
      },
    ],
    total_invoice: 14688.140000000001,
    total_margin: 2271.14,
    region: 'Australia',
  },
  {
    id: 221,
    customer_id: 20,
    customer_name: 'Magda Del Piero',
    date: '2020-03-05',
    invoice_lines: [
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 17,
        total_line: 649.57,
        total_margin: 150.11,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 2,
        total_line: 41.22,
        total_margin: 3.74,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 46,
        total_line: 969.68,
        total_margin: 11.96,
      },
    ],
    total_invoice: 1660.47,
    total_margin: 165.81000000000003,
    region: 'Europe',
  },
  {
    id: 222,
    customer_id: 29,
    customer_name: 'John Cook',
    date: '2020-12-22',
    invoice_lines: [
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 8,
        total_line: 304.32,
        total_margin: 54.72,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 114,
        total_line: 2256.06,
        total_margin: 274.74,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 83,
        total_line: 1986.19,
        total_margin: 102.09,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 120,
        total_line: 5433.6,
        total_margin: 540,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 3,
        total_line: 57.78,
        total_margin: 7.68,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 51,
        total_line: 442.68,
        total_margin: 36.72,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 115,
        total_line: 1702,
        total_margin: 90.85000000000001,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 13,
        total_line: 53.17,
        total_margin: 9.88,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 76,
        total_line: 858.8000000000001,
        total_margin: 209,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 137,
        total_line: 1883.75,
        total_margin: 250.71,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 102,
        total_line: 901.68,
        total_margin: 165.24,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 84,
        total_line: 1395.24,
        total_margin: 173.88,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 57,
        total_line: 2167.71,
        total_margin: 87.21000000000001,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 130,
        total_line: 5755.1,
        total_margin: 217.1,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 143,
        total_line: 4026.88,
        total_margin: 167.31,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 106,
        total_line: 2184.66,
        total_margin: 198.22,
      },
    ],
    total_invoice: 31409.620000000003,
    total_margin: 2585.35,
    region: 'Brazil',
  },
  {
    id: 223,
    customer_id: 37,
    customer_name: 'John Wu',
    date: '2020-01-15',
    invoice_lines: [
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 53,
        total_line: 866.5500000000001,
        total_margin: 51.41,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 35,
        total_line: 1732.85,
        total_margin: 131.95,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 145,
        total_line: 3458.25,
        total_margin: 832.3000000000001,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 69,
        total_line: 1490.4,
        total_margin: 283.59000000000003,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 138,
        total_line: 1897.5,
        total_margin: 252.54000000000002,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 49,
        total_line: 891.8,
        total_margin: 24.990000000000002,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 115,
        total_line: 5028.95,
        total_margin: 1151.1499999999999,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 36,
        total_line: 1223.28,
        total_margin: 262.08,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 76,
        total_line: 1371.04,
        total_margin: 217.35999999999999,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 79,
        total_line: 2707.3300000000004,
        total_margin: 354.71000000000004,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 8,
        total_line: 118.4,
        total_margin: 6.32,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 105,
        total_line: 3311.7,
        total_margin: 69.3,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 31,
        total_line: 126.78999999999999,
        total_margin: 23.56,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 76,
        total_line: 2903.96,
        total_margin: 671.08,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 14,
        total_line: 172.34,
        total_margin: 35.84,
      },
    ],
    total_invoice: 27301.140000000003,
    total_margin: 4368.18,
    region: 'USA',
  },
  {
    id: 224,
    customer_id: 36,
    customer_name: 'Martin Wu',
    date: '2020-04-10',
    invoice_lines: [
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 51,
        total_line: 1595.79,
        total_margin: 328.44,
      },
      {
        product_id: 59,
        product_name: 'Baking - 5',
        product_category: 'Baking',
        unit_price: 47.89,
        quantity: 15,
        total_line: 718.35,
        total_margin: 119.25,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 28,
        total_line: 505.12,
        total_margin: 80.08,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 2,
        total_line: 8.18,
        total_margin: 1.52,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 1,
        total_line: 12.02,
        total_margin: 2.33,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 106,
        total_line: 4635.38,
        total_margin: 1061.06,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 120,
        total_line: 1060.8,
        total_margin: 194.4,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 102,
        total_line: 2102.22,
        total_margin: 190.74,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 52,
        total_line: 573.56,
        total_margin: 48.879999999999995,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 52,
        total_line: 1029.08,
        total_margin: 125.32000000000001,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 73,
        total_line: 3538.31,
        total_margin: 673.7900000000001,
      },
    ],
    total_invoice: 15778.809999999998,
    total_margin: 2825.81,
    region: 'Europe',
  },
  {
    id: 225,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-11-02',
    invoice_lines: [
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 79,
        total_line: 2708.91,
        total_margin: 496.12,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 56,
        total_line: 770,
        total_margin: 102.48,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 54,
        total_line: 2361.4199999999996,
        total_margin: 540.54,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 84,
        total_line: 2290.68,
        total_margin: 551.04,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 92,
        total_line: 1132.52,
        total_margin: 235.52,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 42,
        total_line: 738.3599999999999,
        total_margin: 122.22,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 115,
        total_line: 1910.1499999999999,
        total_margin: 238.04999999999998,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 44,
        total_line: 847.44,
        total_margin: 112.64,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 148,
        total_line: 476.56,
        total_margin: 38.480000000000004,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 47,
        total_line: 1803.3899999999999,
        total_margin: 157.45000000000002,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 73,
        total_line: 2501.71,
        total_margin: 327.77000000000004,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 97,
        total_line: 2731.52,
        total_margin: 113.49,
      },
    ],
    total_invoice: 20272.66,
    total_margin: 3035.7999999999993,
    region: 'Australia',
  },
  {
    id: 226,
    customer_id: 23,
    customer_name: 'Martijn Del Piero',
    date: '2020-03-18',
    invoice_lines: [
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 35,
        total_line: 1103.8999999999999,
        total_margin: 23.1,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 99,
        total_line: 1465.2,
        total_margin: 78.21000000000001,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 108,
        total_line: 2137.3199999999997,
        total_margin: 260.28000000000003,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 48,
        total_line: 1841.7599999999998,
        total_margin: 160.8,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 107,
        total_line: 4070.2799999999997,
        total_margin: 731.88,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 118,
        total_line: 4255.08,
        total_margin: 484.98,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 32,
        total_line: 577.28,
        total_margin: 91.52,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 11,
        total_line: 418.33000000000004,
        total_margin: 16.830000000000002,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 78,
        total_line: 960.1800000000001,
        total_margin: 199.68,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 55,
        total_line: 1868.8999999999999,
        total_margin: 400.40000000000003,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 33,
        total_line: 484.11,
        total_margin: 72.92999999999999,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 90,
        total_line: 2146.5,
        total_margin: 516.6,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 59,
        total_line: 2859.73,
        total_margin: 544.57,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 16,
        total_line: 329.76,
        total_margin: 29.92,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 101,
        total_line: 4416.73,
        total_margin: 1011.01,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 89,
        total_line: 1478.29,
        total_margin: 184.23,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 123,
        total_line: 361.62,
        total_margin: 83.64,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 60,
        total_line: 1636.2,
        total_margin: 393.59999999999997,
      },
    ],
    total_invoice: 32411.17,
    total_margin: 5284.18,
    region: 'USA',
  },
  {
    id: 227,
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    date: '2020-01-24',
    invoice_lines: [
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 1,
        total_line: 9.53,
        total_margin: 0.92,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 23,
        total_line: 788.67,
        total_margin: 144.44,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 67,
        total_line: 1199.97,
        total_margin: 124.62,
      },
    ],
    total_invoice: 1998.17,
    total_margin: 269.98,
    region: 'Europe',
  },
  {
    id: 228,
    customer_id: 24,
    customer_name: 'Pablo Mohaman',
    date: '2020-01-25',
    invoice_lines: [
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 145,
        total_line: 5563.65,
        total_margin: 485.75,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 70,
        total_line: 1036,
        total_margin: 55.300000000000004,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 48,
        total_line: 542.4000000000001,
        total_margin: 132,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 136,
        total_line: 2802.96,
        total_margin: 254.32000000000002,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 72,
        total_line: 294.48,
        total_margin: 54.72,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 65,
        total_line: 1772.55,
        total_margin: 426.4,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 62,
        total_line: 2072.04,
        total_margin: 249.23999999999998,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 113,
        total_line: 2056.6,
        total_margin: 57.63,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 140,
        total_line: 3768.8,
        total_margin: 915.6,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 27,
        total_line: 646.11,
        total_margin: 33.21,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 32,
        total_line: 1216.96,
        total_margin: 48.96,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 69,
        total_line: 3124.32,
        total_margin: 310.5,
      },
    ],
    total_invoice: 24896.87,
    total_margin: 3023.63,
    region: 'Europe',
  },
  {
    id: 229,
    customer_id: 10,
    customer_name: 'Daniels van Dijk',
    date: '2020-06-22',
    invoice_lines: [
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 64,
        total_line: 1745.28,
        total_margin: 419.84,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 97,
        total_line: 4802.47,
        total_margin: 365.69,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 105,
        total_line: 1443.75,
        total_margin: 192.15,
      },
    ],
    total_invoice: 7991.5,
    total_margin: 977.68,
    region: 'India',
  },
  {
    id: 230,
    customer_id: 16,
    customer_name: 'Greg Muijs',
    date: '2020-11-07',
    invoice_lines: [
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 82,
        total_line: 2740.44,
        total_margin: 329.64,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 90,
        total_line: 368.09999999999997,
        total_margin: 68.4,
      },
    ],
    total_invoice: 3108.54,
    total_margin: 398.03999999999996,
    region: 'Australia',
  },
  {
    id: 231,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-07-31',
    invoice_lines: [
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 110,
        total_line: 2318.7999999999997,
        total_margin: 28.6,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 85,
        total_line: 737.8,
        total_margin: 61.199999999999996,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 26,
        total_line: 989.04,
        total_margin: 177.84,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 7,
        total_line: 77.21,
        total_margin: 6.58,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 110,
        total_line: 4980.8,
        total_margin: 495,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 66,
        total_line: 2263.14,
        total_margin: 414.48,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 122,
        total_line: 1162.6599999999999,
        total_margin: 112.24000000000001,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 13,
        total_line: 53.17,
        total_margin: 9.88,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 105,
        total_line: 4648.35,
        total_margin: 175.35,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 35,
        total_line: 440.65,
        total_margin: 16.1,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 68,
        total_line: 601.12,
        total_margin: 110.16000000000001,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 55,
        total_line: 1088.45,
        total_margin: 132.55,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 2,
        total_line: 66.84,
        total_margin: 8.04,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 127,
        total_line: 1435.1000000000001,
        total_margin: 349.25,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 115,
        total_line: 3415.5,
        total_margin: 95.44999999999999,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 78,
        total_line: 1295.58,
        total_margin: 161.45999999999998,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 131,
        total_line: 3526.5200000000004,
        total_margin: 856.74,
      },
    ],
    total_invoice: 29100.73,
    total_margin: 3210.92,
    region: 'Brazil',
  },
  {
    id: 232,
    customer_id: 33,
    customer_name: 'Jean van Dijk',
    date: '2020-09-20',
    invoice_lines: [
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 78,
        total_line: 3861.7799999999997,
        total_margin: 294.06,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 27,
        total_line: 925.2900000000001,
        total_margin: 121.23,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 51,
        total_line: 1372.92,
        total_margin: 333.54,
      },
    ],
    total_invoice: 6159.99,
    total_margin: 748.83,
    region: 'Brazil',
  },
  {
    id: 233,
    customer_id: 18,
    customer_name: 'Jack Wu',
    date: '2020-01-24',
    invoice_lines: [
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 15,
        total_line: 655.9499999999999,
        total_margin: 150.15,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 72,
        total_line: 1483.92,
        total_margin: 134.64000000000001,
      },
    ],
    total_invoice: 2139.87,
    total_margin: 284.79,
    region: 'India',
  },
  {
    id: 234,
    customer_id: 15,
    customer_name: 'Greg Mohaman',
    date: '2020-12-10',
    invoice_lines: [
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 117,
        total_line: 4470.57,
        total_margin: 1033.11,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 94,
        total_line: 773.62,
        total_margin: 38.54,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 142,
        total_line: 2734.92,
        total_margin: 363.52,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 27,
        total_line: 257.31,
        total_margin: 24.84,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 125,
        total_line: 2700,
        total_margin: 513.75,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 71,
        total_line: 2724.27,
        total_margin: 237.85,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 37,
        total_line: 1637.99,
        total_margin: 61.79,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 42,
        total_line: 697.2,
        total_margin: 16.8,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 94,
        total_line: 1536.9,
        total_margin: 91.17999999999999,
      },
    ],
    total_invoice: 17532.780000000002,
    total_margin: 2381.3799999999997,
    region: 'Brazil',
  },
  {
    id: 235,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-09-21',
    invoice_lines: [
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 71,
        total_line: 3515.21,
        total_margin: 267.67,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 87,
        total_line: 3804.5099999999998,
        total_margin: 870.87,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 76,
        total_line: 2916.12,
        total_margin: 254.6,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 82,
        total_line: 2810.1400000000003,
        total_margin: 368.18,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 76,
        total_line: 2582.4799999999996,
        total_margin: 553.28,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 114,
        total_line: 1370.28,
        total_margin: 265.62,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 134,
        total_line: 2417.3599999999997,
        total_margin: 383.24,
      },
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 111,
        total_line: 1951.3799999999999,
        total_margin: 323.01,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 58,
        total_line: 730.22,
        total_margin: 26.68,
      },
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 83,
        total_line: 683.09,
        total_margin: 34.03,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 113,
        total_line: 3874.77,
        total_margin: 709.64,
      },
    ],
    total_invoice: 26655.56,
    total_margin: 4056.82,
    region: 'Brazil',
  },
  {
    id: 236,
    customer_id: 11,
    customer_name: 'Jean Martins',
    date: '2020-08-05',
    invoice_lines: [
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 130,
        total_line: 4457.7,
        total_margin: 816.4,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 117,
        total_line: 1731.6000000000001,
        total_margin: 92.43,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 141,
        total_line: 4411.89,
        total_margin: 908.0400000000001,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 85,
        total_line: 1168.75,
        total_margin: 155.55,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 14,
        total_line: 123.75999999999999,
        total_margin: 22.68,
      },
      {
        product_id: 56,
        product_name: 'Baking - 2',
        product_category: 'Baking',
        unit_price: 38.37,
        quantity: 26,
        total_line: 997.6199999999999,
        total_margin: 87.10000000000001,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 110,
        total_line: 2632.3,
        total_margin: 135.3,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 8,
        total_line: 274.16,
        total_margin: 35.92,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 122,
        total_line: 1378.6000000000001,
        total_margin: 335.5,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 127,
        total_line: 2311.4,
        total_margin: 64.77,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 66,
        total_line: 2509.98,
        total_margin: 100.98,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 38,
        total_line: 1291.2399999999998,
        total_margin: 276.64,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 67,
        total_line: 843.53,
        total_margin: 30.82,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 4,
        total_line: 49.24,
        total_margin: 10.24,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 89,
        total_line: 4313.83,
        total_margin: 821.47,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 37,
        total_line: 321.15999999999997,
        total_margin: 26.64,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 91,
        total_line: 1511.51,
        total_margin: 188.36999999999998,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 100,
        total_line: 2160,
        total_margin: 411.00000000000006,
      },
    ],
    total_invoice: 32488.269999999997,
    total_margin: 4519.85,
    region: 'Australia',
  },
  {
    id: 237,
    customer_id: 27,
    customer_name: 'Daniels Jackson',
    date: '2020-01-27',
    invoice_lines: [
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 80,
        total_line: 3877.6,
        total_margin: 738.4000000000001,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 16,
        total_line: 265.76,
        total_margin: 33.12,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 4,
        total_line: 126.16,
        total_margin: 2.64,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 101,
        total_line: 3431.9799999999996,
        total_margin: 735.28,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 24,
        total_line: 271.20000000000005,
        total_margin: 66,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 87,
        total_line: 1721.73,
        total_margin: 209.67000000000002,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 57,
        total_line: 1097.8200000000002,
        total_margin: 145.92000000000002,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 36,
        total_line: 981.72,
        total_margin: 236.16,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 37,
        total_line: 119.14,
        total_margin: 9.620000000000001,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 64,
        total_line: 1164.8,
        total_margin: 32.64,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 147,
        total_line: 4599.63,
        total_margin: 946.6800000000001,
      },
    ],
    total_invoice: 17657.539999999997,
    total_margin: 3156.13,
    region: 'Brazil',
  },
  {
    id: 238,
    customer_id: 37,
    customer_name: 'John Wu',
    date: '2020-11-10',
    invoice_lines: [
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 112,
        total_line: 3326.4,
        total_margin: 92.96,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 86,
        total_line: 1857.6000000000001,
        total_margin: 353.46000000000004,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 115,
        total_line: 1880.2500000000002,
        total_margin: 111.55,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 70,
        total_line: 962.5,
        total_margin: 128.1,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 5,
        total_line: 91,
        total_margin: 2.55,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 62,
        total_line: 3005.14,
        total_margin: 572.26,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 42,
        total_line: 621.6,
        total_margin: 33.18,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 8,
        total_line: 190.8,
        total_margin: 45.92,
      },
    ],
    total_invoice: 11935.289999999999,
    total_margin: 1339.9800000000002,
    region: 'USA',
  },
  {
    id: 239,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-06-21',
    invoice_lines: [
      {
        product_id: 2,
        product_name: 'Alcohol - 2',
        product_category: 'Alcohol',
        unit_price: 8.23,
        quantity: 125,
        total_line: 1028.75,
        total_margin: 51.25,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 126,
        total_line: 4318.02,
        total_margin: 565.74,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 143,
        total_line: 4510.22,
        total_margin: 94.38000000000001,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 101,
        total_line: 962.53,
        total_margin: 92.92,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 133,
        total_line: 6022.24,
        total_margin: 598.5,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 111,
        total_line: 2988.1200000000003,
        total_margin: 725.94,
      },
      {
        product_id: 23,
        product_name: 'Meat - 5',
        product_category: 'Meat',
        unit_price: 43.73,
        quantity: 23,
        total_line: 1005.79,
        total_margin: 230.23,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 23,
        total_line: 878.83,
        total_margin: 203.09,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 21,
        total_line: 376.11,
        total_margin: 39.06,
      },
      {
        product_id: 20,
        product_name: 'Meat - 2',
        product_category: 'Meat',
        unit_price: 11.03,
        quantity: 145,
        total_line: 1599.35,
        total_margin: 136.29999999999998,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 77,
        total_line: 1483.0200000000002,
        total_margin: 197.12,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 26,
        total_line: 891.54,
        total_margin: 163.28,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 5,
        total_line: 16.1,
        total_margin: 1.3,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 28,
        total_line: 509.59999999999997,
        total_margin: 14.280000000000001,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 32,
        total_line: 531.52,
        total_margin: 66.24,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 92,
        total_line: 1158.28,
        total_margin: 42.32,
      },
    ],
    total_invoice: 28280.02,
    total_margin: 3221.9500000000007,
    region: 'Australia',
  },
  {
    id: 240,
    customer_id: 35,
    customer_name: 'Daniels Martins',
    date: '2020-04-27',
    invoice_lines: [
      {
        product_id: 4,
        product_name: 'Alcohol - 4',
        product_category: 'Alcohol',
        unit_price: 17.58,
        quantity: 101,
        total_line: 1775.58,
        total_margin: 293.91,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 6,
        total_line: 109.19999999999999,
        total_margin: 3.06,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 78,
        total_line: 1396.98,
        total_margin: 145.08,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 95,
        total_line: 1553.2500000000002,
        total_margin: 92.14999999999999,
      },
      {
        product_id: 13,
        product_name: 'Vegetables - 4',
        product_category: 'Vegetables',
        unit_price: 34.27,
        quantity: 43,
        total_line: 1473.6100000000001,
        total_margin: 193.07000000000002,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 13,
        total_line: 496.73,
        total_margin: 114.79,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 106,
        total_line: 1555.02,
        total_margin: 234.26,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 110,
        total_line: 3771.9,
        total_margin: 690.8000000000001,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 136,
        total_line: 399.84,
        total_margin: 92.48,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 21,
        total_line: 453.6,
        total_margin: 86.31,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 52,
        total_line: 1977.56,
        total_margin: 79.56,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 42,
        total_line: 2079.42,
        total_margin: 158.34,
      },
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 43,
        total_line: 541.37,
        total_margin: 19.78,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 37,
        total_line: 151.32999999999998,
        total_margin: 28.12,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 124,
        total_line: 2058.4,
        total_margin: 49.6,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 105,
        total_line: 2213.3999999999996,
        total_margin: 27.3,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 95,
        total_line: 1169.45,
        total_margin: 243.20000000000002,
      },
    ],
    total_invoice: 23176.640000000003,
    total_margin: 2551.8100000000004,
    region: 'India',
  },
  {
    id: 241,
    customer_id: 19,
    customer_name: 'Trisha Dupuis',
    date: '2020-04-01',
    invoice_lines: [
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 102,
        total_line: 1152.6000000000001,
        total_margin: 280.5,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 18,
        total_line: 563.22,
        total_margin: 115.92,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 4,
        total_line: 59.2,
        total_margin: 3.16,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 18,
        total_line: 159.12,
        total_margin: 29.160000000000004,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 105,
        total_line: 1540.35,
        total_margin: 232.04999999999998,
      },
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 107,
        total_line: 4070.2799999999997,
        total_margin: 731.88,
      },
      {
        product_id: 22,
        product_name: 'Meat - 4',
        product_category: 'Meat',
        unit_price: 21.6,
        quantity: 143,
        total_line: 3088.8,
        total_margin: 587.73,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 86,
        total_line: 1656.3600000000001,
        total_margin: 220.16,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 55,
        total_line: 756.25,
        total_margin: 100.65,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 92,
        total_line: 2590.72,
        total_margin: 107.63999999999999,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 21,
        total_line: 348.81,
        total_margin: 43.47,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 94,
        total_line: 1157.14,
        total_margin: 240.64000000000001,
      },
    ],
    total_invoice: 17142.85,
    total_margin: 2692.9599999999996,
    region: 'Europe',
  },
  {
    id: 242,
    customer_id: 34,
    customer_name: 'Mike Martins',
    date: '2020-08-09',
    invoice_lines: [
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 134,
        total_line: 2824.72,
        total_margin: 34.84,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 80,
        total_line: 3056.8,
        total_margin: 706.4,
      },
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 71,
        total_line: 1936.17,
        total_margin: 465.76,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 36,
        total_line: 693.36,
        total_margin: 92.16,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 25,
        total_line: 366.75,
        total_margin: 55.25,
      },
      {
        product_id: 61,
        product_name: 'Baking - 7',
        product_category: 'Baking',
        unit_price: 38.03,
        quantity: 115,
        total_line: 4373.45,
        total_margin: 175.95000000000002,
      },
      {
        product_id: 48,
        product_name: 'Tobacco - 3',
        product_category: 'Tobacco',
        unit_price: 3.22,
        quantity: 90,
        total_line: 289.8,
        total_margin: 23.400000000000002,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 4,
        total_line: 71.64,
        total_margin: 7.44,
      },
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 120,
        total_line: 2374.7999999999997,
        total_margin: 289.20000000000005,
      },
      {
        product_id: 32,
        product_name: 'Fish - 5',
        product_category: 'Fish',
        unit_price: 45.28,
        quantity: 14,
        total_line: 633.9200000000001,
        total_margin: 63,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 25,
        total_line: 598.25,
        total_margin: 30.75,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 143,
        total_line: 2338.05,
        total_margin: 138.71,
      },
      {
        product_id: 1,
        product_name: 'Alcohol - 1',
        product_category: 'Alcohol',
        unit_price: 23.85,
        quantity: 92,
        total_line: 2194.2000000000003,
        total_margin: 528.08,
      },
      {
        product_id: 46,
        product_name: 'Tobacco - 1',
        product_category: 'Tobacco',
        unit_price: 26.92,
        quantity: 142,
        total_line: 3822.6400000000003,
        total_margin: 928.68,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 7,
        total_line: 144.26999999999998,
        total_margin: 13.09,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 61,
        total_line: 1811.7,
        total_margin: 50.629999999999995,
      },
      {
        product_id: 21,
        product_name: 'Meat - 3',
        product_category: 'Meat',
        unit_price: 16.61,
        quantity: 36,
        total_line: 597.96,
        total_margin: 74.52,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 77,
        total_line: 2573.34,
        total_margin: 309.53999999999996,
      },
    ],
    total_invoice: 30701.819999999996,
    total_margin: 3987.4,
    region: 'Europe',
  },
  {
    id: 243,
    customer_id: 39,
    customer_name: 'John Del Piero',
    date: '2020-05-22',
    invoice_lines: [
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 138,
        total_line: 2844.18,
        total_margin: 258.06,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 45,
        total_line: 132.3,
        total_margin: 30.6,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 56,
        total_line: 828.8000000000001,
        total_margin: 44.24,
      },
      {
        product_id: 73,
        product_name: 'Snacks - 1',
        product_category: 'Snacks',
        unit_price: 14.67,
        quantity: 140,
        total_line: 2053.8,
        total_margin: 309.4,
      },
      {
        product_id: 66,
        product_name: 'Cheese - 3',
        product_category: 'Cheese',
        unit_price: 44.27,
        quantity: 113,
        total_line: 5002.51,
        total_margin: 188.70999999999998,
      },
    ],
    total_invoice: 10861.59,
    total_margin: 831.01,
    region: 'India',
  },
  {
    id: 244,
    customer_id: 17,
    customer_name: 'Saidi Martins',
    date: '2020-04-22',
    invoice_lines: [
      {
        product_id: 57,
        product_name: 'Baking - 3',
        product_category: 'Baking',
        unit_price: 27.27,
        quantity: 12,
        total_line: 327.24,
        total_margin: 78.72,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 61,
        total_line: 2072.7799999999997,
        total_margin: 444.08000000000004,
      },
    ],
    total_invoice: 2400.0199999999995,
    total_margin: 522.8000000000001,
    region: 'Brazil',
  },
  {
    id: 245,
    customer_id: 1,
    customer_name: 'Magda Muijs',
    date: '2020-07-25',
    invoice_lines: [
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 93,
        total_line: 2933.22,
        total_margin: 61.38,
      },
      {
        product_id: 50,
        product_name: 'Tobacco - 5',
        product_category: 'Tobacco',
        unit_price: 48.47,
        quantity: 130,
        total_line: 6301.099999999999,
        total_margin: 1199.9,
      },
    ],
    total_invoice: 9234.32,
    total_margin: 1261.2800000000002,
    region: 'Europe',
  },
  {
    id: 246,
    customer_id: 8,
    customer_name: 'Tim Jackson',
    date: '2020-07-07',
    invoice_lines: [
      {
        product_id: 74,
        product_name: 'Snacks - 2',
        product_category: 'Snacks',
        unit_price: 12.59,
        quantity: 140,
        total_line: 1762.6,
        total_margin: 64.4,
      },
      {
        product_id: 42,
        product_name: 'Soft drinks - 6',
        product_category: 'Soft drinks',
        unit_price: 12.31,
        quantity: 133,
        total_line: 1637.23,
        total_margin: 340.48,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 119,
        total_line: 4291.14,
        total_margin: 489.09000000000003,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 51,
        total_line: 1704.42,
        total_margin: 205.01999999999998,
      },
      {
        product_id: 49,
        product_name: 'Tobacco - 4',
        product_category: 'Tobacco',
        unit_price: 2.94,
        quantity: 103,
        total_line: 302.82,
        total_margin: 70.04,
      },
      {
        product_id: 30,
        product_name: 'Fish - 3',
        product_category: 'Fish',
        unit_price: 31.54,
        quantity: 126,
        total_line: 3974.04,
        total_margin: 83.16000000000001,
      },
      {
        product_id: 40,
        product_name: 'Soft drinks - 4',
        product_category: 'Soft drinks',
        unit_price: 34.29,
        quantity: 103,
        total_line: 3531.87,
        total_margin: 646.84,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 92,
        total_line: 2878.68,
        total_margin: 592.48,
      },
      {
        product_id: 43,
        product_name: 'Soft drinks - 7',
        product_category: 'Soft drinks',
        unit_price: 18.04,
        quantity: 144,
        total_line: 2597.7599999999998,
        total_margin: 411.84,
      },
      {
        product_id: 12,
        product_name: 'Vegetables - 3',
        product_category: 'Vegetables',
        unit_price: 17.91,
        quantity: 34,
        total_line: 608.94,
        total_margin: 63.24,
      },
      {
        product_id: 64,
        product_name: 'Cheese - 1',
        product_category: 'Cheese',
        unit_price: 11.3,
        quantity: 21,
        total_line: 237.3,
        total_margin: 57.75,
      },
      {
        product_id: 47,
        product_name: 'Tobacco - 2',
        product_category: 'Tobacco',
        unit_price: 12.02,
        quantity: 86,
        total_line: 1033.72,
        total_margin: 200.38,
      },
    ],
    total_invoice: 24560.519999999997,
    total_margin: 3224.7200000000003,
    region: 'USA',
  },
  {
    id: 247,
    customer_id: 7,
    customer_name: 'Jean Cook',
    date: '2020-10-02',
    invoice_lines: [
      {
        product_id: 60,
        product_name: 'Baking - 6',
        product_category: 'Baking',
        unit_price: 38.04,
        quantity: 133,
        total_line: 5059.32,
        total_margin: 909.72,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 41,
        total_line: 845.01,
        total_margin: 76.67,
      },
      {
        product_id: 37,
        product_name: 'Soft drinks - 1',
        product_category: 'Soft drinks',
        unit_price: 33.42,
        quantity: 132,
        total_line: 4411.4400000000005,
        total_margin: 530.64,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 68,
        total_line: 1627.24,
        total_margin: 83.64,
      },
      {
        product_id: 29,
        product_name: 'Fish - 2',
        product_category: 'Fish',
        unit_price: 31.29,
        quantity: 101,
        total_line: 3160.29,
        total_margin: 650.44,
      },
    ],
    total_invoice: 15103.3,
    total_margin: 2251.11,
    region: 'USA',
  },
  {
    id: 248,
    customer_id: 10,
    customer_name: 'Daniels van Dijk',
    date: '2020-12-19',
    invoice_lines: [
      {
        product_id: 14,
        product_name: 'Vegetables - 5',
        product_category: 'Vegetables',
        unit_price: 19.79,
        quantity: 28,
        total_line: 554.12,
        total_margin: 67.48,
      },
      {
        product_id: 39,
        product_name: 'Soft drinks - 3',
        product_category: 'Soft drinks',
        unit_price: 8.68,
        quantity: 149,
        total_line: 1293.32,
        total_margin: 107.28,
      },
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 126,
        total_line: 1732.5,
        total_margin: 230.58,
      },
      {
        product_id: 11,
        product_name: 'Vegetables - 2',
        product_category: 'Vegetables',
        unit_price: 21.08,
        quantity: 99,
        total_line: 2086.9199999999996,
        total_margin: 25.740000000000002,
      },
      {
        product_id: 10,
        product_name: 'Vegetables - 1',
        product_category: 'Vegetables',
        unit_price: 18.2,
        quantity: 38,
        total_line: 691.6,
        total_margin: 19.38,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 123,
        total_line: 1820.4,
        total_margin: 97.17,
      },
      {
        product_id: 77,
        product_name: 'Snacks - 5',
        product_category: 'Snacks',
        unit_price: 16.6,
        quantity: 129,
        total_line: 2141.4,
        total_margin: 51.6,
      },
      {
        product_id: 52,
        product_name: 'Tobacco - 7',
        product_category: 'Tobacco',
        unit_price: 23.93,
        quantity: 97,
        total_line: 2321.21,
        total_margin: 119.31,
      },
      {
        product_id: 65,
        product_name: 'Cheese - 2',
        product_category: 'Cheese',
        unit_price: 28.16,
        quantity: 117,
        total_line: 3294.72,
        total_margin: 136.89,
      },
      {
        product_id: 76,
        product_name: 'Snacks - 4',
        product_category: 'Snacks',
        unit_price: 4.09,
        quantity: 53,
        total_line: 216.76999999999998,
        total_margin: 40.28,
      },
      {
        product_id: 28,
        product_name: 'Fish - 1',
        product_category: 'Fish',
        unit_price: 49.51,
        quantity: 130,
        total_line: 6436.3,
        total_margin: 490.1,
      },
      {
        product_id: 67,
        product_name: 'Cheese - 4',
        product_category: 'Cheese',
        unit_price: 8.84,
        quantity: 96,
        total_line: 848.64,
        total_margin: 155.52,
      },
      {
        product_id: 38,
        product_name: 'Soft drinks - 2',
        product_category: 'Soft drinks',
        unit_price: 20.61,
        quantity: 111,
        total_line: 2287.71,
        total_margin: 207.57000000000002,
      },
      {
        product_id: 41,
        product_name: 'Soft drinks - 5',
        product_category: 'Soft drinks',
        unit_price: 16.35,
        quantity: 106,
        total_line: 1733.1000000000001,
        total_margin: 102.82,
      },
      {
        product_id: 3,
        product_name: 'Alcohol - 3',
        product_category: 'Alcohol',
        unit_price: 38.21,
        quantity: 16,
        total_line: 611.36,
        total_margin: 141.28,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 120,
        total_line: 4077.5999999999995,
        total_margin: 873.6,
      },
      {
        product_id: 58,
        product_name: 'Baking - 4',
        product_category: 'Baking',
        unit_price: 29.7,
        quantity: 24,
        total_line: 712.8,
        total_margin: 19.919999999999998,
      },
      {
        product_id: 44,
        product_name: 'Soft drinks - 8',
        product_category: 'Soft drinks',
        unit_price: 36.06,
        quantity: 131,
        total_line: 4723.860000000001,
        total_margin: 538.4100000000001,
      },
    ],
    total_invoice: 37584.33,
    total_margin: 3424.9300000000003,
    region: 'Europe',
  },
  {
    id: 249,
    customer_id: 11,
    customer_name: 'Jean Martins',
    date: '2020-12-23',
    invoice_lines: [
      {
        product_id: 31,
        product_name: 'Fish - 4',
        product_category: 'Fish',
        unit_price: 13.75,
        quantity: 138,
        total_line: 1897.5,
        total_margin: 252.54000000000002,
      },
      {
        product_id: 75,
        product_name: 'Snacks - 3',
        product_category: 'Snacks',
        unit_price: 19.26,
        quantity: 77,
        total_line: 1483.0200000000002,
        total_margin: 197.12,
      },
      {
        product_id: 51,
        product_name: 'Tobacco - 6',
        product_category: 'Tobacco',
        unit_price: 9.53,
        quantity: 1,
        total_line: 9.53,
        total_margin: 0.92,
      },
      {
        product_id: 19,
        product_name: 'Meat - 1',
        product_category: 'Meat',
        unit_price: 14.8,
        quantity: 47,
        total_line: 695.6,
        total_margin: 37.13,
      },
      {
        product_id: 55,
        product_name: 'Baking - 1',
        product_category: 'Baking',
        unit_price: 33.98,
        quantity: 109,
        total_line: 3703.8199999999997,
        total_margin: 793.52,
      },
    ],
    total_invoice: 7789.47,
    total_margin: 1281.23,
    region: 'Australia',
  },
];
